import React, { useEffect, useState } from "react";
import { GoGlobe, GoSearch } from "react-icons/go";
import { Button, Placeholder, Spinner, Tab, Tabs } from 'react-bootstrap';
import { Stack, Table, Modal } from 'react-bootstrap'
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FiPlusCircle, FiMinusCircle } from "react-icons/fi";
import { format, set } from 'date-fns';
import {
    GET_ALL_INVOICES_ERROR, SET_PAGINATION_COUNT_TO,
    REGENERATE_INVOICE_DATA_SUCCESS, handlePaginationLoaderTrue,
    getAllInvoices, getAllPartnerCompanies,
    putInvoiceData, PUT_INVOICE_DATA_SUCCESS,
    regenerateAnInvoice, commercialHeadGetBillingEntities,
    commercialHeadGetCompleteContractsForDropdown,
    handleDocumentLoaderTrue, commercialHeadUploadDocument,
    createNewMiscInvoice, PUT_ADD_MISC_INVOICE_SUCCESS,
    PUT_ADD_MISC_INVOICE_FAILURE, submitToGSTSubmissionPortal,
    sendToCustomerAsEmail, PUT_GST_SUBMIT_SUCCESS,
    editAMiscInvoice, PUT_EDIT_MISC_INVOICE_SUCCESS,
    CONTRACT_API_LOADER_TRIGGER_TRUE, commercialHeadGetAllFacilitiesForNav,
    getAllServices,
    createNewCreditNote,
    handleDocumentLoaderFalse
} from "../../Redux/Actions/Actions";
import { useDispatch, useSelector } from "react-redux";
import FormLoader from "../Reusable_Components/FromLoader";
import { MdErrorOutline, MdHistory } from "react-icons/md";
import Pagination from "../Reusable_Components/Pagination";
import NavBarTop from '../Reusable_Components/NavBarTop'
import LeftNavBar from '../Reusable_Components/LeftNavBar'
import axios from "../../axios-interceptor"
import AlertPopUp from "../Reusable_Components/Alert";
import { base_url } from "../../utilities";
import { ACLS, CEO_GROUP, COMMERCIAL_HEAD_GROUP, FACILITY_MANAGER_GROUP, FINANCE_MANAGER_GROUP, PORTOS_CUSTOMER_GROUP, RECORDS_PER_PAGE, TECHNICIAN_GROUP } from "../../Config";
import PdfViewer from "../Reusable_Components/pdfviewer";
import {
    formatCurrencyBasedOnRegion, formatToIndianRupee,
    convertCurrencyToWords, timeElapsed, validateValue,
    formatNumericInput, limitCurrencyAmount,
    formatDateBasedOnValue,
    toTitleCase
} from "../Reusable_Components/ReusableFunctions";
import QRCode from "react-qr-code";
import { formatDateView } from "../Reusable_Components/ReusableFunctions";
import Footer from '../Login/Footer';
import UploadComponent from "../Reusable_Components/UploadComponent";
import Select from 'react-select';
import { useNavigate } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useLocation } from "react-router-dom";
import { FaFilter, FaSort } from 'react-icons/fa';
import { BsCurrencyRupee } from "react-icons/bs";
import SearchableDropdown from '../Reusable_Components/SearchableDropdown';
import JSZip from "jszip";
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import Dropdown from 'react-bootstrap/Dropdown';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Drawer from 'react-modern-drawer'
import Chip from "@mui/material/Chip";
// import Stack from "@mui/material/Stack";
// import Button from "@mui/material/Button";

//import styles 👇
import 'react-modern-drawer/dist/index.css'
import { PiExportBold } from "react-icons/pi";
import MultiMonthSelect from "../Reusable_Components/MultiMonthSelect";
import TableComponent from "../Reusable_Components/TableComponent";



import { FaCheckCircle, FaFileInvoice, FaMoneyBill } from "react-icons/fa";
import { IoMdCloseCircle, IoMdInformationCircleOutline } from "react-icons/io";


export const SET_LOADER = "SET_LOADER"



const FinanceManagerInvoice = () => {


    const navigate = useNavigate()
    const location = useLocation()
    const { props } = location.state || {};
    const [creditNoteList, setCreditNoteList] = useState([])
    const [debitNoteList, setDebitNoteList] = useState([])

    useEffect(() => {
        dispatch(getAllServices())
    }, [])

    useEffect(() => {
        const details = props?.details
        if (details) {
            handleViewButton(details?.invoice_number, details?.status, details?.invoice_type)
        }
    }, [props])

    const servicesForDropdown = useSelector((state) => state.servicesList);
    const getGroupNameOriginal = (val) => {
        switch (val) {
            case "Commercial Head":
                return COMMERCIAL_HEAD_GROUP;
            case "Technician":
                return TECHNICIAN_GROUP;
            case "Finance Manager":
                return FINANCE_MANAGER_GROUP;
            case "Facility Manager":
                return FACILITY_MANAGER_GROUP;
            case "CEO":
                return CEO_GROUP;
            case "Customer":
                return PORTOS_CUSTOMER_GROUP;
            default:
                return "";
        }
    }
    const isManage = ACLS[getGroupNameOriginal(localStorage.getItem('group'))].find(obj => obj.ROUTE === "/financeManagerInvoices" && obj.PERMISSIONS?.includes("MANAGE"));

    const [sample, setSample] = useState()
    const [totalInvoices, setTotalInvoices] = useState()
    const [invoiceSelected, setinvoiceSelected] = useState('')
    const [searchText, setSearchText] = useState("")
    const [asc, setAsC] = useState(false);
    const [desc, setDesc] = useState(false);
    const [filteredData, setFilteredData] = useState("")
    const [invoiceType, setInvoiceType] = useState(isManage ? "all" : "emailed")
    const [igstToggle, setIgstToggle] = useState(false)
    const [paymentToggle, setPaymentToggle] = useState(false)
    const [termsToggle, setTermsToggle] = useState(false)
    const [userNotesToggle, setUserNotesToggle] = useState(false)
    const [biilingPeriodFilter, setBillingPeriodFilter] = useState(new Date())

    const [currentPage, setCurrentPage] = useState(1)
    const [invoicePage, setInvoicePage] = useState(false)
    const [invoiceTableData, setInvoiceTableData] = useState([])
    const [currentTime, setCurrentTime] = useState(new Date())
    const [invoiceStatus, setInvoiceStatus] = useState([])
    const [preview, setPreview] = useState(false)
    const [miscDueDate, setMiscDueDate] = useState("")
    const [miscService, setMiscService] = useState("")
    const [miscDescription, setMiscDescription] = useState("")
    const [miscBasicAmount, setMiscBasicAmount] = useState(0)
    const [miscIgst, setMiscIgst] = useState(18);
    const [miscCsgtSgst, setMiscCgstSgst] = useState(9)
    const [slfShow, setSlfShow] = useState(false);
    const [userNotes, setUserNotes] = useState("")
    const [userNotesError, setUserNotesError] = useState("")
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(5)

    const dispatch = useDispatch()
    const invoicesList = useSelector(state => state.invoicesList?.data)
    const invoicesListError = useSelector(state => state.invoicesListError)
    const [invoiceListErrorFlag, setInvoiceListErrorFlag] = useState(false)
    const loading = useSelector(state => state.loading)
    const paginationCount = useSelector(state => state.paginationCount)
    const editInvoiceSubmisssion = useSelector(state => state.editInvoiceSubmisssion)
    const partnerCompaniesList = useSelector(state => state.partnerCompaniesList)
    const partnerCompaniesListError = useSelector(state => state.partnerCompaniesListError)
    const generateInvoiceStatus = useSelector(state => state.generateInvoiceStatus)
    const gstsubmmisiondata = useSelector(state => state.gstsubmmisiondata)
    const error = useSelector(state => state.error)
    const [isLoading, setIsLoading] = useState(false)
    const [facilityName, setFacilityName] = useState('')

    const handleClose = () => setSlfShow(false);
    const handleShow = () => setSlfShow(true);
    const [sortOrder, setSortOrder] = useState(false);

    //invoice data fields
    const [companyName, setCompanyName] = useState("")
    const [companyAddress, setCompanyAddress] = useState("")
    const [companyCIN, setCompanyCIN] = useState("")
    const [companyGST, setCompanyGST] = useState("")
    const [companyPhone, setCompanyPhone] = useState("")
    const [invoiceDetails, setInvoiceDetails] = useState([])
    const [companyLogo, setCompanyLogo] = useState("")
    const [contractNo, setContractNo] = useState("")
    const [customerName, setcustomerName] = useState("")
    const [customerAddress, setcustomerAddress] = useState("")
    const [customerStateCode, setcustomerStateCode] = useState("")
    const [customerGSTIN, setcustomerGSTIN] = useState("")
    const [customerCIN, setcustomerCIN] = useState("")
    const [customerPlaceOfSupply, setcustomerPlaceOfSupply] = useState("")
    const [customerPAN, setcustomerPAN] = useState("")
    const [IRN, setIRN] = useState("")
    const [ackNo, setAckNo] = useState("")
    const [ackDate, setAckDate] = useState("")
    const [invoiceNo, setInvoiceNo] = useState("")
    const [parnterState, setPartnerState] = useState("")
    const [partnerStateCode, setPartnerStateCode] = useState("")
    const [partnerPAN, setPartnerPAN] = useState("")
    const [partnerCIN, setPartnerCIN] = useState("")
    const [partnerBillDate, setPartnerBillDate] = useState("")
    const [shippingAddress, setShippingAddress] = useState('')
    const [partnerDueDate, setPartnerDueDate] = useState("")
    const [basicAmount, setBasicAmount] = useState(0)
    const [totalSgst, setTotalSgst] = useState(0)
    const [totalIgst, setTotalIgst] = useState(0)
    const [totalCgst, setTotalCgst] = useState(0)
    const [TotalAmount, setTotalAmount] = useState(0)
    const [totalAmountInWords, setTotalAmountInWords] = useState('');
    //for alert pop up
    const [alertShow, setAlertShow] = useState(false)
    const [alertType, setAlertType] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const [alertValue, setAlertValue] = useState('')
    const [alertButtons, setAlertButtons] = useState([])
    const [alertAction, setAlertAction] = useState([])
    //edit invoice data
    const [streetAddress, setStreetAddress] = useState("")
    const [city, setCity] = useState("")
    const [state, setState] = useState("")
    const [pincode, setPincode] = useState("")
    const [toggleShippingAddress, setToggleShippingAddress] = useState(false)
    const [approvalType, setApprovalType] = useState("")
    const [listOfPartnerCompanies, setListOfPartnerCompanies] = useState([])
    const [pdfDataForPayments, setpdfDataForPayments] = useState(null);
    const [pdfDataForTerms, setpdfDataForTerms] = useState(null);
    const totalRecordsAc = useSelector((state) => state.invoicesList?.info?.total_no_of_records);
    const currentPaginationPageAc = useSelector((state) => state.invoicesList?.info?.page_number);
    const [shippingAddressToggle, setShippingAddressToggle] = useState(false)
    const [shippingCompanyName, setShippingCompanyName] = useState('');
    const [shippingCompanyAddress, setShippingCompanyAddress] = useState('');
    const [QrCode, setQrCode] = useState('');
    const [invoiceStatusTo, setInvoiceStatusTo] = useState('')
    const [invoiceId, setInvoiceId] = useState('')
    const [slfInvoiceName, setSlfInvoiceName] = useState('')
    const [rejectReason, setRejectReason] = useState('')
    const [rejectReasonError, setRejectReasonError] = useState('')
    const [rejectModal, setRejectModal] = useState(false)
    const [showComputationDetails, setShowComputationDetails] = useState(false) //has to be changes to false when backend is updated
    const [showBillingPeriod, setShowBillingPeriod] = useState(false)
    const [showPaymentDetails, setShowPaymentDetails] = useState(false) //has to be changes to false when backend is updated
    const [showTermsDetails, setShowTermsDetails] = useState(false) //has to be changes to false when backend is updated
    const [downloadPath, setDownloadPath] = useState('')
    const [selectedInvoiceType, setSelectedInvoiceType] = useState('Draft')

    const [billingMonthFilter, setBillingMonthFilter] = useState(dayjs().month() + 1);
    const [billingYearFilter, setBillingYearFilter] = useState(dayjs().year());
    //circle progress bar for donwload zip
    const [downloadProgress, setDownloadProgress] = useState(0);
    const [showDownloadProgress, setShowDownloadProgress] = useState(false);
    const [selectedFacilityFilter, setSelectedFacilityFilter] = useState("");
    const [selectedCustomerFilter, setSelectedCustomerFilter] = useState('');
    const [selectedInvoiceSelectedFilter, setSelectedInvoiceSelectedFilter] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState('');
    const [selectedStatusFilter, setSelectedStatusFilter] = useState('all');
    const [selectedPaymentFilter, setSelectedPaymentFilter] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('all');
    const monthNumber = dayjs().month();
    const yearNumber = dayjs().year();

    const [periods, setPeriods] = useState([{ month: monthNumber, year: yearNumber }]);
    const [periodsFilter, setPeriodsFilter] = useState([{ month: monthNumber, year: yearNumber }]);

    const [companyList, setCompanyList] = useState([])
    const [selectedPaymentStatus, setSelectedPaymentStatus] = useState('');
    const [showSummary, setShowSummary] = useState(false);
    const paymentTypes = [{
        label: 'Due',
        value: 'due'
    },
    {
        label: "Partially Paid",
        value: "partiallypaid"

    },
    {
        label: "Fully Paid",
        value: "fullypaid"
    }
    ]

    useEffect(() => {
        getAllCompanies()
    }, [])

    const getAllCompanies = () => {
        axios.get(base_url + "customers", {
            params: {
                request_type: "dropdown",
            }
        })
            .then((response) => {
                if (response?.data?.data[0] === 'error') {
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(response?.data?.data[1].message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                            }
                        },
                    ])
                } else {
                    setCompanyList(response?.data?.data);
                }
            })
            .catch((error) => {
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                    }
                }])
            });

    }


    const [isOpen, setIsOpen] = React.useState(false)
    const toggleDrawer = () => {
        setIsOpen((prevState) => !prevState)
    }

    const toggleInvoiceDrawer = () => {
        setShowInvoiceHistory((prevState) => !prevState)
    }

    useEffect(() => {
        dispatch(commercialHeadGetAllFacilitiesForNav())
    }, [dispatch])


    const handleDelete = (chipToDelete) => {
        const monthNumber = dayjs().month() + 1;
        const fullYear = dayjs().year();
        const currentMonth = dayjs().month();
        if (chipToDelete === "customer") {
            setSelectedCustomer("")
            setSelectedCustomerFilter("")
        }
        if (chipToDelete === "invoice Selected") {
            setinvoiceSelected("")
            setSelectedInvoiceSelectedFilter("")
        }
        if (chipToDelete === "billing period") {
            setPeriodsFilter([
                {
                    month: currentMonth,
                    year: fullYear
                }
            ])
            setPeriods([{
                month: currentMonth,
                year: fullYear
            }])

        }
        if (chipToDelete === "payment status") {
            setSelectedPaymentStatus("")
            setSelectedPaymentFilter("")

        }
        dispatch(getAllInvoices({
            page: 1 && 1, limit: RECORDS_PER_PAGE, facility_id: selectedFacilityId, invoiceType, searchText,
            invoiceSelected: chipToDelete === "invoice Selected" ? "" : invoiceSelected
            , periods: chipToDelete === "billing period" ?
                [{
                    month: currentMonth,
                    year: fullYear
                }] :
                periods,
            selectedCustomer: chipToDelete === "customer" ? "" : selectedCustomer,
            paymentStatus: chipToDelete === "payment status" ? "" : selectedPaymentStatus
        }))

    };

    const clearAll = () => {
        const monthNumber = dayjs().month() + 1;
        const fullYear = dayjs().year();
        const currentMonth = dayjs().month();

        setInvoiceType("all")
        setSelectedStatus("all");
        setSelectedStatusFilter("all");
        setSelectedCustomer("")
        setSelectedCustomerFilter("")
        setPeriodsFilter([
            {
                month: currentMonth,
                year: fullYear
            }
        ])
        setPeriods([{
            month: currentMonth,
            year: fullYear
        }])
        dispatch(getAllInvoices({ page: 1 && 1, limit: RECORDS_PER_PAGE, facility_id: selectedFacilityId, searchText, invoiceSelected, periods, selectedCustomer }))
    };

    const invoiceTypeOptions = [
        { label: 'Invoice', value: 1 },
        { label: 'Credit Note', value: 2 },
        { label: 'Debit Note', value: 3 },
    ]

    const [creditOptionPreview, setCreditOptionPreview] = useState(true)
    const [selectedInvoiceTab, setSelectedInvoiceTab] = useState(1)
    const [showInvoiceHistory, setShowInvoiceHistory] = useState(false)
    const [invoicePaymentDetails, setInvoicePaymentDetails] = useState(null)
    const [debitDummyRecords, setdebitDummyRecords] = useState([
        {
            db_number: 'DN-00001',
            amount: 52000,
            status: "GST Submitted",
            created_at: '19 October 2025',
            created_by: 'Avinash',
            updated_at: '21 October 2025',
            updated_by: 'Anvesh'
        }
    ])

    const invoiceHistoryEvents = [
        {
            user: "Avinash",
            time: "11/10/2025 4:35 PM",
            text: "Payment of ₹20,000.00 received",
            history_type: "created",
            icon_type: "payment",
        },
        {
            user: "Avinash",
            time: "11/10/2025 2:35 PM",
            text: "Credit note CN-0001 created from Invoice.",
            icon_type: "creditAndDebit",
            history_type: "created",
        },
        {
            user: "Avinash",
            time: "11/10/2025 2:35 PM",
            text: "Debit note DN-0001 created from Invoice.",
            icon_type: "creditAndDebit",
            history_type: "created",
        },
        {
            user: "Avinash",
            time: "01/09/2025 2:35 PM",
            text: "Invoice Submitted to GST",
            icon_type: "invoice",
            history_type: "updated",
        },
        {
            user: "Amit Ahuja",
            time: "01/09/2025 2:35 PM",
            text: "Approved Invoice",
            icon_type: "invoice",
            history_type: "updated",
        },
        {
            user: "Avinash",
            time: "01/09/2025 2:35 PM",
            text: "Invoice sent to approval",
            icon_type: "invoice",
            history_type: "updated",
        },
        {
            user: "Avinash",
            time: "01/09/2025 2:35 PM",
            text: "Electricity - Tax Invoice created for ₹2,20,774.19",
            icon_type: "invoice",
            history_type: "created",
        },
    ];



    const dummyListOfContacts = [
        {
            name: "Rahul Deshpande",
            designation: "CEO",
            sendEmail: true
        }
        ,
        {
            name: "Mrinal",
            designation: "Manager",
            sendEmail: true
        }
        ,
        {
            name: "Ankita Agarwal",
            designation: "Manager",
            sendEmail: true
        }
        ,
        {
            name: "Rahul Sharma",
            designation: "Accountant",
            sendEmail: true
        }
        ,
    ]

    const taxPercentageOptions = [0, 5, 12, 18, 28]
    //for misc invoice generation
    const [miscInvoiceTable, setMiscInvoiceTable] = useState([{
        service: "", hsn: "", hsnError: false, hsnLoader: false, hsnMsg: '', basicAmount: 0.0, cgst: 9.0, sgst: 9.0, igst: 18.0, gross: 0.0
        , from_date: "", to_date: "", consumption: 0.0, rate_per_unit: 0.0
    }])
    const [miscListOfContacts, setMiscListOfContacts] = useState([])
    const billingEntities = useSelector((state) => state.billingEntities);
    const contractsForDropdown = useSelector((state) => state.contractsForDropdown);
    const contractApiLoader = useSelector((state) => state.contractApiLoader);
    const facilitiesListForNav = useSelector((state) => state.facilitiesListForNav);
    const newInvoiceNumber = useSelector((state) => state.newInvoiceNumber);
    const [miscIgstOptions, setMiscIgstOptions] = useState([...taxPercentageOptions])
    const [contractsDropdown, setContractsDropdown] = useState([])
    const [billingEntityDropdown, setBillingEntityDropdown] = useState(null)
    const [billingEntityOptions, setBillingEntityOptions] = useState([])
    const [miscPlaceOfSupply, setMiscPlaceOfSupply] = useState(null);
    const [miscContractName, setMiscContractName] = useState(null)
    const [editMiscInvoiceClicked, setEditMiscInvoiceClicked] = useState(false)
    const [miscInvoiceServiceIntifier, setMiscInvoiceServiceIntifier] = useState('')
    const [miscSelectedContacts, setMiscSelectedContacts] = useState(true)
    const [uploadedFiles, setUploadedFiles] = useState();
    const [miscTotalBasicAmount, setMiscTotalBasicAmount] = useState(0.0)
    const [miscTotalTaxAmount, setMiscTotalTaxAmount] = useState(0.0)
    const [miscShowBilling, setMiscShowBilling] = useState(false)
    const [miscShowComputations, setMiscShowComputations] = useState(false)
    const [miscCgstSgstOptions, setMiscCgstSgstOptions] = useState(() => {
        const options = []
        taxPercentageOptions.forEach(each => {
            options.push(parseFloat(each / 2))
        })
        return options
    })

    const handleEditMiscInvoice = () => {
        setEditMiscInvoiceClicked(true)
        dispatch(commercialHeadGetBillingEntities())
        dispatch(commercialHeadGetCompleteContractsForDropdown(localStorage.getItem('selected_facility_id')))

        const tableData = invoiceDetails.map(each => {
            setMiscInvoiceServiceIntifier(each.service_identifier)
            return {
                service: each.service_name_in_invoice,
                hsn: each.hsn,
                basicAmount: each.net_amount,
                cgst: parseFloat(each.cgst_rate),
                sgst: parseFloat(each.sgst_rate),
                igst: parseFloat(each.igst_rate),
                consumption: each.consumption,
                rate_per_unit: each.rate_per_unit,
                from_date: each.from_date,
                to_date: each.to_date,
                gross: each.net_amount + (each.net_amount / 100) * (each.cgst_rate + each.sgst_rate)
            }
        })
        setMiscInvoiceTable([...tableData])
        // setMiscTotalTaxAmount(totalTaxAmount)
        const invoiceTable = [...tableData]
        let totalTaxAmount = 0
        if (igstToggle) {
            totalTaxAmount = invoiceTable.reduce((acc, each) => acc + parseFloat(each.basicAmount / 100) * (parseFloat(each.igst)), 0)
        }
        else {
            totalTaxAmount = invoiceTable.reduce((acc, each) => acc + parseFloat(each.basicAmount / 100) * (parseFloat(each.cgst) + parseFloat(each.sgst)), 0)
        }
        // setMiscShowBilling(in)
        setMiscTotalTaxAmount(totalTaxAmount)
        setMiscTotalBasicAmount(basicAmount)
        setCurrentPage(3)
    }

    useEffect(() => {
        if (contractsForDropdown) {
            const contracts = contractsForDropdown.map((each) => {
                return {
                    label: each.contract_name,
                    value: each.contract_id + ',' + each.contract_type
                }
            })
            setContractsDropdown(contracts)
            if (editMiscInvoiceClicked) {
                const contract = contractsForDropdown.find(each => each.contract_number === contractNo)
                setMiscContractName({
                    label: contract?.contract_name,
                    value: contract?.contract_id + ',' + contract?.contract_type
                })
                getContractDetails(contract?.contract_id + ',' + contract?.contract_type)
                // const placeOfSupply = stateOptions?.find(each => each.value === customerPlaceOfSupply)
                const placeOfSupply = {
                    label: customerPlaceOfSupply,
                    value: customerPlaceOfSupply
                }
                setMiscPlaceOfSupply(placeOfSupply)
            }
        }
    }, [contractsForDropdown])

    useEffect(() => {
        // success message for gst submission
        if (gstsubmmisiondata) {
            setAlertShow(true)
            setAlertType('success')
            setAlertMessage('Success')
            setAlertValue(<>
                <p className="mb-3">Invoice <span style={{ fontWeight: 'bold' }}>{invoiceNo}</span> Submitted to GST Portal Successfully</p>
            </>)
            setAlertButtons([
                {
                    name: 'view Invoice', variant: 'outline-secondary', action: () => {
                        setAlertShow(false)
                        handleViewButton(invoiceNo, 'gstsubmitted', 'miscellaneous')
                        dispatch({
                            type: PUT_GST_SUBMIT_SUCCESS,
                            payload: null
                        })
                    }
                },
                {
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        setCurrentPage(1);
                        backFunction();
                        backPagination()
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_GST_SUBMIT_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_FAILURE,
                            payload: null
                        })

                    }
                },
            ])
        }
    }, [gstsubmmisiondata])

    useEffect(() => {
        if (billingEntities) {
            const billingEntitiesOptions = billingEntities.map((each) => {
                return {
                    label: each?.company_name,
                    value: each?.partner_company_id
                }
            })
            setBillingEntityOptions(billingEntitiesOptions)
            if (editMiscInvoiceClicked) {
                const billingEntity = billingEntities.find(each => each.company_name === companyName && each.gst_number === companyGST)
                setBillingEntityDropdown({
                    label: billingEntity?.company_name,
                    value: billingEntity?.partner_company_id
                })
            }
        }
    }, [billingEntities])

    useEffect(() => {
        if (newInvoiceNumber && !editMiscInvoiceClicked) {
            setAlertShow(true)
            setAlertType('success')
            setAlertMessage('Success')
            setAlertValue(<>
                <p className="mb-3">Invoice <span style={{ fontWeight: 'bold' }}>{newInvoiceNumber}</span> Generated Successfully</p>
            </>)
            setAlertButtons([
                {
                    name: 'View Invoice', variant: 'outline-secondary', action: () => {
                        setAlertShow(false)
                        handleViewButton(newInvoiceNumber, 'draft', 'miscellaneous')
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_SUCCESS,
                            payload: null
                        })
                    }
                },
                {
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        setCurrentPage(1);
                        backFunction();
                        backPagination()
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_GST_SUBMIT_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_FAILURE,
                            payload: null
                        })
                    }
                },
            ])
        }
        else {
            if (newInvoiceNumber && editMiscInvoiceClicked) {
                setAlertShow(true)
                setAlertType('success')
                setAlertMessage('Success')
                setAlertValue(<>
                    <p className="mb-3">Invoice <span style={{ fontWeight: 'bold' }}>{invoiceNo}</span> Updated Successfully</p>
                </>)
                setAlertButtons([
                    {
                        name: 'View Invoice', variant: 'outline-secondary', action: () => {
                            setAlertShow(false)
                            handleViewButton(invoiceNo, 'draft', 'miscellaneous')
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                payload: null
                            })
                        }
                    },
                    {
                        name: 'Close', action: () => {
                            setAlertShow(false)
                            setCurrentPage(1);
                            backFunction();
                            backPagination()
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_GST_SUBMIT_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_FAILURE,
                                payload: null
                            })
                        }
                    },
                ])
            }
        }
    }, [newInvoiceNumber])


    useEffect(() => {
        if (error) {
            setAlertShow(true)
            setAlertType('error')
            setAlertMessage('Error ')
            setAlertValue(error)
            setAlertButtons([{
                name: 'Close', action: () => {
                    setAlertShow(false)
                    dispatch({
                        type: PUT_ADD_MISC_INVOICE_SUCCESS,
                        payload: null
                    })
                    dispatch({
                        type: PUT_GST_SUBMIT_SUCCESS,
                        payload: null
                    })
                    dispatch({
                        type: PUT_ADD_MISC_INVOICE_FAILURE,
                        payload: null
                    })
                }
            }])
        }
        setIsLoading(false);
    }, [error]);

    useEffect(() => {
        if (billingEntityDropdown && miscPlaceOfSupply) {
            setIsLoading(true)
            const billingEntity = billingEntities.find(each => each.partner_company_id === billingEntityDropdown.value)
            const placeOfSupply = miscPlaceOfSupply.value
            // api call to get the tax rates
            // invoices/transactionType
            const data = {
                "gst_number": billingEntity?.gst_number,
                "state": placeOfSupply
            }
            // gst_number = 29AAACW0000A1ZP & state=Karnataka
            axios.get(base_url + "invoices/transactionType?gst_number=" + billingEntity?.gst_number + "&state=" + placeOfSupply)
                .then((response) => {
                    const taxRates = response.data.data?.data
                    if (taxRates.igst === true) {
                        setIgstToggle(true)
                        const cgstInTable = miscInvoiceTable.some(each => each.cgst)
                        if (cgstInTable) {
                            const tableData = miscInvoiceTable.map(each => {
                                return {
                                    ...each,
                                    igst: each.cgst + each.sgst
                                }
                            })
                            setMiscInvoiceTable(tableData)
                        }
                    } else {
                        setIgstToggle(false)
                        const igstInTable = miscInvoiceTable.some(each => each.igst)
                        if (igstInTable) {
                            const tableData = miscInvoiceTable.map(each => {
                                return {
                                    ...each,
                                    cgst: each.igst / 2,
                                    sgst: each.igst / 2
                                }
                            })
                            setMiscInvoiceTable(tableData)
                        }
                    }
                    setIsLoading(false)
                })
                .catch((error) => {
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error ')
                    setAlertValue(error?.response?.data.message)
                    setAlertButtons([{
                        name: 'Close', action: () => {
                            setAlertShow(false)
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_GST_SUBMIT_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_FAILURE,
                                payload: null
                            })
                        }
                    }])
                    setIsLoading(false)
                })
        }
    }, [billingEntityDropdown, miscPlaceOfSupply])


    const submitToGSTPortal = (invoiceNumber) => {
        // endpoint - https://q73ion9zv2.execute-api.us-east-2.amazonaws.com/dev/api/invoices/submitToGSTPortal
        // body - {"invoice_number": "SRST2425-001174"}

        dispatch(submitToGSTSubmissionPortal({ invoice_number: invoiceNumber }))
    }

    const getAllInvoicesPdf = async (statusType) => {
        setIsLoading(true);
        const data = {
            request_type: "dropdown",
            payment_status: selectedPaymentStatus ? selectedPaymentStatus : undefined,
            invoice_type: invoiceSelected ? invoiceSelected : undefined,
            filter_condition: JSON.stringify({
                facility_id: localStorage.getItem("selected_facility_id"),
                status: statusType,
                start_month: periods.length > 1 ? periods[0]?.month + 1 : undefined,
                start_year: periods.length > 1 ? periods[0]?.year : undefined,
                end_month: periods.length > 1 ? periods[periods.length - 1]?.month + 1 : undefined,
                end_year: periods.length > 1 ? periods[periods.length - 1]?.year : undefined,
                customer_id: selectedCustomer ? selectedCustomer : undefined,
                invoice_year: periods.length > 1 ? undefined : periods[0]?.year,
                invoice_month: periods.length > 1 ? undefined : periods[0]?.month + 1,
            })
        };

        try {
            const res = await axios.get(base_url + `invoices/invoicesByStatus`, {
                params: data
            });

            const response = res.data.data;
            const listOfKeys = [];

            response.forEach((each) => {
                if (each.pdf_path_on_s3) {
                    listOfKeys.push(each.pdf_path_on_s3);
                }
            });
            setIsLoading(false);

            return listOfKeys;

        } catch (error) {
            console.error("Error fetching invoices:", error);
            setIsLoading(false);

            return []; // Always return an array
        }
    };

    const handleDownloadZip = async (s3keys) => {
        setIsLoading(true);
        setShowDownloadProgress(true);
        setDownloadProgress(0);

        try {
            const keys1 = Array.isArray(s3keys) ? s3keys : [];

            if (keys1.length === 0) {
                throw new Error("No files to download");
            }

            const zip = new JSZip();


            // Fetch and add files for keys1 into 'pdfgenerated'
            if (keys1.length > 0) {
                const response1 = await axios.get(`${base_url}documents/invoiceDocuments`, {
                    params: {
                        filter_condition: JSON.stringify({
                            s3_keys: keys1
                        })
                    },
                });

                const data1 = response1.data?.data;
                if (data1 && data1.length > 0) {
                    data1.forEach(file => {
                        if (file.invoice) {
                            let base64Data = file.invoice.replace(/^b'|^b"|['"]$/g, ''); // Clean base64 data
                            const fileName = file.key.split('/').pop();
                            // folderPdfGenerated.file(fileName, base64Data, { base64: true });
                            zip.file(fileName, base64Data, { base64: true });
                        }
                    });
                }
            }

            const zipBlob = await zip.generateAsync({ type: 'blob' }, metadata => {
                const percent = Math.round(metadata.percent);
                setDownloadProgress(percent);
            });

            setAlertShow(true);
            setAlertType('success');
            setAlertMessage('Success');
            setAlertValue('Download completed successfully.');
            setAlertButtons([{
                name: 'Close', action: () => {
                    setAlertShow(false);
                    setShowDownloadProgress(false);
                    setDownloadProgress(0);
                    dispatch({ type: PUT_ADD_MISC_INVOICE_SUCCESS, payload: null });
                    dispatch({ type: PUT_GST_SUBMIT_SUCCESS, payload: null });
                    dispatch({ type: PUT_ADD_MISC_INVOICE_FAILURE, payload: null });
                }
            }]);

            const url = URL.createObjectURL(zipBlob);
            const link = document.createElement('a');
            link.href = url;
            const zipFileName = `invoices-${selectedFacility}-${billingMonthFilter}-${billingYearFilter}.zip`;
            link.setAttribute('download', zipFileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);

            setDownloadProgress(100);

        } catch (error) {
            console.error(error);
            setAlertShow(true);
            setAlertType('error');
            setAlertMessage('Error');
            setAlertValue(error?.response?.data?.message || error.message || 'An error occurred');
            setAlertButtons([{
                name: 'Close',
                action: () => {
                    setAlertShow(false);
                    setDownloadProgress(0);
                    setShowDownloadProgress(false);
                    dispatch({ type: PUT_ADD_MISC_INVOICE_SUCCESS, payload: null });
                    dispatch({ type: PUT_GST_SUBMIT_SUCCESS, payload: null });
                    dispatch({ type: PUT_ADD_MISC_INVOICE_FAILURE, payload: null });
                }
            }]);
        } finally {
            setIsLoading(false);
        }
    };

    const sendToCustomer = (invoiceNumber) => {
        setIsLoading(true)
        // dispatch(sendToCustomerAsEmail({invoice_number: invoiceNumber}))
        axios
            .post(base_url + "invoices/dispatchEmail", { invoice_number: invoiceNumber })
            .then((response) => {
                if (response.data.status === "success") {
                    setIsLoading(false)
                    setAlertShow(true)
                    setAlertType('success')
                    setAlertMessage('Success')
                    setAlertValue(<>
                        <p className="mb-3">Invoice <span style={{ fontWeight: 'bold' }}>{invoiceNumber}</span> Sent to Customer Successfully</p>
                    </>)
                    setAlertButtons([
                        {
                            name: 'View Invoice', variant: 'outline-secondary', action: () => {
                                setAlertShow(false)
                                handleViewButton(invoiceNumber, 'emailed', 'miscellaneous')
                            }
                        },
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                                setCurrentPage(1);
                                backFunction();
                                backPagination()
                                dispatch({
                                    type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                    payload: null
                                })
                                dispatch({
                                    type: PUT_GST_SUBMIT_SUCCESS,
                                    payload: null
                                })
                                dispatch({
                                    type: PUT_ADD_MISC_INVOICE_FAILURE,
                                    payload: null
                                })
                            }
                        },
                    ])
                }
            })
            .catch((error) => {
                setIsLoading(false)
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error ')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_GST_SUBMIT_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_FAILURE,
                            payload: null
                        })
                    }
                }])
            })
    }

    const calculateTotalBasicAmount = (table) => {
        const invoiceTable = table ? table : miscInvoiceTable
        const totalBasicAmount = invoiceTable.reduce((acc, each) => acc + parseFloat(each.basicAmount), 0)
        setMiscTotalBasicAmount(totalBasicAmount)
    }

    const calculateTotalTaxAmount = (table) => {
        const invoiceTable = table ? table : miscInvoiceTable
        let totalTaxAmount = 0
        if (igstToggle) {
            totalTaxAmount = invoiceTable.reduce((acc, each) => acc + parseFloat(each.basicAmount / 100) * (parseFloat(each.igst)), 0)
        }
        else {
            totalTaxAmount = invoiceTable.reduce((acc, each) => acc + parseFloat(each.basicAmount / 100) * (parseFloat(each.cgst) + parseFloat(each.sgst)), 0)
        }
        setMiscTotalTaxAmount(totalTaxAmount)
    }

    const generateInvoiceButtonClicked = () => {
        dispatch(commercialHeadGetBillingEntities())
        dispatch(commercialHeadGetCompleteContractsForDropdown(localStorage.getItem('selected_facility_id')))
    }

    const getContractDetails = (data) => {
        const contractNumber = data.split(',')[0]
        const contactType = data.split(',')[1]
        let url = ''
        if (contactType === 'FMS') {
            url = 'customers/fmsContracts'
        } else {
            url = 'customers/contracts'
        }
        dispatch({
            type: CONTRACT_API_LOADER_TRIGGER_TRUE,
            payload: true,
        });
        axios.get(base_url + url, {
            params: {
                filter_condition: JSON.stringify({ contract_id: contractNumber })
            }
        })
            .then((response) => {
                dispatch({
                    type: CONTRACT_API_LOADER_TRIGGER_TRUE,
                    payload: false,
                });
                const data = response.data.data
                if (!editMiscInvoiceClicked) {
                    const billingEntityId = data?.billing_entity
                    //selecting place of supply
                    const facilityId = data?.facility_id
                    const facility = facilitiesListForNav.find(each => each.facility_id === facilityId)
                    setMiscPlaceOfSupply({
                        label: facility?.state,
                        value: facility?.state
                    })
                    //getting facility name from local
                    setFacilityName(facility?.name)
                    //search and map billing entity
                    const billingEntity = billingEntities.find(each => each.partner_company_id === billingEntityId)
                    if (billingEntity) {
                        setBillingEntityDropdown({
                            label: billingEntity.company_name,
                            value: billingEntity.partner_company_id
                        })
                        if (billingEntity.logo) {
                            getImage(billingEntity.logo)
                        } else {
                            setCompanyLogo(null)
                        }
                        setCompanyName(billingEntity.company_name)
                        const address = billingEntity?.registered_address
                        setCompanyAddress(`${address?.street_address_1}, ${address?.street_address_2}, ${address?.city}, ${address?.state}, ${address?.postal_code}`)
                        setPartnerState(address?.state)
                        setPartnerStateCode(billingEntity?.gst_number?.slice(0, 2))
                        setCompanyGST(billingEntity?.gst_number)
                        setPartnerPAN(billingEntity?.pan_number)
                        setCompanyCIN(billingEntity?.cin)
                    }

                    setContractNo(data?.contract_number)
                    setcustomerName(data?.company_name)
                    //set service Identifier
                    setMiscInvoiceServiceIntifier(`${data?.space_name}, ${localStorage.getItem('selected_facility_name')}`)
                    // setMiscPlaceOfSupply(data?.pos_state)
                    setcustomerPlaceOfSupply(facility?.state)
                    // billing adress 
                    const billingAddress = data?.billing_address
                    setcustomerAddress(` ${billingAddress?.street_address_1}, ${billingAddress?.street_address_2}, ${billingAddress?.city}, ${billingAddress?.state}, ${billingAddress?.postal_code}`)
                    // shipping address
                    const shippingAddress = data?.shipping_address
                    if (shippingAddress) {
                        setStreetAddress(`${shippingAddress?.street_address_1}, ${shippingAddress?.street_address_2}`)
                        setCity(shippingAddress?.city)
                        setState(shippingAddress?.state)
                        setPincode(shippingAddress?.postal_code)
                        setToggleShippingAddress(true)
                    }
                    setcustomerGSTIN(data?.gst_number)
                    setcustomerPAN(data?.pan_number)
                    setcustomerCIN(data?.cin)
                    setcustomerStateCode(data?.gst_number?.slice(0, 2))
                }

                const listOfContacts = data?.contacts?.map(each => {
                    return {
                        name: each.name,
                        contact_id: each.contact_id,
                        designation: each.designation,
                        sendEmail: true
                    }
                })
                setMiscListOfContacts(listOfContacts)


            })
            .catch((error) => {
                dispatch({
                    type: CONTRACT_API_LOADER_TRIGGER_TRUE,
                    payload: false,
                });
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error ')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_GST_SUBMIT_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_FAILURE,
                            payload: null
                        })
                    }
                }])
            })
    }

    const getContractDetailsForEdit = (data) => {
        const contractNumber = data.split(',')[0]
        const contactType = data.split(',')[1]
        let url = ''
        if (contactType === 'FMS') {
            url = 'customers/fmsContracts'
        } else {
            url = 'customers/contracts'
        }
        dispatch({
            type: CONTRACT_API_LOADER_TRIGGER_TRUE,
            payload: true,
        });
        axios.get(base_url + url, {
            params: {
                filter_condition: JSON.stringify({ contract_id: contractNumber })
            }
        })
            .then((response) => {
                dispatch({
                    type: CONTRACT_API_LOADER_TRIGGER_TRUE,
                    payload: false,
                });
                const data = response.data.data

                const billingEntityId = data?.billing_entity
                //selecting place of supply
                const facilityId = data?.facility_id
                const facility = facilitiesListForNav.find(each => each.facility_id === facilityId)
                setMiscPlaceOfSupply({
                    label: facility?.state,
                    value: facility?.state
                })
                //getting facility name from local
                setFacilityName(facility?.name)
                //search and map billing entity
                const billingEntity = billingEntities.find(each => each.partner_company_id === billingEntityId)
                if (billingEntity) {
                    setBillingEntityDropdown({
                        label: billingEntity.company_name,
                        value: billingEntity.partner_company_id
                    })
                    if (billingEntity.logo) {
                        getImage(billingEntity.logo)
                    } else {
                        setCompanyLogo(null)
                    }
                    setCompanyName(billingEntity.company_name)
                    const address = billingEntity?.registered_address
                    setCompanyAddress(`${address?.street_address_1}, ${address?.street_address_2}, ${address?.city}, ${address?.state}, ${address?.postal_code}`)
                    setPartnerState(address?.state)
                    setPartnerStateCode(billingEntity?.gst_number?.slice(0, 2))
                    setCompanyGST(billingEntity?.gst_number)
                    setPartnerPAN(billingEntity?.pan_number)
                    setCompanyCIN(billingEntity?.cin)
                }

                setContractNo(data?.contract_number)
                setcustomerName(data?.company_name)
                //set service Identifier
                setMiscInvoiceServiceIntifier(`${data?.space_name}, ${localStorage.getItem('selected_facility_name')}`)
                // setMiscPlaceOfSupply(data?.pos_state)
                setcustomerPlaceOfSupply(facility?.state)
                // billing adress 
                const billingAddress = data?.billing_address
                setcustomerAddress(` ${billingAddress?.street_address_1}, ${billingAddress?.street_address_2}, ${billingAddress?.city}, ${billingAddress?.state}, ${billingAddress?.postal_code}`)
                // shipping address
                const shippingAddress = data?.shipping_address
                if (shippingAddress) {
                    setStreetAddress(`${shippingAddress?.street_address_1}, ${shippingAddress?.street_address_2}`)
                    setCity(shippingAddress?.city)
                    setState(shippingAddress?.state)
                    setPincode(shippingAddress?.postal_code)
                    setToggleShippingAddress(true)
                }
                setcustomerGSTIN(data?.gst_number)
                setcustomerPAN(data?.pan_number)
                setcustomerCIN(data?.cin)
                setcustomerStateCode(data?.gst_number?.slice(0, 2))


                const listOfContacts = data?.contacts?.map(each => {
                    return {
                        name: each.name,
                        contact_id: each.contact_id,
                        designation: each.designation,
                        sendEmail: true
                    }
                })
                setMiscListOfContacts(listOfContacts)


            })
            .catch((error) => {
                dispatch({
                    type: CONTRACT_API_LOADER_TRIGGER_TRUE,
                    payload: false,
                });
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error ')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_GST_SUBMIT_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_FAILURE,
                            payload: null
                        })
                    }
                }])
            })
    }

    const addMiscInvoice = () => {
        const tableDetails = miscInvoiceTable?.map(each => {
            if (igstToggle) {
                return {
                    service_name_in_invoice: each.service,
                    hsn_code: each.hsn,
                    net_amount: parseFloat(each.basicAmount),
                    igst_rate: parseInt(each.igst),
                    consumption: parseFloat(each.consumption),
                    rate_per_unit: parseFloat(each.rate_per_unit),
                    from_date: each.from_date,
                    to_date: each.to_date
                }
            } else {
                return {
                    service_name_in_invoice: each.service,
                    hsn_code: each.hsn,
                    net_amount: parseFloat(each.basicAmount),
                    cgst_rate: parseFloat(each.cgst),
                    sgst_rate: parseFloat(each.sgst),
                    consumption: parseFloat(each.consumption),
                    rate_per_unit: parseFloat(each.rate_per_unit),
                    from_date: each.from_date,
                    to_date: each.to_date
                }
            }
        })
        let listOfContacts = []
        miscListOfContacts?.forEach(each => {
            if (each.sendEmail) {
                listOfContacts.push(each?.contact_id)
            }
        })
        const data = {
            place_of_supply: miscPlaceOfSupply?.value,
            invoice_details: tableDetails,
            billing_entity: billingEntityDropdown?.value,
            contract_name: miscContractName?.label,
            misc_list_of_contacts: listOfContacts,
            show_billing_period: miscShowBilling,
            show_computation_details: miscShowComputations,
            terms_and_conditions: termsAndConditions
        }
        dispatch(createNewMiscInvoice(data))
    }

    const editMiscInvoice = () => {
        const tableDetails = miscInvoiceTable?.map(each => {
            if (igstToggle) {
                return {
                    service_name_in_invoice: each.service,
                    hsn_code: each.hsn?.toString(),
                    net_amount: parseFloat(each.basicAmount),
                    igst_rate: parseInt(each.igst),
                    consumption: parseFloat(each.consumption),
                    rate_per_unit: parseFloat(each.rate_per_unit),
                    from_date: each.from_date,
                    to_date: each.to_date
                }
            } else {
                return {
                    service_name_in_invoice: each.service,
                    hsn_code: each.hsn?.toString(),
                    net_amount: parseFloat(each.basicAmount),
                    cgst_rate: parseFloat(each.cgst),
                    sgst_rate: parseFloat(each.sgst),
                    consumption: parseFloat(each.consumption),
                    rate_per_unit: parseFloat(each.rate_per_unit),
                    from_date: each.from_date,
                    to_date: each.to_date
                }
            }
        })
        let listOfContacts = []
        miscListOfContacts?.forEach(each => {
            if (each.sendEmail) {
                listOfContacts.push(each?.contact_id)
            }
        })
        const data = {
            invoice_number: invoiceNo,
            place_of_supply: miscPlaceOfSupply?.value,
            invoice_details: tableDetails,
            billing_entity: billingEntityDropdown?.value,
            contract_name: miscContractName?.label,
            misc_list_of_contacts: listOfContacts,
            show_billing_period: miscShowBilling,
            show_computation_details: miscShowComputations,
            terms_and_conditions: termsAndConditions
        }
        dispatch(editAMiscInvoice(data))
    }

    const handleFilesSelected = (files) => {
        const processedFiles = [];
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = function () {
                const base64FileContent = reader.result.split(",")[1];
                // const required_id = selectedDraftContract && selectedDraftContract.draft_id
                const processedFile = {
                    file_content: base64FileContent,
                    object_type: "invoice_documents",
                    file_description: file.description,
                    file_type: file.file.type.split("/")[1],
                    file_name: file.file.name,
                    // draft_id:required_id,
                    contract_name: miscContractName && miscContractName.label,
                    file_size: file.file.size,
                    flag: file.flag,
                    user_id: localStorage.getItem("username"),
                };
                processedFiles.push(processedFile);
                if (processedFiles.length === files.length) {
                    setUploadedFiles(processedFiles);
                }
            };

            reader.readAsDataURL(file.file);
        });
    };
    const handleDocumentUpload = (index) => {
        dispatch(handleDocumentLoaderTrue())
        dispatch(commercialHeadUploadDocument(
            {
                files: [uploadedFiles[index]]
            }
        ))
    }

    const addMiscInvoiceValidation = () => {
        let isValid = billingEntityDropdown
            && miscContractName && miscPlaceOfSupply
            && miscInvoiceTable.length > 0 && miscInvoiceTable.every(each => each.service && each.hsn && each.basicAmount && !each.hsnError)
            && miscListOfContacts.length > 0 && miscListOfContacts.some(each => each.sendEmail)
            && termsAndConditions

        if (miscShowBilling) {
            isValid = isValid && miscInvoiceTable.every(each => each.from_date && each.to_date)
        }
        if (miscShowComputations) {
            isValid = isValid && miscInvoiceTable.every(each => each.consumption && each.rate_per_unit)
        }
        return isValid
    }



    const states = [
        'Delhi',
        'Andhra Pradesh',
        'Arunachal Pradesh',
        'Assam',
        'Bihar',
        'Chhattisgarh',
        'Goa',
        'Gujarat',
        'Haryana',
        'Himachal Pradesh',
        'Jharkhand',
        'Karnataka',
        'Kerala',
        'Madhya Pradesh',
        'Maharashtra',
        'Manipur',
        'Meghalaya',
        'Mizoram',
        'Nagaland',
        'Odisha',
        'Punjab',
        'Rajasthan',
        'Sikkim',
        'Tamil Nadu',
        'Telangana',
        'Tripura',
        'Uttar Pradesh',
        'Uttarakhand',
        'West Bengal'
    ];

    const stateOptions = states.map(state => ({
        label: state,
        value: state
    }));

    const typesOfInvoices = [
        {
            name: "All Invoices",
            id: "all"
        },
        {
            name: "Awaiting FM approval",
            id: "draft"
        },
        {
            name: "Awaiting GST submission",
            id: "approved"
        },
        {
            name: "GST submitted",
            id: "gstsubmitted"
        },
        {
            name: 'PDF Generated',
            id: 'pdfgenerated'
        },
        {
            name: 'Sent to Customer',
            id: 'emailed'
        },

        {
            name: "On-Hold",
            id: "onhold"
        },
        // {
        //     name : "Generated Invoices",
        //     id : "generated"
        // },
        {
            name: "Rejected",
            id: "rejected"
        },


    ]

    const slfDetails = [
        {
            year: 2024,
            space: "Unit 11",
            license_fee: "10,000",
            escation: 10,
            start_date: "12/12/2023",
            end_date: "12/12/2024",
            locking_period: "7 days",
            Payement: "7 Days"
        },
        {
            year: 2024,
            space: "Unit 11",
            license_fee: "10,000",
            escation: 10,
            start_date: "12/12/2023",
            end_date: "12/12/2024",
            locking_period: "7 days",
            Payement: "7 Days"
        },
        {
            year: 2024,
            space: "Unit 11",
            license_fee: "10,000",
            escation: 10,
            start_date: "12/12/2023",
            end_date: "12/12/2024",
            locking_period: "7 days",
            Payement: "7 Days"
        },
        {
            year: 2024,
            space: "Unit 11",
            license_fee: "10,000",
            escation: 10,
            start_date: "12/12/2023",
            end_date: "12/12/2024",
            locking_period: "7 days",
            Payement: "7 Days"
        },
        {
            year: 2024,
            space: "Unit 11",
            license_fee: "10,000",
            escation: 10,
            start_date: "12/12/2023",
            end_date: "12/12/2024",
            locking_period: "7 days",
            Payement: "7 Days"
        }
    ]

    useEffect(() => {
        if (invoicesListError) {
            setInvoiceListErrorFlag(true)
        }
    }, [invoicesListError])

    useEffect(() => {
        setListOfPartnerCompanies(partnerCompaniesList)
    }, [partnerCompaniesList])

    useEffect(() => {
        if (partnerCompaniesListError) {
            setAlertShow(true)
            setAlertType('error')
            setAlertMessage('Error ')
            setAlertValue(partnerCompaniesListError)
            setAlertButtons([{
                name: 'Close', action: () => {
                    setAlertShow(false)
                    dispatch({
                        type: PUT_ADD_MISC_INVOICE_SUCCESS,
                        payload: null
                    })
                    dispatch({
                        type: PUT_GST_SUBMIT_SUCCESS,
                        payload: null
                    })
                    dispatch({
                        type: PUT_ADD_MISC_INVOICE_FAILURE,
                        payload: null
                    })
                }
            }])
        }
        setIsLoading(false);
    }, [partnerCompaniesListError])

    useEffect(() => {
        if (generateInvoiceStatus === "success") {
            handleViewButton(invoiceNo, 'draft', selectedInvoiceType)
        }
    }, [generateInvoiceStatus])

    const filterFuntion = () => {
        const filterId = invoiceType === "pending" ? "approved" : invoiceType
        let data = invoicesList.filter(each => each.status === filterId)
        if (invoiceType === "pending") {
            data = data.filter(each => each.approval_status == "No")
            //    setFilteredData(filteredData)
        }
        else if (invoiceType === "approved") {
            data = data.filter(each => each.approval_status == "Yes")
            // setFilteredData(filteredData)
        }
        if (invoiceSelected !== "") {
            data = data.filter(each => each.invoice_type === invoiceSelected)
        }
        const text = searchText.toLowerCase();
        if (text) {
            data = data.filter((each) => {
                return each.invoice_number.toLowerCase().includes(text) ||
                    each.company_name.toLowerCase().includes(text)
            });
        }
        // if (biilingPeriodFilter !== "") {
        //     data = data.filter(each => each.billing_period === format(biilingPeriodFilter, 'MMM yyyy'))
        // }
        setTotalInvoices(data.length)
        setFilteredData(data)

    }


    useEffect(() => {
        applyFilter()
    }, [])

    useEffect(() => {

        if (invoicesList) {
            setFilteredData(invoicesList)
        }
        else {
            setFilteredData([])
        }
    }, [invoicesList])


    useEffect(() => {
        if (editInvoiceSubmisssion) {
            let approvalTypeCapital = approvalType
            approvalTypeCapital = approvalTypeCapital[0]?.toLocaleUpperCase() + approvalTypeCapital?.slice(1)
            setAlertShow(true)
            setAlertType('success')
            setAlertMessage('Success')
            setAlertValue(<>
                {invoiceStatusTo === "approved" && <><b>{approvalTypeCapital}</b> Invoice <b>{invoiceNo}</b> has been approved</>}
                {invoiceStatusTo === "rejected" && <><b>{approvalTypeCapital}</b> Invoice <b>{invoiceNo}</b> has been rejected</>}
                {invoiceStatusTo === "onhold" && <><b>{approvalTypeCapital}</b> Invoice <b>{invoiceNo}</b> has been put on hold</>}
            </>)
            setAlertButtons([{
                name: 'Close', action: () => {
                    setAlertShow(false)
                    // window.location.reload() //going to current page one with same filtered data
                    backFunction()
                    applyFilter()
                    dispatch({
                        type: PUT_ADD_MISC_INVOICE_SUCCESS,
                        payload: null
                    })
                    dispatch({
                        type: PUT_GST_SUBMIT_SUCCESS,
                        payload: null
                    })
                    dispatch({
                        type: PUT_ADD_MISC_INVOICE_FAILURE,
                        payload: null
                    })
                    dispatch({
                        type: PUT_INVOICE_DATA_SUCCESS,
                        payload: null,
                    });

                }
            }])
        }
        setIsLoading(false)
    }, [editInvoiceSubmisssion])


    useEffect(() => {
        if (error?.response?.data.message) {
            setAlertShow(true)
            setAlertType('error')
            setAlertMessage('Error ' + invoiceType)
            setAlertValue(error?.response?.data.message)
            setAlertButtons([{
                name: 'Close', action: () => {
                    setAlertShow(false)
                    dispatch({
                        type: PUT_ADD_MISC_INVOICE_SUCCESS,
                        payload: null
                    })
                    dispatch({
                        type: PUT_GST_SUBMIT_SUCCESS,
                        payload: null
                    })
                    dispatch({
                        type: PUT_ADD_MISC_INVOICE_FAILURE,
                        payload: null
                    })
                }
            }])
        }
        setIsLoading(false);
    }, [error]);

    const [currentAppliedInvoiceType, setCurrentAppliedInvoiceType] = useState(invoiceType)
    const [currentAppliedBillingPeriod, setCurrentAppliedBillingPeriod] = useState("")

    const applyFilter = () => {
        localStorage.setItem("selected_facility_name", selectedFacilityName);
        localStorage.setItem("selected_city_name", selectedCityName);
        localStorage.setItem("selected_facility_id", selectedFacilityId);
        const companyName = companyList.find(each => each.customer_id === selectedCustomer)
        setSelectedCustomerFilter(companyName ? companyName.company_name : "")
        setSelectedInvoiceSelectedFilter(invoiceSelected)
        setSelectedStatusFilter(selectedStatus)
        setInvoiceType(selectedStatus)
        setPeriodsFilter(periods.map(each => ({
            month: each.month,
            year: each.year
        })))
        setSelectedFacilityFilter(localStorage.getItem("selected_city_name") + ", " + localStorage.getItem("selected_facility_name"))
        setCurrentAppliedBillingPeriod(biilingPeriodFilter)
        setCurrentAppliedInvoiceType(invoiceType)
        setSelectedPaymentFilter(selectedPaymentStatus)
        const monthNumber = billingMonthFilter
        const fullYear = billingYearFilter
        dispatch({
            type: SET_PAGINATION_COUNT_TO,
            payload: 1
        })
        dispatch(getAllInvoices({
            page: 1 && 1, limit: RECORDS_PER_PAGE, facility_id: selectedFacilityId,
            invoiceType: selectedStatus, searchText, invoiceSelected, periods, selectedCustomer, paymentStatus: selectedPaymentStatus
        }))
        setInvoiceListErrorFlag(false)
        setIsOpen(false)
    }

    const handleReset = () => {
        localStorage.setItem("selected_facility_name", selectedFacilityName);
        localStorage.setItem("selected_city_name", selectedCityName);
        localStorage.setItem("selected_facility_id", selectedFacilityId);
        const monthNumber = dayjs().month() + 1;
        const fullYear = dayjs().year();
        const currentMonth = dayjs().month();
        setSearchText("");
        setinvoiceSelected("");
        setCurrentAppliedBillingPeriod("");
        setInvoiceStatus("all");
        setInvoiceType('all')
        setSelectedCustomerFilter("");
        setSelectedInvoiceSelectedFilter("");
        setSelectedStatusFilter("all");
        setSelectedCustomer("");
        setSelectedStatus("all");
        setSelectedPaymentFilter("");
        setSelectedPaymentStatus("");
        setPeriodsFilter([
            {
                month: currentMonth,
                year: fullYear
            }
        ])
        setPeriods([{
            month: currentMonth,
            year: fullYear
        }])
        setBillingMonthFilter(monthNumber);
        setBillingYearFilter(fullYear);
        dispatch(getAllInvoices({
            page: 1 && 1, limit: RECORDS_PER_PAGE, facility_id: selectedFacilityId, invoiceType: "all", searchText, invoiceSelected: "", periods: [{
                month: currentMonth,
                year: fullYear
            }],
            selectedCustomer: "",
            paymentStatus: ""
        }))

    };

    const backPagination = () => {
        const monthNumber = billingMonthFilter
        const fullYear = billingYearFilter

        dispatch({
            type: SET_PAGINATION_COUNT_TO,
            payload: 1
        })
        dispatch(getAllInvoices({ page: currentPaginationPageAc, limit: RECORDS_PER_PAGE, facility_id: localStorage.getItem("selected_facility_id"), invoiceType, searchText, invoiceSelected, periods, selectedCustomer, paymentStatus: selectedPaymentStatus }))
        setInvoiceListErrorFlag(false)
    }

    const changeDateFormat = () => {
        const date = format(biilingPeriodFilter, 'MMM yyyy')
        return date

    }

    const handledPaginationNextClicked = () => {
        // const month = format(biilingPeriodFilter, 'MMMM yyyy');
        // const fullYear = format(biilingPeriodFilter, 'yyyy');
        // const monthNumber = new Date(month + ' 1, ' + fullYear).getMonth() + 1;
        const monthNumber = billingMonthFilter
        const fullYear = billingYearFilter
        handlePaginationLoaderTrue()
        setInvoiceListErrorFlag(false)
        dispatch(getAllInvoices({ invoiceType, facility_id: localStorage.getItem("selected_facility_id"), invoiceSelected, search_text: searchText, limit: RECORDS_PER_PAGE, page: currentPaginationPageAc + 1, periods, selectedCustomer, paymentStatus: selectedPaymentStatus }))
    }

    const handledPaginationPrevClicked = () => {
        // const month = format(biilingPeriodFilter, 'MMMM yyyy');
        // const fullYear = format(biilingPeriodFilter, 'yyyy');
        // const monthNumber = new Date(month + ' 1, ' + fullYear).getMonth() + 1;
        const monthNumber = billingMonthFilter
        const fullYear = billingYearFilter
        setInvoiceListErrorFlag(false)
        dispatch(getAllInvoices({ invoiceType, facility_id: localStorage.getItem("selected_facility_id"), invoiceSelected, search_text: searchText, limit: RECORDS_PER_PAGE, page: currentPaginationPageAc - 1, periods, selectedCustomer, paymentStatus: selectedPaymentStatus }))

    }


    function formatAddressWithCapitalization(address) {
        const addressComponents = address?.split(';;');
        const formattedAddress = addressComponents
            .map(component => component
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ')
            ).join(', ');
        return formattedAddress;
    }


    const handleDownload = () => {
        setIsLoading(true);
        axios.get(`${base_url}documents/invoiceDocuments`, {
            params: {
                filter_condition: JSON.stringify({
                    s3_keys: [downloadPath]
                })
            },
        }
        ) // Get JSON response
            .then((response) => {
                let data = response.data?.data[0]?.invoice; // Assuming the base64-encoded PDF is inside this path
                if (!data) {
                    return;
                }
                // Remove b' prefix and trailing '
                data = data.replace(/^b'|^b"|['"]$/g, '');
                // Create a data URL with base64 content
                const link = document.createElement('a');
                link.href = `data:application/pdf;base64,${data}`;
                link.setAttribute('download', 'invoice.pdf'); // Set the file name for download
                document.body.appendChild(link); // Append the link to the DOM
                link.click(); // Programmatically click the link to trigger the download
                link.remove(); // Remove the link after triggering download
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                if (error) {
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error ')
                    setAlertValue(error?.response?.data.message)
                    setAlertButtons([{
                        name: 'Close', action: () => {
                            setAlertShow(false)
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_GST_SUBMIT_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_FAILURE,
                                payload: null
                            })
                        }
                    }])
                }
                setIsLoading(false);
            });
    };

    const handleDownloadpdf = (s3_key) => {
        setIsLoading(true);
        axios.get(`${base_url}documents/invoiceDocuments`, {
            params: {
                filter_condition: JSON.stringify({
                    s3_keys: [s3_key]
                })
            },
        }
        ) // Get JSON response
            .then((response) => {
                let data = response.data?.data[0]?.invoice; // Assuming the base64-encoded PDF is inside this path
                if (!data) {
                    return;
                }
                // Remove b' prefix and trailing '
                data = data.replace(/^b'|^b"|['"]$/g, '');
                // Create a data URL with base64 content
                const link = document.createElement('a');
                link.href = `data:application/pdf;base64,${data}`;
                link.setAttribute('download', 'invoice.pdf'); // Set the file name for download
                document.body.appendChild(link); // Append the link to the DOM
                link.click(); // Programmatically click the link to trigger the download
                link.remove(); // Remove the link after triggering download
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                if (error) {
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error ')
                    setAlertValue(error?.response?.data.message)
                    setAlertButtons([{
                        name: 'Close', action: () => {
                            setAlertShow(false)
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_GST_SUBMIT_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_FAILURE,
                                payload: null
                            })
                        }
                    }])
                }
                setIsLoading(false);
            });
    };

    const handleGeneratePdf = () => {
        setIsLoading(true);
        axios.post(`${base_url}invoices/generatePdf`, {
            invoice_number: invoiceNo
        }
        ) // Get JSON response
            .then((response) => {
                if (response.data.status === 'success') {
                    setAlertShow(true)
                    setAlertType('success')
                    setAlertMessage('Success')
                    setAlertValue(
                        <p className="mb-3">Invoice <span style={{ fontWeight: 'bold' }}>{invoiceNo}</span> Generated PDF Successfully</p>
                    )
                    setAlertButtons([
                        {
                            name: 'view Invoice', variant: 'outline-secondary', action: () => {
                                setAlertShow(false)
                                handleViewButton(invoiceNo, 'pdfgenerated', 'miscellaneous')
                            }
                        },
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                                setIsLoading(false);
                                setCurrentPage(1);
                                backFunction();
                                backPagination()
                                dispatch({
                                    type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                    payload: null
                                })
                                dispatch({
                                    type: PUT_GST_SUBMIT_SUCCESS,
                                    payload: null
                                })
                                dispatch({
                                    type: PUT_ADD_MISC_INVOICE_FAILURE,
                                    payload: null
                                })
                            }
                        }])
                }
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                if (error) {
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error ')
                    setAlertValue(error?.response?.data.message)
                    setAlertButtons([{
                        name: 'Close', action: () => {
                            setAlertShow(false)
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_GST_SUBMIT_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_FAILURE,
                                payload: null
                            })
                        }
                    }])
                }
                setIsLoading(false);
            });
    };



    const getDocuments1 = (footer) => {
        const payementDoc = footer?.payment_terms
        const termsDoc = footer?.terms_and_conditions
        let url = '%7B%22s3_keys%22%3A%5B%22'
        if (payementDoc && termsDoc) {
            url = url + payementDoc + '%22%2C%22' + termsDoc + '%22%5D%7D'
        }
        else if (payementDoc) {
            url = url + payementDoc + '%22%5D%7D'
        }
        else if (termsDoc) {
            url = url + termsDoc + '%22%5D%7D'
        }
        if (url !== '%7B%22s3_keys%22%3A%5B%22') {
            dispatch({
                type: SET_LOADER,
                payload: true
            })
            axios.get(`${base_url}documents?filter_condition=${url}`)
                .then(response => {
                    if (response?.data?.data[0] === 'error') {
                        setAlertShow(true)
                        setAlertType('error')
                        setAlertMessage('Error')
                        setAlertValue(response?.data?.data[1].message)
                        setAlertButtons([
                            {
                                name: 'Close', action: () => {
                                    setAlertShow(false)
                                    // window.location.reload()
                                    dispatch({
                                        type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                        payload: null
                                    })
                                    dispatch({
                                        type: PUT_GST_SUBMIT_SUCCESS,
                                        payload: null
                                    })
                                    dispatch({
                                        type: PUT_ADD_MISC_INVOICE_FAILURE,
                                        payload: null
                                    })
                                }
                            },
                        ])
                        dispatch({
                            type: SET_LOADER,
                            payload: false
                        })
                    }
                    else {
                        const documentData = response.data.data
                        if (payementDoc && termsDoc) {
                            const trimmedData1 = documentData[0].file?.slice(2, -1)
                            const trimmedData2 = documentData[1].file?.slice(2, -1)
                            setpdfDataForPayments(trimmedData1)
                            setpdfDataForTerms(trimmedData2)
                            setPaymentToggle(true)
                            setTermsToggle(true)
                        }
                        else if (payementDoc) {
                            const trimmedData = documentData[0].file?.slice(2, -1)
                            setpdfDataForPayments(trimmedData)
                            setPaymentToggle(true)
                        }
                        else if (termsDoc) {
                            const trimmedData = documentData[0].file?.slice(2, -1)
                            setpdfDataForTerms(trimmedData)
                            setTermsToggle(true)
                        }
                        dispatch({
                            type: SET_LOADER,
                            payload: false
                        })
                    }
                })
                .catch(error => {
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(error?.response?.data.message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                                dispatch({
                                    type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                    payload: null
                                })
                                dispatch({
                                    type: PUT_GST_SUBMIT_SUCCESS,
                                    payload: null
                                })
                                dispatch({
                                    type: PUT_ADD_MISC_INVOICE_FAILURE,
                                    payload: null
                                })
                            }
                        },
                    ])
                    dispatch({
                        type: SET_LOADER,
                        payload: false
                    })
                })
        }

    }

    const getDocuments = (footer) => {
        dispatch({
            type: SET_LOADER,
            payload: true
        })
        const payementDoc = footer?.payment_terms
        const termsDoc = footer?.terms_and_conditions
        if (payementDoc) {
            let url = '%7B%22s3_keys%22%3A%5B%22' + payementDoc + '%22%5D%7D'
            axios.get(`${base_url}documents?filter_condition=${url}`)
                .then(response => {
                    const documentData = response.data.data[0].file
                    const trimmedData = documentData.slice(2, -1)
                    setpdfDataForPayments(trimmedData)
                    setPaymentToggle(true)

                })
                .catch(error => {
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(error?.response?.data.message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                                dispatch({
                                    type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                    payload: null
                                })
                                dispatch({
                                    type: PUT_GST_SUBMIT_SUCCESS,
                                    payload: null
                                })
                                dispatch({
                                    type: PUT_ADD_MISC_INVOICE_FAILURE,
                                    payload: null
                                })
                                // window.location.reload()
                            }
                        },
                    ])
                    dispatch({
                        type: SET_LOADER,
                        payload: false
                    })
                }
                )
        }
        if (termsDoc) {
            setIsLoading(true)
            let url = '%7B%22s3_keys%22%3A%5B%22' + termsDoc + '%22%5D%7D'
            axios.get(`${base_url}documents?filter_condition=${url}`)
                .then(response => {
                    const documentData = response.data.data[0].file
                    const trimmedData = documentData.slice(2, -1)
                    setTermsToggle(true)
                    setpdfDataForTerms(trimmedData)
                    setIsLoading(false)
                })
                .catch(error => {
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(error?.response?.data.message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                                dispatch({
                                    type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                    payload: null
                                })
                                dispatch({
                                    type: PUT_GST_SUBMIT_SUCCESS,
                                    payload: null
                                })
                                dispatch({
                                    type: PUT_ADD_MISC_INVOICE_FAILURE,
                                    payload: null
                                })
                                // window.location.reload()
                            }
                        },
                    ])
                    dispatch({
                        type: SET_LOADER,
                        payload: false
                    })
                }
                )
        }
    }

    const getImage = (logo) => {
        dispatch({
            type: SET_LOADER,
            payload: true
        })
        axios.get(`${base_url}documents?filter_condition=%7B%22s3_keys%22%3A%5B%22${logo}%22%5D%7D`)
            .then(response => {
                const documentData = response.data.data[0].file
                const trimmedData = 'data:image/webp;base64,' + documentData.slice(2, -1)
                if (trimmedData) {
                    setCompanyLogo(trimmedData)
                }
                dispatch({
                    type: SET_LOADER,
                    payload: false
                })
            })
            .catch(error => {
                setCompanyLogo(null)
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([
                    {
                        name: 'Close', action: () => {
                            setAlertShow(false)
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_GST_SUBMIT_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_FAILURE,
                                payload: null
                            })
                        }
                    },
                ])
                dispatch({
                    type: SET_LOADER,
                    payload: false
                })
            }
            )
    }

    const [serviceNameInInvoice, setServiceNameInInvoice] = useState('')


    const handleViewButton = (id, status, type) => {
        setIsLoading(true)
        setInvoiceStatus(status)
        setSelectedInvoiceType(type)
        const url = `${base_url}invoices/get_invoice?invoice_number=${id}`
        axios.get(url)
            .then(response => {
                const invoiceData = response.data.data
                const invoiceMaster = invoiceData.invoice_master
                const invoiceDetails = invoiceData.invoice_details
                const invoiceFooter = invoiceData.invoice_footer
                const invoiceHeader = invoiceData?.invoice_header
                setInvoicePaymentDetails(invoiceData?.payment_details)
                setSelectedInvoiceType(invoiceMaster?.invoice_type)
                if (invoiceFooter.payment_terms || invoiceFooter.terms_and_conditions) {
                    getDocuments1(invoiceFooter)
                    setTermsAndConditions(invoiceFooter.terms_and_conditions)
                }
                if (invoiceHeader?.partner_logo) {
                    getImage(invoiceHeader?.partner_logo)
                } else {
                    setCompanyLogo(null)
                }
                // let isIgst
                // invoiceDetails.some(e => e.igst > 0 ? isIgst = true : isIgst = false)
                if (invoiceHeader?.transaction_type_inter_state === 1) {
                    setIgstToggle(true)
                    // const totalTaxAmount = invoiceDetails.reduce((acc, each) => acc + parseFloat(each.igst), 0)
                    // setTotalTaxAmount(invoiceMaster?.total_tax_amount)
                    setTotalIgst(invoiceMaster?.total_igst)
                } else {
                    // const totalTaxAmount = invoiceDetails.reduce((acc, each) => acc + parseFloat(each.cgst) + parseFloat(each.sgst), 0)
                    setTotalSgst(invoiceMaster?.total_sgst)
                    setTotalCgst(invoiceMaster?.total_cgst)
                }
                const detailsBasicAmount = invoiceDetails.reduce((acc, each) => acc + parseFloat(each.net_amount), 0)
                const totalAmountInWords = convertCurrencyToWords(invoiceMaster.gross_amount)
                const addressComponents = invoiceHeader?.partner_address.split(';;');
                const formattedAddress = formatAddressWithCapitalization(invoiceHeader?.partner_address)
                const state = addressComponents.length > 1 ? addressComponents[addressComponents.length - 2] : '';
                const stateVariable = state;
                const addressComponentsC = invoiceHeader?.customer_address.split(';;');
                const formattedAddressC = invoiceHeader?.billing_address ? formatAddressWithCapitalization(invoiceHeader?.billing_address) : ''
                const stateC = addressComponentsC.length > 1 ? addressComponentsC[addressComponentsC.length - 3] : '';
                const stateVariableC = stateC;
                // const shippingAddress = invoiceHeader?.shipping_address
                // if (shippingAddress) {
                //     const shipppingData = shippingAddress.split(';;')
                //     setStreetAddress(formatAddressWithCapitalization(shipppingData[0]))
                //     setCity(formatAddressWithCapitalization(shipppingData[1]))
                //     setState(formatAddressWithCapitalization(shipppingData[2]))
                //     setPincode(formatAddressWithCapitalization(shipppingData[3]))
                //     setToggleShippingAddress(true)
                // }
                if (invoiceMaster?.show_computation_details === 1) {
                    setShowComputationDetails(true)
                    setMiscShowComputations(true)
                }
                if (invoiceMaster?.show_billing_period === 1) {
                    setShowBillingPeriod(true)
                    setMiscShowBilling(true)
                }
                if (invoiceFooter?.show_pterms === 1) {
                    setShowPaymentDetails(true)
                }
                if (invoiceFooter?.show_tandc === 1) {
                    setShowTermsDetails(true)
                }
                setServiceNameInInvoice(invoiceMaster?.service_name_in_invoice)
                setDownloadPath(invoiceMaster?.pdf_path_on_s3)
                setCompanyName(invoiceMaster.company_name)
                setFacilityName(invoiceMaster?.facility_name)
                setInvoiceId(invoiceMaster?.invoice_id)
                setSlfInvoiceName(invoiceDetails?.service_name_in_invoice)
                setInvoiceDetails([...invoiceDetails])
                setCompanyCIN(invoiceHeader?.partner_cin)
                setCompanyName(invoiceHeader?.partner_name?.toUpperCase())
                setQrCode(invoiceHeader?.qr_code)
                setcustomerCIN(invoiceHeader?.customer_cin)
                setCompanyGST(invoiceHeader?.partner_gstin)
                setCompanyPhone(invoiceHeader?.partner_phone)
                setCompanyAddress(invoiceHeader?.partner_address)
                // setCompanyLogo(invoiceHeader?.partner_logo)
                setcustomerName(invoiceHeader?.customer_name)
                setContractNo(invoiceMaster?.contract_number)
                setcustomerGSTIN(invoiceHeader?.customer_gstin)
                setcustomerPAN(invoiceHeader?.customer_pan)
                setIRN(invoiceHeader?.irn_number)
                setAckNo(invoiceHeader?.gst_portal_ack_no)
                setAckDate(formatDateBasedOnValue(formatDateView(invoiceHeader?.gst_portal_ack_date)))
                setCompanyAddress(formattedAddress);
                setcustomerAddress(formattedAddressC)
                setcustomerPlaceOfSupply(invoiceMaster?.pos_state)
                setPartnerBillDate(formatDateBasedOnValue(formatDateView(invoiceHeader?.issue_date)))
                setPartnerDueDate(formatDateBasedOnValue(formatDateView(invoiceMaster?.payment_due_date)))
                setPartnerState(stateVariable)
                setPartnerPAN(invoiceHeader?.partner_pan)
                setPartnerCIN(invoiceHeader?.partner_cin)
                setInvoiceNo(invoiceHeader?.invoice_number)
                setPartnerStateCode(invoiceHeader?.partner_gstin.substring(0, 2))
                setcustomerStateCode(invoiceHeader?.customer_gstin.substring(0, 2))
                setBasicAmount(invoiceMaster?.total_basic_amount)
                setTotalAmount(invoiceMaster.gross_amount)
                setTotalAmountInWords(invoiceMaster?.amount_in_words);
                setTimeout(() => {
                    setIsLoading(false)
                })
                setToggleShippingAddress(true)
                let companyAddress = invoiceHeader?.partner_address?.replace(/;;/g, ', ');
                let customerAddress = invoiceHeader?.customer_address?.replace(/;;/g, ', ');
                let billingAddress = invoiceHeader?.billing_address?.replace(/;;/g, ', ');
                let shippingAddress = invoiceHeader?.shipping_address?.replace(/;;/g, ', ');
                setCompanyAddress(companyAddress)
                setcustomerAddress(billingAddress)
                setShippingAddress(shippingAddress)
            })
            .catch(error => {
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_GST_SUBMIT_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_FAILURE,
                            payload: null
                        })
                    }
                }])
                setIsLoading(false)
            })
        // setCurrentPage(9)
        setInvoicePage(true)
        if (type === "electricity") {
            setCurrentPage(2)
        } else if (type === "water") {
            setCurrentPage(4)
        } else if (type === "slf") {
            setCurrentPage(5)
        } else if (type === "fms") {
            setCurrentPage(6)
        }
        else if (type === "miscellaneous") {
            setCurrentPage(7)
        } else {
            setCurrentPage(8)
        }

    }

    const checkSendForApprovalValidation = () => {
        if (toggleShippingAddress) {
            // return streetAddress && city && state && pincode && streetAddress !== "" && city !== "" && state !== "" && pincode !== "" && pincode.length === 6
            return true
        } else {
            return true
        }
    }

    const sendForApproval = () => {
        setIsLoading(true)
        const body = {
            "invoice_number": invoiceNo,
            "invoice_id": invoiceId,
            // "bill_from": companyName,
            // "payment_terms": paymentToggle,
            // "terms_and_conditions": termsToggle,
            // "notes": userNotes,
            "status": "approved"
        }
        // if (toggleShippingAddress) {
        //     body.shipping_address = {
        //         "street_address": streetAddress,
        //         "city": city,
        //         "state": state,
        //         "postal_code": pincode
        //     }
        // }
        dispatch({
            type: PUT_INVOICE_DATA_SUCCESS,
            payload: null
        })
        setInvoiceStatusTo('approved')
        dispatch(putInvoiceData(body))
    }

    const rejectAnInvoice = () => {
        const body = {
            "invoice_number": invoiceNo,
            "invoice_id": invoiceId,
            'rejected_reason': rejectReason,
            "status": "rejected"
        }
        dispatch({
            type: PUT_INVOICE_DATA_SUCCESS,
            payload: null
        })
        setInvoiceStatusTo('rejected')
        dispatch(putInvoiceData(body))
    }

    const holdInvoice = () => {
        const body = {
            "invoice_number": invoiceNo,
            "invoice_id": invoiceId,
            "status": "onhold"
        }
        dispatch({
            type: PUT_INVOICE_DATA_SUCCESS,
            payload: null
        })
        setInvoiceStatusTo('onhold')
        dispatch(putInvoiceData(body))
    }

    const handleReject = () => {
        setRejectModal(true)
    }
    const handleHold = () => {
        setAlertShow(true)
        setAlertType('question')
        setAlertMessage('')
        setAlertValue('Do you want to put this invoice On-hold?')
        setAlertButtons([{
            name: 'Close', action: () => {
                setAlertShow(false)
                dispatch({
                    type: PUT_ADD_MISC_INVOICE_SUCCESS,
                    payload: null
                })
                dispatch({
                    type: PUT_GST_SUBMIT_SUCCESS,
                    payload: null
                })
                dispatch({
                    type: PUT_ADD_MISC_INVOICE_FAILURE,
                    payload: null
                })
            }
        },
        {
            name: 'Proceed', action: () => {
                setAlertShow(false)
                holdInvoice()
            }
        }
        ])
    }
    const handleRegenerate = () => {
        setAlertShow(true)
        setAlertType('question')
        setAlertMessage('')
        setAlertValue('Do you want to regenerate this invoice?')
        setAlertButtons([{
            name: 'Close', action: () => {
                setAlertShow(false)
                dispatch({
                    type: PUT_ADD_MISC_INVOICE_SUCCESS,
                    payload: null
                })
                dispatch({
                    type: PUT_GST_SUBMIT_SUCCESS,
                    payload: null
                })
                dispatch({
                    type: PUT_ADD_MISC_INVOICE_FAILURE,
                    payload: null
                })
            }
        },
        {
            name: 'Proceed', action: () => {
                setAlertShow(false)
                regenerateInvoice()
            }
        }
        ])
    }
    const regenerateInvoice = () => {
        const body = {
            "invoice_number": invoiceNo,
        }
        dispatch({
            type: REGENERATE_INVOICE_DATA_SUCCESS,
            payload: null
        })
        setInvoiceStatusTo('draft')
        dispatch(regenerateAnInvoice(body))
    }

    const editInvoice = () => {
        setAlertShow(true)
        setAlertType('question')
        setAlertMessage('')
        setAlertValue('Do you approve this invoice?')
        setAlertButtons([{
            name: 'Close', action: () => {
                setAlertShow(false)
                dispatch({
                    type: PUT_ADD_MISC_INVOICE_SUCCESS,
                    payload: null
                })
                dispatch({
                    type: PUT_GST_SUBMIT_SUCCESS,
                    payload: null
                })
                dispatch({
                    type: PUT_ADD_MISC_INVOICE_FAILURE,
                    payload: null
                })
            }
        },
        {
            name: 'Proceed', action: () => {
                setAlertShow(false)
                sendForApproval()
            }
        }
        ])
    }


    const numberComponent = (value) => {
        let x = value?.toString();
        let afterPoint = '';
        if (x?.indexOf('.') > 0)
            afterPoint = x?.substring(x?.indexOf('.'), x?.length);
        x = Math.floor(x);
        x = x?.toString();
        let lastThree = x?.substring(x.length - 3);
        let otherNumbers = x?.substring(0, x.length - 3);
        if (otherNumbers !== '')
            lastThree = ',' + lastThree;
        let res = otherNumbers?.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree + afterPoint;
        return res;
    };

    const formatterComponent = (value) => {
        const nFormat = new Intl.NumberFormat()
        const formattedNumber = nFormat.format(value)
        return formattedNumber
    }

    const handleMiscDueDateChange = (e) => {
        setMiscDueDate(e.target.value)
    }

    function numberToIndianWords(number) {
        const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
        const teens = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
        const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

        if (number === 0) {
            return 'zero';
        }

        function convertLessThanThousand(num) {
            let str = '';
            if (num >= 100) {
                str += ones[Math.floor(num / 100)] + ' hundred ';
                num %= 100;
            }
            if (num >= 20) {
                str += tens[Math.floor(num / 10)] + ' ';
                num %= 10;
            }
            if (num > 0) {
                if (num < 10) {
                    str += ones[num];
                } else {
                    str += teens[num - 10];
                }
            }
            return str.trim();
        }

        function convert(num) {
            let str = '';
            if (num >= 10000000) {
                str += convert(Math.floor(num / 10000000)) + ' crore ';
                num %= 10000000;
            }
            if (num >= 100000) {
                str += convertLessThanThousand(Math.floor(num / 100000)) + ' lakh ';
                num %= 100000;
            }
            if (num >= 1000) {
                str += convertLessThanThousand(Math.floor(num / 1000)) + ' thousand ';
                num %= 1000;
            }
            if (num > 0) {
                str += convertLessThanThousand(num);
            }
            return str.trim();
        }

        const numArray = number?.toString().split('.');
        const wholeNumberPart = parseInt(numArray[0]);
        const decimalPart = parseInt(numArray[1] || 0);

        let result = convert(wholeNumberPart);
        if (decimalPart !== 0) {
            result += ' and ' + convert(decimalPart) + " paisa only ";
        }

        function capitalizeFirstLetter(str) {
            return str.charAt(0)?.toUpperCase() + str.slice(1);
        }

        return capitalizeFirstLetter(result);
    }

    //sorting functions 
    const sortInvoiceNo = () => {
        const sortedData = filteredData?.sort((a, b) => {
            if (sortOrder) {
                return a.invoice_number?.localeCompare(b.invoice_number);
            } else {
                return b.invoice_number?.localeCompare(a.invoice_number);
            }
        })
        setFilteredData([...sortedData]);
        setSortOrder(!sortOrder);
    }

    const sortInvoiceType = () => {
        const sortedData = filteredData?.sort((a, b) => {
            if (sortOrder) {
                return a.invoice_type?.localeCompare(b.invoice_type);
            } else {
                return b.invoice_type?.localeCompare(a.invoice_type);
            }
        })
        setFilteredData([...sortedData]);
        setSortOrder(!sortOrder);
    }

    const sortCompanyName = () => {
        const sortedData = filteredData?.sort((a, b) => {
            if (sortOrder) {
                return a.user_name?.localeCompare(b.user_name);
            } else {
                return b.user_name?.localeCompare(a.user_name);
            }
        })
        setFilteredData([...sortedData]);
        setSortOrder(!sortOrder);
    }

    const sortBillingPeriod = () => {
        const sortedData = filteredData?.sort((a, b) => {
            if (sortOrder) {
                return a.billing_period?.localeCompare(b.billing_period);
            } else {
                return b.billing_period?.localeCompare(a.billing_period);
            }
        })
        setFilteredData([...sortedData]);
        setSortOrder(!sortOrder);
    }

    const sortPreviousInvoiceAmount = () => {
        const sortedData = filteredData?.sort((a, b) => {
            if (sortOrder) {
                return parseFloat(a.previous_amount) - parseFloat(b.previous_amount);
            } else {
                return parseFloat(b.previous_amount) - parseFloat(a.previous_amount);
            }
        })
        setFilteredData([...sortedData]);
        setSortOrder(!sortOrder);
    }

    const sortCurrentInvoiceAmount = () => {
        const sortedData = filteredData?.sort((a, b) => {
            if (sortOrder) {
                return parseFloat(a.amount) - parseFloat(b.amount);
            } else {
                return parseFloat(b.amount) - parseFloat(a.amount);
            }
        })
        setFilteredData([...sortedData]);
        setSortOrder(!sortOrder);
    }

    const sortUpdatedBy = () => {
        const sortedData = filteredData?.sort((a, b) => {
            if (sortOrder) {
                return a.updated_by?.localeCompare(b.updated_by);
            } else {
                return b.updated_by?.localeCompare(a.updated_by);
            }
        })
        setFilteredData([...sortedData]);
        setSortOrder(!sortOrder);
    }

    const sortUpdatedOn = () => {
        const sortedData = filteredData?.sort((a, b) => {
            if (sortOrder) {
                return a.updated_on?.localeCompare(b.updated_on);
            } else {
                return b.updated_on?.localeCompare(a.updated_on);
            }
        })
        setFilteredData([...sortedData]);
        setSortOrder(!sortOrder);
    }

    const sortHeldBy = () => {
        const sortedData = filteredData?.sort((a, b) => {
            if (sortOrder) {
                return a.held_by?.localeCompare(b.held_by);
            } else {
                return b.held_by?.localeCompare(a.held_by);
            }
        })
        setFilteredData([...sortedData]);
        setSortOrder(!sortOrder);
    }

    const sortRejectedBy = () => {
        const sortedData = filteredData?.sort((a, b) => {
            if (sortOrder) {
                return a.rejected_by?.localeCompare(b.rejected_by);
            } else {
                return b.rejected_by?.localeCompare(a.rejected_by);
            }
        })
        setFilteredData([...sortedData]);
        setSortOrder(!sortOrder);
    }

    const handleShippingAddressToggle = () => {
        setShippingAddressToggle(!shippingAddressToggle);
    };
    const handleShippingCompanyNameChange = (event) => {
        setShippingCompanyName(event.target.value);
    };

    const handleShippingCompanyAddressChange = (event) => {
        setShippingCompanyAddress(event.target.value);
    };


    const handleSearchSubmit = (searchValue) => {
        if (validateValue(searchValue)) {
            setSearchText(searchValue);
            dispatch(getAllInvoices({
                page: 1 && 1, limit: RECORDS_PER_PAGE, facility_id: selectedFacilityId,
                invoiceType: selectedStatus, searchText: searchValue, invoiceSelected, periods, selectedCustomer,
                paymentStatus: selectedPaymentStatus
            }))
        }
    };

    const backFunction = () => {
        setInvoicePaymentDetails(null)
        setCreditNoteList([])
        setDebitNoteList([])
        setCreateCreditNoteClicked(false)
        setCurrentPage(1)
        setServiceNameInInvoice('')
        setInvoiceId('')
        setPreview(false)
        setIgstToggle(false)
        setPaymentToggle(false)
        setTermsToggle(false)
        setUserNotesToggle(false)
        setUserNotes("")
        setUserNotesError("")
        setShippingAddressToggle(false)
        setShippingCompanyName("")
        setShippingCompanyAddress("")
        setMiscService("")
        setMiscDescription("")
        setMiscBasicAmount(null)
        setMiscDueDate("")
        setCompanyName("")
        setInvoiceDetails([])
        setCompanyCIN("")
        setCompanyGST("")
        setCompanyPhone("")
        setCompanyAddress("")
        setCompanyLogo("")
        setcustomerName("")
        setContractNo("")
        setcustomerGSTIN("")
        setcustomerPAN("")
        setIRN("")
        setAckNo("")
        setAckDate("")
        setCompanyAddress("")
        setcustomerAddress("")
        setcustomerPlaceOfSupply("")
        setPartnerBillDate("")
        setPartnerDueDate("")
        setPartnerState("")
        setPartnerPAN("")
        setPartnerCIN("")
        setInvoiceNo("")
        setPartnerStateCode("")
        setcustomerStateCode("")
        setBasicAmount("")
        setTotalAmount("")
        setTotalAmountInWords("")
        setTotalCgst(0)
        setTotalSgst(0)
        setTotalIgst(0)
        setInvoiceStatus("")
        setToggleShippingAddress(false)
        setStreetAddress("")
        setCity("")
        setState("")
        setPincode("")
        setApprovalType('')
        setInvoiceStatusTo('')
        setpdfDataForPayments('')
        setpdfDataForTerms('')
        setcustomerCIN('')
        setRejectReason('')
        setShowComputationDetails(false)
        setShowPaymentDetails(false)
        setShowTermsDetails(false)

        //for misc invoice 
        setMiscInvoiceTable([{
            service: "", hsn: "", hsnError: false, hsnLoader: false, hsnMsg: '', basicAmount: 0.0, cgst: 9.0, sgst: 9.0, igst: 18.0, gross: 0.0,
            consumption: 0.0, rate_per_unit: 0.0, from_date: '', to_date: ''
        }])
        setMiscListOfContacts([])
        setMiscIgstOptions([...taxPercentageOptions])
        setContractsDropdown([])
        setBillingEntityDropdown(null)
        setBillingEntityOptions([])
        setMiscPlaceOfSupply(null)
        setMiscContractName(null)
        setMiscTotalBasicAmount(0.0)
        setMiscTotalTaxAmount(0.0)
        setMiscCgstSgstOptions(() => {
            const options = []
            taxPercentageOptions.forEach(each => {
                options.push(parseFloat(each / 2))
            })
            return options
        })
        setTermsAndConditions(null)
        setUploadedFiles([])
        setEditMiscInvoiceClicked(false)
        setCompanyAddress('')
        setcustomerAddress('')
        setShippingAddress('')
        setDownloadPath('')
        setQrCode('')
        setMiscShowBilling(false)
        setMiscShowComputations(false)
        setInvoicePage(false)
        setSelectedInvoiceTab(1)

    }

    function getMonthName(monthNumber) {

        const monthValuesRecord = {
            1: 'January',
            2: 'February',
            3: 'March',
            4: 'April',
            5: 'May',
            6: 'June',
            7: 'July',
            8: 'August',
            9: 'September',
            10: 'October',
            11: 'November',
            12: 'December'
        };
        return monthValuesRecord[monthNumber];
    }

    function base64ToArrayBuffer(base64) {
        const binaryString = window.atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    }

    const numberToMonth = (month) => {
        const mapDict = {
            1: 'Jan',
            2: 'Feb',
            3: 'Mar',
            4: 'Apr',
            5: 'May',
            6: 'Jun',
            7: 'Jul',
            8: 'Aug',
            9: 'Sep',
            10: 'Oct',
            11: 'Nov',
            12: 'Dec'
        }
        return mapDict[month]
    }

    const handleExportInvoiceMasterClicked = () => {
        // const month = format(biilingPeriodFilter, 'MMMM yyyy');
        // const fullYear = format(biilingPeriodFilter, 'yyyy');
        // const monthNumber = new Date(month + ' 1, ' + fullYear).getMonth() + 1;
        setIsLoading(true);

        const monthNumber = billingMonthFilter;
        const fullYear = billingYearFilter;

        const data = {
            search_text: searchText,
            invoice_type: invoiceSelected === '' ? undefined : invoiceSelected,
            payment_status: selectedPaymentStatus === '' ? undefined : selectedPaymentStatus,
            filter_condition: JSON.stringify({
                facility_id: localStorage.getItem("selected_facility_id"),
                status: invoiceType === 'all' ? undefined : invoiceType,
                start_month: periods.length > 1 ? periods[0]?.month + 1 : undefined,
                start_year: periods.length > 1 ? periods[0]?.year : undefined,
                end_month: periods.length > 1 ? periods[periods.length - 1]?.month + 1 : undefined,
                end_year: periods.length > 1 ? periods[periods.length - 1]?.year : undefined,
                invoice_year: periods.length === 1 ? periods[0]?.year : undefined,
                invoice_month: periods.length === 1 ? periods[0]?.month + 1 : undefined,
                customer_id: selectedCustomer ? selectedCustomer : undefined,
            }),
        };

        axios.get(`${base_url}analytics/invoiceDataExport`,
            {
                params: data,
            }
        )
            .then((response) => {
                if (periods.length > 1) {
                    var periodString = `from_${numberToMonth(periods[0]?.month + 1)}${periods[0]?.year}_to_${numberToMonth(periods[periods.length - 1]?.month + 1)}${periods[periods.length - 1]?.year}`;
                }
                else if (periods.length == 1) {
                    var periodString = `of_${numberToMonth(periods[0]?.month + 1)}${periods[0]?.year}`;
                }
                const company = companyList?.find(company => company.customer_id === selectedCustomer)
                const companyName = company?.company_name
                setIsLoading(false);
                const url = window.URL.createObjectURL(
                    new Blob([base64ToArrayBuffer(response.data.data)], {
                        type: "application/xlsx",
                    })
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `Invoice_master_for_city_${localStorage.getItem("selected_city_name")}_facility_${localStorage.getItem("selected_facility_name")}_${invoiceSelected ? invoiceSelected : "All"}_invoices_${periodString}${companyName ? `_of_${companyName}` : ''}${selectedPaymentStatus ? `_with_${selectedPaymentStatus}_payment` : ""}.xlsx`);
                document.body.appendChild(link);
                link.click();
                setAlertShow(true);
                setAlertType('success');
                setAlertMessage('Success');
                setAlertValue('Invoice Master Exported Successfully');
                setAlertButtons([
                    {
                        name: 'Close', action: () => {
                            setAlertShow(false);
                        }
                    },
                ]);
            })
            .catch((error) => {
                setIsLoading(false);
                setAlertShow(true);
                setAlertType('error');
                setAlertMessage('Error');
                setAlertValue(error?.response?.data?.message || 'Failed to export Invoice Master');
                setAlertButtons([
                    {
                        name: 'Close', action: () => {
                            setAlertShow(false);
                        }
                    },
                ]);

                console.log(error)
            }
            )

    }

    // ======================================= Filter setup=================


    function formatPeriodRange(periods) {
        if (!periods || periods.length === 0) return "";
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        periods.sort((a, b) => {
            if (a.year === b.year) {
                return a.month - b.month;
            }
        });
        if (periods.length === 1) {
            const single = periods[0];
            return `${monthNames[single.month]}’${String(single.year).slice(-2)}`;
        }
        const start = periods[0];
        const end = periods[periods.length - 1];
        return `${monthNames[start.month]}’${String(start.year).slice(-2)} - ${monthNames[end.month]}’${String(end.year).slice(-2)}`;
    }
    const [filters, setFilters] = useState([
        `${localStorage.getItem("selected_city_name")}, ${localStorage.getItem("selected_facility_name")}`,
        "All Customers",
        "All Invoices",
        "May’25 - Oct’25",
    ]);

    const [filterItems, setFilterItems] = useState([])

    useEffect(() => {
        const monthNumber = dayjs().month();
        const yearNumber = dayjs().year();
        const items = []
        items.push({
            name: 'facility name',
            id: "facility",
            value: selectedFacilityFilter,
            clearable: false,
        });
        if (selectedCustomerFilter && selectedCustomerFilter !== '') {
            items.push({
                name: 'customer',
                id: "customer",
                value: selectedCustomerFilter,
                clearable: true,
            });
        }
        if (periodsFilter && periodsFilter.length > 0) {
            const isCurrentMonthOnly = periodsFilter.length === 1 && periodsFilter[0].month === monthNumber && periodsFilter[0].year === yearNumber;
            items.push({
                name: 'billing period',
                id: "billing period",
                value: formatPeriodRange(periodsFilter),
                clearable: !isCurrentMonthOnly,
            });
        }
        if (selectedInvoiceSelectedFilter && selectedInvoiceSelectedFilter !== 'all') {
            items.push({
                name: 'invoice Selected',
                id: "invoice Selected",
                value: selectedInvoiceSelectedFilter,
                clearable: true,
            });
        }
        if (selectedPaymentFilter && selectedPaymentFilter !== '') {
            items.push({
                name: 'payment status',
                id: "payment status",
                value: selectedPaymentFilter,
                clearable: true,
            });
        }

        setFilterItems(items)
    }, [selectedCustomerFilter, selectedStatusFilter, selectedFacilityFilter, periodsFilter, selectedInvoiceSelectedFilter, selectedPaymentFilter]);

    // ======================================= city-facility filter setup=================

    const [facilityList, setFacilityList] = useState([]);

    useEffect(() => {
        if (facilitiesListForNav) {
            const options = facilitiesListForNav?.map((facility) => `${facility.city}, ${facility.name}`);
            setFacilityList(options);
        }
    }, [facilitiesListForNav]);

    const [selectedFacility, setSelectedFacility] = useState(`${localStorage.getItem("selected_city_name")}, ${localStorage.getItem("selected_facility_name")}`);
    const [selectedFacilityId, setSelectedFacilityId] = useState(localStorage.getItem("selected_facility_id"));
    const [selectedFacilityName, setSelectedFacilityName] = useState(localStorage.getItem("selected_facility_name"));
    const [selectedCityName, setSelectedCityName] = useState(localStorage.getItem("selected_city_name"));
    const [createCreditNoteClicked, setCreateCreditNoteClicked] = useState(false);

    // ================================================================



    const handleInvoiceItemChange = (id, field, value) => {
        setInvoiceDetails(prev =>
            prev.map(item =>
                item.id === id ? { ...item, [field]: value } : item
            )
        );
    };

    const InvoiceHistoryTimeline = () => {
        return (
            <div className="timeline-wrapper" style={{ position: "relative", }}>
                <div
                    className="timeline-line"
                    style={{
                        position: "absolute",
                        left: 16,
                        width: 3,
                        top: 10,
                        height: `${Math.max(invoiceHistoryEvents.length * 100, 40)}px`,
                        backgroundColor: "#d3d3d3",
                        zIndex: 0,
                    }}
                />
                <div className="timeline-container">
                    {invoiceHistoryEvents.map((evt, i) => (
                        <div className="timeline-item" key={i}>
                            <div className="timeline-icon" style={{
                                backgroundColor: evt.icon_type === 'payment' ? '#A9D4A0' : evt.icon_type === 'creditAndDebit' ? '#E3B7B7' : '#F3F09E'
                            }}>
                                {evt.icon_type === 'payment' && <img src="./images/icons/invoice-payment.svg" alt="edit-icon" />}
                                {evt.icon_type === 'creditAndDebit' && <img src="./images/icons/credit-icon.svg" alt="edit-icon" />}
                                {evt.icon_type === 'invoice' && <img src="./images/icons/invoice-created-icon.svg" alt="edit-icon" />}
                            </div>
                            <div className="timeline-content">
                                <div className="timeline-header">
                                    <span className="timeline-user">{evt.user}</span>
                                    <span className="timeline-time">{evt.time}</span>
                                </div>
                                <p className="timeline-text">{evt.text}</p>
                                {evt.history_type === "created" &&
                                    <p className="C-pointer" style={{
                                        color: "#007BFF",
                                        marginBottom: "0px",
                                        fontSize: "12px",
                                        display: "flex",
                                        alignItems: "center",

                                    }}><img className="mx-1" src="./images/icons/invoice-eye-icon.svg" alt="edit-icon" /> View the Invoice
                                    </p>}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const addCreditDebitNote = () => {
        const tableDetails = invoiceDetails?.map(each => {
            if (igstToggle) {
                return {
                    service_name_in_invoice: each.service,
                    hsn_code: each.hsn,
                    net_amount: parseFloat(each.basicAmount),
                    igst_rate: parseInt(each.igst),
                    consumption: parseFloat(each.consumption),
                    rate_per_unit: parseFloat(each.rate_per_unit),
                    from_date: each.from_date,
                    to_date: each.to_date
                }
            } else {
                return {
                    service_name_in_invoice: each.service,
                    hsn_code: each.hsn,
                    net_amount: parseFloat(each.basicAmount),
                    cgst_rate: parseFloat(each.cgst),
                    sgst_rate: parseFloat(each.sgst),
                    consumption: parseFloat(each.consumption),
                    rate_per_unit: parseFloat(each.rate_per_unit),
                    from_date: each.from_date,
                    to_date: each.to_date
                }
            }
        })

        const placeOfSupply = null;
        const billingEntity = billingEntityDropdown?.value;

        const data = {
            invoice_no: invoiceNo,
            invoice_type: invoiceType,
            invoice_details: tableDetails,
            place_of_supply: customerPlaceOfSupply,
            // billing_entity: billingEntity,
            // contract_name: contractName,
            // misc_list_of_contacts: listOfContacts,
            show_billing_period: miscShowBilling,
            show_computation_details: miscShowComputations,
        }
        dispatch(createNewCreditNote(data))
    }

    useEffect(() => {
        if (selectedInvoiceTab !== 1) {
            getInvoiceNotes()
        }
    }, [selectedInvoiceTab])


    const getInvoiceNotes = () => {
        setIsLoading(true)
        axios.get(`${base_url}invoices/getNoteByInvoice`, {
            params: {
                // filter_condition: JSON.stringify({
                invoice_id: invoiceId,
                note_type: cdType(selectedInvoiceTab).toLowerCase(),
                // })
            }
        })
            .then(res => {
                // setInvoiceNotes(response.data);
                const response = res.data.data
                const flattenedNotes = response.flatMap(item => item.note_details);
                if (selectedInvoiceTab === 2) {
                    setCreditNoteList(flattenedNotes)
                } else {
                    setDebitNoteList(flattenedNotes)
                }
                setIsLoading(false)
            })
            .catch(error => {
                console.error("Error fetching invoice notes:", error);
                setIsLoading(false)
            });
    };

    const TypesOfInvoiceCon = () => {
        return (
            <>
                <div className="fm-invoice-setting-con">
                    <div className="d-flex flex-column justify-content-between" style={{ height: '70vh' }}>
                        <div>
                            {invoiceTypeOptions.map((each, index) => (
                                <div
                                    key={index}
                                    className={`C-pointer d-flex justify-center align-items-center px-3 `}
                                    style={{
                                        backgroundColor: selectedInvoiceTab === each.value ? '#E2E8F0' : 'transparent',
                                        height: '40px',
                                        paddingTop: '9px',
                                    }}
                                    onClick={() => setSelectedInvoiceTab(each.value)}
                                >
                                    <div className="d-flex align-items-center justify-content-between w-100 m-auto">
                                        <p>{each.label}</p>
                                        <p>{'>'}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {invoicePaymentDetails && <div className="preview-cd-payments">
                            <p className="preview-cd-payments-title">Payments Summary:</p>

                            <p className="preview-cd-payments-row">
                                <span>Invoice Amount</span>
                                <span>{invoicePaymentDetails.invoiced_amount} {localStorage.getItem("currency_format")}</span>
                            </p>

                            <p className="preview-cd-payments-row">
                                <span>Amount Paid</span>
                                <span>{invoicePaymentDetails.total_received_amount} {localStorage.getItem("currency_format")}</span>
                            </p>

                            <p className="preview-cd-payments-row">
                                <span>TDS Amount</span>
                                <span>{invoicePaymentDetails.tds_amount} {localStorage.getItem("currency_format")}</span>
                            </p>

                            <div className="preview-cd-payments-due">
                                <span>Due Amount</span>
                                <span>{invoicePaymentDetails.amount_due} {localStorage.getItem("currency_format")}</span>
                            </div>
                        </div>}
                    </div>
                </div>
            </>
        )
    }

    const TypesOfInvoiceConCreate = () => {
        return (
            <>
                <div className="fm-invoice-setting-con">
                    <div className="d-flex flex-column justify-content-between" style={{ height: '70vh' }}>
                        <div>
                            <h1 className="invoice-setting-header">{cdType(selectedInvoiceTab)} Note</h1>
                            <div style={{ marginBottom: '3px', marginTop: '15px' }} className="fin_man_billing_period">
                                <p style={{ marginBottom: '-18px' }}>Invoice No:&nbsp;</p>
                                <input style={{ marginTop: '20px', height: '2.5rem' }} value={invoiceNo}
                                    // onChange={(e) => handleSearchSubmit(e.target.value)}
                                    disabled={true}
                                    className='fin_man_meter_search_bar' />
                            </div>
                        </div>
                        {/* <div className="preview-cd-payments">
                            <p className="preview-cd-payments-title">Payments Summary:</p>

                            <p className="preview-cd-payments-row">
                                <span>Invoice Amount</span>
                                <span>₹ 2,20,774.00</span>
                            </p>

                            <p className="preview-cd-payments-row">
                                <span>Amount Paid</span>
                                <span>00.00</span>
                            </p>

                            <p className="preview-cd-payments-row">
                                <span>Debit Amount</span>
                                <span>₹ 52,000.00</span>
                            </p>

                            <div className="preview-cd-payments-due">
                                <span>Due Amount</span>
                                <span>₹ 2,72,774.00</span>
                            </div>
                        </div> */}

                    </div>
                </div>
            </>
        )
    }

    const reusableInvoicePreviewCardDetails = () => {
        return (
            <>
                <div className="invoice-preview-card-details">
                    {companyLogo && <div className="invoice-logo-placeholder">
                        <div>
                            <img style={{ width: '15rem', height: '5rem' }} src={companyLogo} alt="company logo" />
                        </div>
                    </div>}
                    <div className="d-flex justify-content-between w-100">
                        <div className="invoice-header-address">
                            <h5
                                className="invoice-header-title"
                                style={{
                                    fontSize: `${Math.max(40 - (companyName?.length ? companyName?.length * 0.3 : 1), 20)}px`
                                }}
                            >
                                {companyName?.toUpperCase()}

                            </h5>
                            <p style={{
                                textAlign: 'center'
                            }}><span ><b>Reg.Office:</b> {companyAddress}</span></p>
                        </div>
                        {
                            QrCode?.length > 0 ?
                                <QRCode style={{ marginTop: '-70px' }} value={QrCode} size={170} />
                                :
                                <div className="invoice-bar-code">
                                    {invoiceStatus === "rejected" ? (
                                        <p className="rejected-text">Rejected</p>
                                    ) : (
                                        <p className="qr-code-text">QR Code</p>
                                    )}
                                </div>
                        }

                    </div>
                    <h5 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>Tax Invoice</h5>
                    <h6 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>({serviceNameInInvoice})</h6>
                    <div className="invoice-preview-inner-card-div">
                        <div className="invoice-preview-inner-card">
                            <div style={{ width: '100%' }}>
                                <p>
                                    <b style={{ fontSize: "18px" }}>Buyer </b>
                                    <br /> <b>{customerName}</b><br />
                                    <div className="invoice-left-data">
                                        <span className="key"><b>Billed To</b></span>
                                        <span style={{ marginRight: '3px' }}>:</span>
                                        <span className="value"> {customerAddress}</span>
                                    </div>
                                    {toggleShippingAddress && <div className="invoice-left-data">
                                        <span className="key"><b>Shipped To</b></span>
                                        <span style={{ marginRight: '3px' }}>:</span>
                                        <span className="value">  {shippingAddress}</span>
                                    </div>}
                                    <div className="invoice-left-data">
                                        <span className="key"><b>State Code</b></span>
                                        <span style={{ marginRight: '3px' }}>:</span>
                                        <span className="value"> {customerStateCode}</span>
                                    </div>
                                    <div className="invoice-left-data">
                                        <span className="key"><b>GSTIN</b></span>
                                        <span style={{ marginRight: '3px' }}>:</span>
                                        <span className="value"> {customerGSTIN}</span>
                                    </div>
                                    <div className="invoice-left-data">
                                        <span className="key"><b>PAN</b></span>
                                        <span style={{ marginRight: '3px' }}>:</span>
                                        <span className="value"> {customerPAN}</span>
                                    </div>
                                    <div className="invoice-left-data">
                                        <span className="key"><b>CIN</b></span>
                                        <span style={{ marginRight: '3px' }}>:</span>
                                        <span className="value"> {customerCIN}</span>
                                    </div>
                                    <div className="invoice-left-data">
                                        <span className="key"><b>Place Of Supply</b></span>
                                        <span style={{ marginRight: '3px' }}>:</span>
                                        <span className="value"> {customerPlaceOfSupply}</span>
                                    </div>
                                </p>
                            </div>
                        </div>
                        <div className="invoice-address-right">
                            <div >
                                <br />
                                <p> <b>Contract No   </b> </p>
                                <p><b>Invoice No</b> </p>
                                <p><b>State</b></p>
                                <p><b>State Code</b> </p>
                                <p><b>GSTIN</b></p>
                                <p><b>PAN</b></p>
                                <p><b>CIN</b></p>
                                <br />
                                <p><b>Invoice Date</b></p>
                                <p><b>Due Date</b></p>

                            </div>
                            <div style={{ marginLeft: "20px" }}>
                                <br />
                                <p>: {contractNo}</p>
                                <p>: {invoiceNo}</p>
                                <p>: {parnterState}</p>
                                <p>: {partnerStateCode}</p>
                                <p>: {companyGST}</p>
                                <p>: {partnerPAN}</p>
                                <p>: {companyCIN}</p>

                                <br />
                                <p>: {ackDate}</p>
                                <p>: {partnerDueDate}</p>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="invoice-preview-card-details-bottom">
                    <div className="invoice-preview-inner-card-2">
                        <p><span><b>IRN :</b> </span>{IRN}<br />
                        </p>
                    </div>
                </div>
            </>
        )
    }

    const reusableInvoiceTable = () => {
        return (
            <>
                {/* electric invoice */}
                {currentPage === 2 &&
                    <Table className="invoice-preview-table">
                        <thead >
                            <tr >
                                <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                                <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                                <th colSpan={2}><b>Bill Period / Reading</b></th>
                                {showComputationDetails && <th colSpan={1}><b>Total Units</b></th>}
                                {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
                                {/* <th colSpan={1}><b>Meter Rent</b></th> */}
                                <th colSpan={1}><b>Basic Amount</b></th>
                                {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                                {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                                {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                                <th colSpan={1}><b>Gross</b></th>
                            </tr>
                            <tr>
                                <th>From / Op. Reading</th>
                                <th>To / Cl. Reading</th>

                                {showComputationDetails && <th>kWh</th>}
                                {showComputationDetails && <th>
                                    ({formatCurrencyBasedOnRegion()} / kWh)</th>}
                                {/* <th>Amount (INR)</th> */}
                                <th>Amount ({formatCurrencyBasedOnRegion()})</th>
                                {!igstToggle && <th>Rate (%)</th>}
                                {!igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                {!igstToggle && <th>Rate (%)</th>}
                                {!igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                {igstToggle && <th>Rate (%)</th>}
                                {igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                <th>Amount ({formatCurrencyBasedOnRegion()})</th>
                            </tr>
                        </thead>
                        <tbody >
                            {invoiceDetails?.map((item, index) => (
                                <tr key={index}>
                                    <th className="text-start">{item?.service_name_in_invoice?.toUpperCase()},<br />
                                        {item?.service_identifier}
                                    </th>
                                    <th className="text-start">{item?.hsn}</th>
                                    <th style={{ textAlign: 'end' }}>
                                        <div>
                                            <p style={{ marginBottom: '-5px' }}>{formatDateBasedOnValue(formatDateView(item.from_date))}
                                                <hr />
                                                {formatToIndianRupee(item.initial_reading)}
                                            </p>
                                        </div>
                                    </th>
                                    <th style={{ textAlign: 'end' }}><div>
                                        <p style={{ marginBottom: '-5px' }}>{formatDateBasedOnValue(formatDateView(item.to_date))}
                                            <hr />
                                            {formatToIndianRupee(item.final_reading)}
                                        </p>
                                    </div></th>
                                    {showComputationDetails && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.consumption)}</th>}
                                    {showComputationDetails && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.rate_per_unit)}</th>}
                                    {/* <th>-</th> */}
                                    <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.net_amount)}</th>
                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst_rate)}</th>}
                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst)}</th>}
                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst_rate)}</th>}
                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst)}</th>}
                                    {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst_rate)}</th>}
                                    {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst)}</th>}
                                    <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.gross_amount)}</th>
                                </tr>
                            ))}
                            {/* Grand Total */}
                            <tr >
                                {/* service description */}
                                <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
                                    Total
                                </th>
                                {/* sac/hsn */}
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                {/* basic amount */}
                                <th className="text-end">
                                    {formatToIndianRupee(basicAmount)}
                                </th>
                                {/* sgst rate*/}
                                {!igstToggle && <th>

                                </th>}
                                {/* sgst amount*/}
                                {!igstToggle && <th className="text-end">
                                    {formatToIndianRupee(totalSgst)}
                                </th>}
                                {/* cgst rate*/}
                                {!igstToggle && <th>

                                </th>}
                                {/* cgst amount*/}
                                {!igstToggle && <th className="text-end">
                                    {formatToIndianRupee(totalCgst)}
                                </th>}
                                {/* igst rate*/}
                                {igstToggle && <th>

                                </th>}
                                {/* igst amount*/}
                                {igstToggle && <th className="text-end">{formatToIndianRupee(totalIgst)}</th>}
                                {/* gross amount */}
                                <th className="text-end">
                                    {formatToIndianRupee(TotalAmount)}
                                    {/* parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.igst)) : formatToIndianRupee(parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.cgst) + parseFloat((each.basicAmount / 100) * each.sgst))} */}
                                </th>
                            </tr>
                        </tbody>
                    </Table>
                }
                {/* FMS invoice */}
                {currentPage === 6 &&
                    <Table className="invoice-preview-table">
                        <thead>
                            <tr>
                                <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                                <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                                <th colSpan={2}><b>Bill Period </b></th>
                                {showComputationDetails && <th colSpan={1}><b>Total Area</b></th>}
                                {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
                                <th colSpan={1}><b>Basic Amount</b></th>
                                {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                                {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                                {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                                <th colSpan={1}><b>GROSS</b></th>
                            </tr>
                            <tr>

                                <th>From</th>
                                <th>To</th>
                                {showComputationDetails && <th>Sq. ft</th>}
                                {showComputationDetails && <th> ({formatCurrencyBasedOnRegion()} / Sq. ft)</th>}
                                <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                                {!igstToggle && <th>Rate <br /> (%)</th>}
                                {!igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                {!igstToggle && <th>Rate <br />(%)</th>}
                                {!igstToggle && <th>Amount<br /> ({formatCurrencyBasedOnRegion()})</th>}
                                {igstToggle && <th>Rate <br />(%)</th>}
                                {igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                            </tr>
                        </thead>
                        <tbody >
                            {invoiceDetails?.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <th className="text-start">{item?.service_name_in_invoice?.toUpperCase()},<br />
                                            {item?.service_identifier}
                                        </th>
                                        <th className="text-start">{item?.hsn}</th>
                                        <th style={{ textAlign: 'end', textWrap: 'nowrap' }}>{formatDateBasedOnValue(formatDateView(item.from_date))}</th>
                                        <th style={{ textAlign: 'end', textWrap: 'nowrap' }}>
                                            <div>
                                                {formatDateBasedOnValue(formatDateView(item.to_date))}
                                            </div>
                                        </th>
                                        {showComputationDetails && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.consumption)}</th>}
                                        {showComputationDetails && <th style={{ textAlign: 'end' }}><div>
                                            {formatToIndianRupee(item.rate_per_unit)}
                                        </div></th>}
                                        <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.net_amount)}</th>

                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst_rate)}</th>}
                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst)}</th>}
                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst_rate)}</th>}
                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst)}</th>}
                                        {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst_rate)}</th>}
                                        {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst)}</th>}
                                        <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.gross_amount)}</th>
                                    </tr>
                                )
                            })
                            }
                            {/* Grand Total */}
                            <tr >
                                {/* service description */}
                                <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
                                    Total
                                </th>
                                {/* sac/hsn */}
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                {showComputationDetails &&
                                    <>
                                        <th className="text-start">
                                        </th>
                                        <th className="text-start">
                                        </th>
                                    </>}

                                {/* basic amount */}
                                <th className="text-end">
                                    {formatToIndianRupee(basicAmount)}
                                </th>
                                {/* sgst rate*/}
                                {!igstToggle && <th>

                                </th>}
                                {/* sgst amount*/}
                                {!igstToggle && <th className="text-end">
                                    {formatToIndianRupee(totalSgst)}
                                </th>}
                                {/* cgst rate*/}
                                {!igstToggle && <th>

                                </th>}
                                {/* cgst amount*/}
                                {!igstToggle && <th className="text-end">
                                    {formatToIndianRupee(totalCgst)}
                                </th>}
                                {/* igst rate*/}
                                {igstToggle && <th>

                                </th>}
                                {/* igst amount*/}
                                {igstToggle && <th className="text-end">{formatToIndianRupee(totalIgst)}</th>}
                                {/* gross amount */}
                                <th className="text-end">
                                    {formatToIndianRupee(TotalAmount)}
                                    {/* parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.igst)) : formatToIndianRupee(parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.cgst) + parseFloat((each.basicAmount / 100) * each.sgst))} */}
                                </th>
                            </tr>
                        </tbody>
                    </Table>}
                {/* water invoice */}
                {currentPage === 4 &&
                    <Table className="invoice-preview-table">
                        <thead>
                            <tr>
                                <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                                <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                                <th colSpan={2}><b>Bill Period / Reading</b></th>
                                {showComputationDetails && <th colSpan={1}><b>Total Units</b></th>}
                                {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
                                {/* <th colSpan={1}><b>Meter Rent</b></th> */}
                                <th colSpan={1}><b>Basic Amount</b></th>
                                {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                                {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                                {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                                <th colSpan={1}><b>GROSS</b></th>
                            </tr>
                            <tr>
                                <th>From / Op. Reading</th>
                                <th>To / Cl. Reading</th>
                                {showComputationDetails && <th>kL</th>}
                                {showComputationDetails && <th>({formatCurrencyBasedOnRegion()} / kL)</th>}
                                <th>Amount ({formatCurrencyBasedOnRegion()})</th>
                                {/* <th>Amount (INR)</th> */}
                                {!igstToggle && <th>Rate (%)</th>}
                                {!igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                {!igstToggle && <th>Rate (%)</th>}
                                {!igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                {igstToggle && <th>Rate (%)</th>}
                                {igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                <th>Amount ({formatCurrencyBasedOnRegion()})</th>
                            </tr>
                        </thead>
                        <tbody >
                            {invoiceDetails?.map((item, index) => (
                                <tr key={index}>
                                    <th className="text-start">{item?.service_name_in_invoice?.toUpperCase()},<br />
                                        {item?.service_identifier}</th>
                                    <th className="text-start">{item?.hsn}</th>
                                    <th style={{ textAlign: 'end' }}>
                                        <div>
                                            <p style={{ marginBottom: '-5px', textWrap: 'nowrap' }}>{formatDateBasedOnValue(formatDateView(item.from_date))}
                                                <hr />
                                                {formatToIndianRupee(item.initial_reading)}
                                            </p>
                                        </div>
                                    </th>
                                    <th style={{ textAlign: 'end' }}><div>
                                        <p style={{ marginBottom: '-5px' }}>{formatDateBasedOnValue(formatDateView(item.to_date))}
                                            <hr />
                                            {formatToIndianRupee(item.final_reading)}
                                        </p>
                                    </div></th>
                                    {showComputationDetails && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.consumption)}</th>}
                                    {showComputationDetails && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.rate_per_unit)}</th>}
                                    {/* <th>-</th> */}
                                    <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.net_amount)}</th>
                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst_rate)}</th>}
                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst)}</th>}
                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst_rate)}</th>}
                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst)}</th>}
                                    {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst_rate)}</th>}
                                    {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst)}</th>}
                                    <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.gross_amount)}</th>
                                </tr>
                            ))}
                            {/* Grand Total */}
                            <tr >
                                {/* service description */}
                                <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
                                    Total
                                </th>
                                {/* sac/hsn */}
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                {/* basic amount */}
                                <th className="text-end">
                                    {formatToIndianRupee(basicAmount)}
                                </th>
                                {/* sgst rate*/}
                                {!igstToggle && <th>

                                </th>}
                                {/* sgst amount*/}
                                {!igstToggle && <th className="text-end">
                                    {formatToIndianRupee(totalSgst)}
                                </th>}
                                {/* cgst rate*/}
                                {!igstToggle && <th>

                                </th>}
                                {/* cgst amount*/}
                                {!igstToggle && <th className="text-end">
                                    {formatToIndianRupee(totalCgst)}
                                </th>}
                                {/* igst rate*/}
                                {igstToggle && <th>

                                </th>}
                                {/* igst amount*/}
                                {igstToggle && <th className="text-end">{formatToIndianRupee(totalIgst)}</th>}
                                {/* gross amount */}
                                <th className="text-end">
                                    {formatToIndianRupee(TotalAmount)}
                                    {/* parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.igst)) : formatToIndianRupee(parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.cgst) + parseFloat((each.basicAmount / 100) * each.sgst))} */}
                                </th>
                            </tr>
                        </tbody>
                    </Table>}
                {/* mics invoice */}
                {currentPage === 7 &&
                    <Table className="invoice-preview-table">
                        <thead>
                            <tr>
                                <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                                <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                                {miscShowBilling && <th colSpan={2}><b>Bill Period</b></th>}
                                {miscShowComputations && <th colSpan={1} rowSpan={2}><b>Total Units</b></th>}
                                {miscShowComputations && <th colSpan={1} rowSpan={2}><b>Rate</b></th>}
                                <th colSpan={1}><b>Basic Amount</b></th>
                                {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                                {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                                {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                                <th colSpan={1}><b>GROSS</b></th>
                            </tr>
                            <tr>
                                {miscShowBilling && <><th>From</th>
                                    <th>To</th>
                                </>}
                                <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                                {!igstToggle && <th>Rate <br /> (%)</th>}
                                {!igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                {!igstToggle && <th>Rate <br />(%)</th>}
                                {!igstToggle && <th>Amount<br /> ({formatCurrencyBasedOnRegion()})</th>}
                                {igstToggle && <th>Rate <br />(%)</th>}
                                {igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                            </tr>
                        </thead>
                        <tbody >
                            {invoiceDetails?.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <th className="text-start">{item?.service_name_in_invoice?.toUpperCase()},<br />
                                            {item?.service_identifier}
                                        </th>
                                        <th className="text-start">{item?.hsn}</th>
                                        {miscShowBilling && <th>{item?.from_date}</th>}
                                        {miscShowBilling && <th>{item?.to_date}</th>}
                                        {miscShowComputations && <th>{item?.consumption}</th>}
                                        {miscShowComputations && <th>{item?.rate_per_unit}</th>}
                                        <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.net_amount)}</th>

                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst_rate)}</th>}
                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst)}</th>}
                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst_rate)}</th>}
                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst)}</th>}
                                        {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst_rate)}</th>}
                                        {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst)}</th>}
                                        <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.gross_amount)}</th>
                                    </tr>
                                )
                            })
                            }
                            {/* Grand Total */}
                            <tr >
                                {/* service description */}
                                <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
                                    Total
                                </th>
                                {/* sac/hsn */}
                                <th className="text-start">
                                </th>
                                {miscShowBilling && <th className="text-start">
                                </th>}
                                {miscShowBilling && <th className="text-start">
                                </th>}
                                {miscShowComputations && <th className="text-start">
                                </th>}
                                {miscShowComputations && <th className="text-start">
                                </th>}
                                {/* basic amount */}
                                <th className="text-end">
                                    {formatToIndianRupee(basicAmount)}
                                </th>
                                {/* sgst rate*/}
                                {!igstToggle && <th>

                                </th>}
                                {/* sgst amount*/}
                                {!igstToggle && <th className="text-end">
                                    {formatToIndianRupee(totalSgst)}
                                </th>}
                                {/* cgst rate*/}
                                {!igstToggle && <th>

                                </th>}
                                {/* cgst amount*/}
                                {!igstToggle && <th className="text-end">
                                    {formatToIndianRupee(totalCgst)}
                                </th>}
                                {/* igst rate*/}
                                {igstToggle && <th>

                                </th>}
                                {/* igst amount*/}
                                {igstToggle && <th className="text-end">{formatToIndianRupee(totalIgst)}</th>}
                                {/* gross amount */}
                                <th className="text-end">
                                    {formatToIndianRupee(TotalAmount)}
                                    {/* parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.igst)) : formatToIndianRupee(parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.cgst) + parseFloat((each.basicAmount / 100) * each.sgst))} */}
                                </th>
                            </tr>
                        </tbody>
                    </Table>}
                {/* other invoices */}
                {currentPage === 8 && <Table className="invoice-preview-table">
                    <thead>
                        <tr>
                            <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                            <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                            <th colSpan={2}><b>Bill Period </b></th>
                            {showComputationDetails && <th colSpan={1}><b>Total Area</b></th>}
                            {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
                            <th colSpan={1}><b>Basic Amount</b></th>
                            {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                            {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                            {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                            <th colSpan={1}><b>GROSS</b></th>
                        </tr>
                        <tr>

                            <th>From</th>
                            <th>To</th>
                            {showComputationDetails && <th>Sq. ft</th>}
                            {showComputationDetails && <th> ({formatCurrencyBasedOnRegion()} / Sq. ft)</th>}
                            <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                            {!igstToggle && <th>Rate <br /> (%)</th>}
                            {!igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                            {!igstToggle && <th>Rate <br />(%)</th>}
                            {!igstToggle && <th>Amount<br /> ({formatCurrencyBasedOnRegion()})</th>}
                            {igstToggle && <th>Rate <br />(%)</th>}
                            {igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                            <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                        </tr>
                    </thead>
                    <tbody >
                        {invoiceDetails?.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <th className="text-start">{item?.service_name_in_invoice?.toUpperCase()},<br />
                                        {item?.service_identifier}
                                    </th>
                                    <th className="text-start">{item?.hsn}</th>
                                    <th style={{ textAlign: 'end' }}>{(formatDateBasedOnValue(formatDateView(item.from_date)))}</th>
                                    <th style={{ textAlign: 'end' }}>
                                        <div>
                                            {formatDateBasedOnValue(formatDateView(item.to_date))}
                                        </div>
                                    </th>
                                    {showComputationDetails && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.consumption)}</th>}
                                    {showComputationDetails && <th style={{ textAlign: 'end' }}><div>
                                        {formatToIndianRupee(item.rate_per_unit)}
                                    </div></th>}
                                    <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.net_amount)}</th>

                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst_rate)}</th>}
                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst)}</th>}
                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst_rate)}</th>}
                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst)}</th>}
                                    {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst_rate)}</th>}
                                    {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst)}</th>}
                                    <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.gross_amount)}</th>
                                </tr>
                            )
                        })
                        }
                        {/* Grand Total */}
                        <tr >
                            {/* service description */}
                            <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
                                Total
                            </th>
                            {/* sac/hsn */}
                            <th className="text-start">
                            </th>
                            <th className="text-start">
                            </th>
                            <th className="text-start">
                            </th>
                            <th className="text-start">
                            </th>
                            <th className="text-start">
                            </th>
                            {/* basic amount */}
                            <th className="text-end">
                                {formatToIndianRupee(basicAmount)}
                            </th>
                            {/* sgst rate*/}
                            {!igstToggle && <th>

                            </th>}
                            {/* sgst amount*/}
                            {!igstToggle && <th className="text-end">
                                {formatToIndianRupee(totalSgst)}
                            </th>}
                            {/* cgst rate*/}
                            {!igstToggle && <th>

                            </th>}
                            {/* cgst amount*/}
                            {!igstToggle && <th className="text-end">
                                {formatToIndianRupee(totalCgst)}
                            </th>}
                            {/* igst rate*/}
                            {igstToggle && <th>

                            </th>}
                            {/* igst amount*/}
                            {igstToggle && <th className="text-end">{formatToIndianRupee(totalIgst)}</th>}
                            {/* gross amount */}
                            <th className="text-end">
                                {formatToIndianRupee(TotalAmount)}
                                {/* parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.igst)) : formatToIndianRupee(parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.cgst) + parseFloat((each.basicAmount / 100) * each.sgst))} */}
                            </th>
                        </tr>
                    </tbody>
                </Table>}
                {/* slf invoice */}
                {currentPage === 5 &&
                    <Table className="invoice-preview-table">
                        <thead>
                            <tr>
                                <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                                <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                                <th colSpan={2}><b>Bill Period </b></th>
                                {showComputationDetails && <th colSpan={1}><b>Total Area</b></th>}
                                {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
                                <th colSpan={1}><b>Basic Amount</b></th>
                                {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                                {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                                {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                                <th colSpan={1}><b>GROSS</b></th>
                            </tr>
                            <tr>

                                <th>From</th>
                                <th>To</th>
                                {showComputationDetails && <th>Sq. ft</th>}
                                {showComputationDetails && <th> ({formatCurrencyBasedOnRegion()} / Sq. ft)</th>}
                                <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                                {!igstToggle && <th>Rate <br /> (%)</th>}
                                {!igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                {!igstToggle && <th>Rate <br />(%)</th>}
                                {!igstToggle && <th>Amount<br /> ({formatCurrencyBasedOnRegion()})</th>}
                                {igstToggle && <th>Rate <br />(%)</th>}
                                {igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                            </tr>
                        </thead>
                        <tbody >
                            {invoiceDetails?.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <th className="text-start">{item?.service_name_in_invoice?.toUpperCase()},<br />
                                            {item?.service_identifier}
                                        </th>
                                        <th className="text-start">{item?.hsn}</th>
                                        <th style={{ textAlign: 'end' }}>{(formatDateBasedOnValue(formatDateView(item.from_date)))}</th>
                                        <th style={{ textAlign: 'end' }}>
                                            <div>
                                                {formatDateBasedOnValue(formatDateView(item.to_date))}
                                            </div>
                                        </th>
                                        {showComputationDetails && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.consumption)}</th>}
                                        {showComputationDetails && <th style={{ textAlign: 'end' }}><div>
                                            {formatToIndianRupee(item.rate_per_unit)}
                                        </div></th>}
                                        <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.net_amount)}</th>

                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst_rate)}</th>}
                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst)}</th>}
                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst_rate)}</th>}
                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst)}</th>}
                                        {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst_rate)}</th>}
                                        {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst)}</th>}
                                        <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.gross_amount)}</th>
                                    </tr>
                                )
                            })
                            }
                            {/* Grand Total */}
                            <tr >
                                {/* service description */}
                                <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
                                    Total
                                </th>
                                {/* sac/hsn */}
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                {/* basic amount */}
                                <th className="text-end">
                                    {formatToIndianRupee(basicAmount)}
                                </th>
                                {/* sgst rate*/}
                                {!igstToggle && <th>

                                </th>}
                                {/* sgst amount*/}
                                {!igstToggle && <th className="text-end">
                                    {formatToIndianRupee(totalSgst)}
                                </th>}
                                {/* cgst rate*/}
                                {!igstToggle && <th>

                                </th>}
                                {/* cgst amount*/}
                                {!igstToggle && <th className="text-end">
                                    {formatToIndianRupee(totalCgst)}
                                </th>}
                                {/* igst rate*/}
                                {igstToggle && <th>

                                </th>}
                                {/* igst amount*/}
                                {igstToggle && <th className="text-end">{formatToIndianRupee(totalIgst)}</th>}
                                {/* gross amount */}
                                <th className="text-end">
                                    {formatToIndianRupee(TotalAmount)}
                                    {/* parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.igst)) : formatToIndianRupee(parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.cgst) + parseFloat((each.basicAmount / 100) * each.sgst))} */}
                                </th>
                            </tr>
                        </tbody>
                    </Table>}
            </>
        )
    }

    const reusableInvoiceTotalCon = () => {
        return (
            <div className="invoice-preview-total-con">
                <div className="invoice-preview-total-con-left">
                    <span>
                        <b>Total Invoice Amount In Words ({formatCurrencyBasedOnRegion()}) : </b>
                    </span>
                    <p >{totalAmountInWords}
                    </p>
                </div>
                <div className="invoice-preview-total d-flex">
                    <p className="invoice-preview-total-key" >Total : </p>
                    {/* <span className="diagonal-line"></span> */}
                    {/* <span></span> */}
                    <p className="invoice-preview-total-value" >&nbsp;
                        &nbsp;{formatToIndianRupee(TotalAmount)} {formatCurrencyBasedOnRegion()}</p>
                </div>
            </div>
        )
    }

    const reusableInvoiceDetails = () => {
        return (
            <div className="invoice-preview-scrollable" style={{ margin: 'auto' }}>
                <div className="invoice-preview-card">
                    {reusableInvoicePreviewCardDetails()}

                    <div className="invoice-preview-table-container">
                        {reusableInvoiceTable()}
                        {reusableInvoiceTotalCon()}

                    </div>
                    <div className="signature">
                        <p></p>
                        <p>sign here</p>
                    </div>

                </div>
                {(paymentToggle && pdfDataForPayments && showPaymentDetails) && <PdfViewer base64Pdf={pdfDataForPayments} />}
                {(termsToggle && pdfDataForTerms && showTermsDetails) && <PdfViewer base64Pdf={pdfDataForTerms} />}
            </div>
        )
    }

    const cdType = (value) => {
        if (value === 2) {
            return 'Credit'
        }
        if (value === 3) {
            return 'Debit'
        }
    }

    const reusableCreditAndDebitNoteDetails = () => {
        return (
            <>
                <div className="invoice-preview-scrollable-cd" style={{ margin: 'auto' }}>
                    <div className="invoice-preview-card-cd">
                        <div className="preview-cd">
                            <div className="preview-cd-header">
                                <div className="preview-cd-header-left preview-cd-notes ">
                                    <p className="preview-cd-title">{toTitleCase(serviceNameInInvoice)} Invoice : {invoiceNo}</p>
                                    <p className="preview-cd-company">{companyName}</p>
                                </div>
                                <div className="preview-cd-header-right d-flex justify-content-between align-items-center gap-2">
                                    <h5 className="preview-cd-subtitle mt-3 ">{cdType(selectedInvoiceTab)} Notes</h5>
                                    <div className="d-flex gap-2"
                                    >
                                        <button onClick={() => {
                                            // setCreateCreditNoteClicked(true)
                                            if (cdType(selectedInvoiceTab) === 'Credit') {
                                                window.open(`/CreditAndDebit?number=${invoiceNo}&type=00`, '_blank');
                                            } else {
                                                window.open(`/CreditAndDebit?number=${invoiceNo}&type=01`, '_blank');
                                            }
                                        }} className="preview-cd-btn">+ New</button>
                                        <button onClick={() => {
                                            getInvoiceNotes()
                                            handleViewButton(invoiceNo, invoiceStatus)
                                        }} className="preview-cd-btn">Reload</button>
                                    </div>
                                </div>
                            </div>



                            {selectedInvoiceTab === 2 &&
                                <div>
                                    {creditNoteList.length > 0 ? <>
                                        <div style={{ marginTop: "-10px", overflow: 'auto' }}>
                                            <TableComponent
                                                headers={[{
                                                    name: "note number",
                                                    type: "text",
                                                    key: "note_number",
                                                    sort: true
                                                }, {
                                                    name: "Amount",
                                                    type: "text",
                                                    key: "gross_amount",
                                                    sort: true
                                                }, {
                                                    name: "Status",
                                                    type: "text",
                                                    key: "status",
                                                    sort: true
                                                }, {
                                                    name: "Created By",
                                                    type: "text",
                                                    key: "created_by",
                                                    sort: true
                                                }, {
                                                    name: "Created At",
                                                    type: "time_stamp",
                                                    key: "created_at",
                                                    sort: true
                                                }, {
                                                    name: "Last Updated By",
                                                    type: "text",
                                                    key: "updated_by",
                                                    sort: true
                                                }, {
                                                    name: "Last Updated At",
                                                    type: "time_stamp",
                                                    key: "updated_at",
                                                    sort: true
                                                },
                                                {
                                                    name: "Action",
                                                    type: "button",
                                                    buttons: [{
                                                        name: "View",
                                                        icon: "./images/icons/ViewViewIconEye.svg",
                                                        disable: (data) => false,
                                                        action: (data) => {
                                                            // setSelectedTemplate(data)
                                                            // setPage(3)
                                                            window.open(`/CreditAndDebit?number=${data.note_id}&type=10`, '_blank');
                                                        }
                                                    }]
                                                }]}
                                                data={creditNoteList}
                                            />

                                        </div>
                                    </>
                                        :
                                        <div className="preview-cd-empty">
                                            <div onClick={() => {
                                                window.open(`/CreditAndDebit?number=${invoiceNo}&type=00`, '_blank');
                                            }} className="C-pointer preview-cd-empty-icon">+</div>
                                            <p className="preview-cd-empty-title">No {cdType(selectedInvoiceTab)} Notes</p>
                                            <p className="preview-cd-empty-text">
                                                There are no {cdType(selectedInvoiceTab)} notes created yet. Click “New” to add a {cdType(selectedInvoiceTab)} Note to this invoice.
                                            </p>
                                        </div>}
                                </div>}
                            {selectedInvoiceTab === 3 && <div>
                                {debitNoteList.length > 0 ? <>
                                    <div style={{ marginTop: "-10px", overflow: 'auto' }}>
                                        <TableComponent
                                            headers={[{
                                                name: "Note Number",
                                                type: "text",
                                                key: "note_number",
                                                sort: true
                                            }, {
                                                name: "Amount",
                                                type: "text",
                                                key: "gross_amount",
                                                sort: true
                                            }, {
                                                name: "Status",
                                                type: "text",
                                                key: "status",
                                                sort: true
                                            }, {
                                                name: "Created By",
                                                type: "text",
                                                key: "created_by",
                                                sort: true
                                            }, {
                                                name: "Created At",
                                                type: "time_stamp",
                                                key: "created_at",
                                                sort: true
                                            }, {
                                                name: "Last Updated By",
                                                type: "text",
                                                key: "updated_by",
                                                sort: true
                                            }, {
                                                name: "Last Updated At",
                                                type: "time_stamp",
                                                key: "updated_at",
                                                sort: true
                                            },
                                            {
                                                name: "Action",
                                                type: "button",
                                                buttons: [{
                                                    name: "View",
                                                    icon: "./images/icons/ViewViewIconEye.svg",
                                                    disable: (data) => false,
                                                    action: (data) => {
                                                        // setSelectedTemplate(data)
                                                        // setPage(3)
                                                        window.open(`/CreditAndDebit?number=${data.note_id}&type=11`, '_blank');
                                                    }
                                                }]
                                            }]}
                                            data={debitNoteList}
                                        />

                                    </div>
                                </>
                                    :
                                    <div className="preview-cd-empty">
                                        <div
                                            onClick={() => {
                                                window.open(`/CreditAndDebit?number=${invoiceNo}&type=01`, '_blank');
                                            }}
                                            className="preview-cd-empty-icon C-pointer">+</div>
                                        <p className="preview-cd-empty-title">No {cdType(selectedInvoiceTab)} Notes</p>
                                        <p className="preview-cd-empty-text">
                                            There are no {cdType(selectedInvoiceTab)} notes created yet. Click “New” to add a {cdType(selectedInvoiceTab)} Note to this invoice.
                                        </p>
                                    </div>}
                            </div>}
                        </div>


                    </div>

                </div>
            </>
        )
    }

    const reusableInvoicePreviewCon = () => {
        return (
            <div className="invoice-preview-con"

            >
                {(invoiceStatus === "pdfgenerated" ||
                    // invoiceStatus === "gstsubmitted" || 
                    invoiceStatus === "emailed") && !createCreditNoteClicked &&
                    TypesOfInvoiceCon()}
                {(invoiceStatus === "pdfgenerated" ||
                    // invoiceStatus === "gstsubmitted" || 
                    invoiceStatus === "emailed") && createCreditNoteClicked &&
                    TypesOfInvoiceConCreate()}
                {selectedInvoiceTab === 1 && reusableInvoiceDetails()}
                {selectedInvoiceTab !== 1 && !createCreditNoteClicked && reusableCreditAndDebitNoteDetails()}
                {selectedInvoiceTab !== 1 && createCreditNoteClicked && reusableCreditAndDebit()}
                <div style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                    position: "absolute",
                    paddingRight: "10px",
                }}>
                    {/* uncomment once invoice history is added to backend */}
                    {/* <div
                        className="invoice-history-icon"
                        title="Invoice History"
                        style={{
                            marginTop: "-10px",
                            marginRight: "70px",
                            // zIndex: 1000,
                        }}
                        onClick={() => {
                            toggleInvoiceDrawer()
                        }}>
                        <MdHistory style={{ width: '25px', height: '25px' }} />
                    </div> */}
                </div>
                <Drawer
                    open={showInvoiceHistory}
                    onClose={toggleInvoiceDrawer}
                    direction='right'
                    className='px-3'
                    style={{ width: '330px' }}
                >
                    <div className="" style={{
                        marginTop: "11vh"
                        // marginTop: "-10px",
                    }}>
                        <div className='d-flex justify-content-between align-items-center px-2'>
                            <h4>Invoice History</h4>
                            <IoMdCloseCircle style={{
                                width: "25px",
                                height: "25px",
                                marginTop: "-5px",
                                color: "lightgrey",
                                cursor: "pointer"
                            }}
                                onClick={() => toggleInvoiceDrawer()}
                            />
                        </div>

                        <div className="d-flex flex-column" style={{
                            gap: '2rem',
                            marginTop: '17px',
                            height: '80vh',
                            overflowY: 'auto',
                            paddingRight: '5px',
                            paddingBottom: '10px'
                        }}>
                            <InvoiceHistoryTimeline />
                        </div>
                    </div>
                </Drawer>
            </div>
        )
    }

    const reusableInvoicePreviewButtons = () => {
        return (
            <div >

                {!preview && <div className="invoice-preview-buttons">
                    {!createCreditNoteClicked && <>
                        {(invoiceStatus === "draft" || invoiceStatus === "onhold" || invoiceStatus === "rejected") &&
                            selectedInvoiceType !== 'miscellaneous' && <button onClick={() => {
                                handleRegenerate()
                                setApprovalType(selectedInvoiceType)
                            }} >Regenerate</button>}
                        {downloadPath && <button onClick={() => {
                            handleDownload()
                        }} disabled={downloadPath === '' || downloadPath === null} style={{ opacity: downloadPath ? '100%' : '50%' }}>Download</button>}
                        {(invoiceStatus === "approved") && <button onClick={() => {
                            submitToGSTPortal(invoiceNo)
                        }} >Submit to GST</button>}
                        {(invoiceStatus === "pdfgenerated" && downloadPath) && (
                            <button
                                onClick={() => {
                                    setAlertShow(true);
                                    setAlertType('question');
                                    setAlertMessage('Confirmation');
                                    setAlertValue('Do you want to send the invoice to the customer?');
                                    setAlertButtons([
                                        {
                                            name: 'Cancel',
                                            action: () => setAlertShow(false),
                                            variant: 'secondary'
                                        },
                                        {
                                            name: 'Proceed',
                                            action: () => {
                                                setAlertShow(false);
                                                sendToCustomer(invoiceNo);
                                            },
                                            variant: 'primary'
                                        }
                                    ]);
                                }}
                            >
                                Send to Customer
                            </button>
                        )}
                        {(invoiceStatus === "gstsubmitted") && <button onClick={() => {
                            handleGeneratePdf()
                        }}  >Generate PDF</button>}
                        {(invoiceStatus === "draft" || invoiceStatus === "onhold" || invoiceStatus === "rejected") &&
                            selectedInvoiceType === 'miscellaneous' &&
                            <button onClick={() => {
                                handleEditMiscInvoice()
                                setApprovalType(selectedInvoiceType)
                            }}
                            // disabled
                            // style={{ opacity: '50%' }}
                            >Edit Misc Invoice</button>}
                        <button onClick={() => { setCurrentPage(1); setPreview(false); backFunction(); backPagination() }}>Back</button>
                        {(invoiceStatus === "draft" || invoiceStatus === "onhold" || invoiceStatus === "approved") && <button onClick={() => {
                            handleReject()
                            setApprovalType(selectedInvoiceType)
                        }} >Reject</button>}
                        {(invoiceStatus === "draft" || invoiceStatus === "rejected" || invoiceStatus === "approved") && <button onClick={() => {
                            handleHold()
                            setApprovalType(selectedInvoiceType)
                        }} >Hold</button>}
                        {!(invoiceStatus !== "rejected" && invoiceStatus !== 'onhold' && invoiceStatus !== "draft") && <button
                            onClick={() => {
                                editInvoice()
                                setApprovalType(selectedInvoiceType)
                            }
                            }
                            style={{ opacity: checkSendForApprovalValidation() ? '100%' : '50%' }} disabled={!checkSendForApprovalValidation()}>Approve</button>}
                    </>}
                    {createCreditNoteClicked &&
                        <>
                            <button onClick={() => { setCurrentPage(1); setPreview(false); backFunction(); backPagination() }}>Back</button>
                            {<button onClick={() => {
                                addCreditDebitNote()
                                setApprovalType(selectedInvoiceType)
                            }} >Generate</button>}
                        </>}
                </div>}
                {preview && <div className="invoice-preview-buttons">
                    <button onClick={() => setPreview(false)}>Back</button>
                </div>}
            </div>
        )
    }

    const reusableCreditAndDebit = () => {
        return (
            <>
                <div className="invoice-preview-scrollable" style={{ margin: 'auto' }}>
                    <div className="invoice-preview-card">
                        <div className="invoice-preview-card-details">
                            {companyLogo && <div className="invoice-logo-placeholder">
                                <div>
                                    <img style={{ width: '15rem', height: '5rem' }} src={companyLogo} alt="company logo" />
                                </div>
                            </div>}
                            <div className="d-flex justify-content-between w-100">
                                <div className="invoice-header-address">
                                    <h5
                                        className="invoice-header-title"
                                        style={{
                                            fontSize: `${Math.max(40 - (companyName?.length ? companyName?.length * 0.3 : 1), 20)}px`
                                        }}
                                    >
                                        {companyName?.toUpperCase()}

                                    </h5>
                                    <p style={{
                                        textAlign: 'center'
                                    }}><span ><b>Reg.Office:</b>
                                            <input
                                                type="text"
                                                value={companyAddress}
                                                onChange={(e) => {
                                                    setCompanyAddress(e.target.value)
                                                }}
                                                style={{
                                                    backgroundColor: '#e6f7ff',
                                                    border: 'none',
                                                    outline: 'none',
                                                    padding: '4px 8px',
                                                    textAlign: 'right',
                                                    // width: '100%',
                                                    minWidth: "500px",
                                                    textAlign: "center"
                                                }}
                                            /></span></p>
                                </div>
                                {
                                    QrCode?.length > 0 ?
                                        <QRCode style={{ marginTop: '-70px' }} value={QrCode} size={170} />
                                        :
                                        <div className="invoice-bar-code">
                                            {invoiceStatus === "rejected" ? (
                                                <p className="rejected-text">Rejected</p>
                                            ) : (
                                                <p className="qr-code-text">QR Code</p>
                                            )}
                                        </div>
                                }

                            </div>
                            <h5 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>Tax Invoice</h5>
                            <h6 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>({serviceNameInInvoice})</h6>
                            <div className="invoice-preview-inner-card-div">
                                <div className="invoice-preview-inner-card">
                                    <div style={{ width: '100%' }}>
                                        <p>
                                            <b style={{ fontSize: "18px" }}>Buyer </b>
                                            <br /> <b>{customerName}</b><br />
                                            <div className="invoice-left-data">
                                                <span className="key"><b>Billed To</b></span>
                                                <span style={{ marginRight: '3px' }}>:</span>
                                                <span className="value"> {customerAddress}</span>
                                            </div>
                                            {toggleShippingAddress && <div className="invoice-left-data">
                                                <span className="key"><b>Shipped To</b></span>
                                                <span style={{ marginRight: '3px' }}>:</span>
                                                <span className="value">  {shippingAddress}</span>
                                            </div>}
                                            <div className="invoice-left-data">
                                                <span className="key"><b>State Code</b></span>
                                                <span style={{ marginRight: '3px' }}>:</span>
                                                <span className="value"> {customerStateCode}</span>
                                            </div>
                                            <div className="invoice-left-data">
                                                <span className="key"><b>GSTIN</b></span>
                                                <span style={{ marginRight: '3px' }}>:</span>
                                                <span className="value"> {customerGSTIN}</span>
                                            </div>
                                            <div className="invoice-left-data">
                                                <span className="key"><b>PAN</b></span>
                                                <span style={{ marginRight: '3px' }}>:</span>
                                                <span className="value"> {customerPAN}</span>
                                            </div>
                                            <div className="invoice-left-data">
                                                <span className="key"><b>CIN</b></span>
                                                <span style={{ marginRight: '3px' }}>:</span>
                                                <span className="value"> {customerCIN}</span>
                                            </div>
                                            <div className="invoice-left-data">
                                                <span className="key"><b>Place Of Supply</b></span>
                                                <span style={{ marginRight: '3px' }}>:</span>
                                                <span className="value"> {customerPlaceOfSupply}</span>
                                            </div>
                                        </p>
                                    </div>
                                </div>
                                <div className="invoice-address-right">
                                    <div >
                                        <br />
                                        <p> <b>Contract No   </b> </p>
                                        <p><b>Invoice No</b> </p>
                                        <p><b>State</b></p>
                                        <p><b>State Code</b> </p>
                                        <p><b>GSTIN</b></p>
                                        <p><b>PAN</b></p>
                                        <p><b>CIN</b></p>
                                        <br />
                                        <p><b>Invoice Date</b></p>
                                        <p><b>Due Date</b></p>

                                    </div>
                                    <div style={{ marginLeft: "20px" }}>
                                        <br />
                                        <p>: {contractNo}</p>
                                        <p>: {invoiceNo}</p>
                                        <p>: {parnterState}</p>
                                        <p>: {partnerStateCode}</p>
                                        <p>: {companyGST}</p>
                                        <p>: {partnerPAN}</p>
                                        <p>: {companyCIN}</p>

                                        <br />
                                        <p>: {ackDate}</p>
                                        <p>: {partnerDueDate}</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="invoice-preview-card-details-bottom">
                            <div className="invoice-preview-inner-card-2">
                                <p><span><b>IRN :</b> </span>{IRN}<br />
                                </p>
                            </div>
                        </div>

                        <div className="invoice-preview-table-container">
                            <Table className="invoice-preview-table">
                                <thead>
                                    <tr>
                                        <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                                        <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                                        <th colSpan={2}><b>Bill Period </b></th>
                                        {showComputationDetails && <th colSpan={1}><b>Total Area</b></th>}
                                        {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
                                        <th colSpan={1}><b>Basic Amount</b></th>
                                        {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                                        {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                                        {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                                        <th colSpan={1}><b>GROSS</b></th>
                                    </tr>
                                    <tr>

                                        <th>From</th>
                                        <th>To</th>
                                        {showComputationDetails && <th>Sq. ft</th>}
                                        {showComputationDetails && <th> ({formatCurrencyBasedOnRegion()} / Sq. ft)</th>}
                                        <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                                        {!igstToggle && <th>Rate <br /> (%)</th>}
                                        {!igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                        {!igstToggle && <th>Rate <br />(%)</th>}
                                        {!igstToggle && <th>Amount<br /> ({formatCurrencyBasedOnRegion()})</th>}
                                        {igstToggle && <th>Rate <br />(%)</th>}
                                        {igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                        <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {invoiceDetails?.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                {/* Service Name and Identifier */}
                                                <th className="text-start">
                                                    {item?.service_name_in_invoice?.toUpperCase()},<br />
                                                    {item?.service_identifier}
                                                </th>

                                                {/* HSN Code */}
                                                <th className="text-start">{item?.hsn}</th>

                                                {/* From Date */}
                                                <th style={{ textAlign: 'end' }}>
                                                    {formatDateBasedOnValue(formatDateView(item.from_date))}
                                                </th>

                                                {/* To Date */}
                                                <th style={{ textAlign: 'end' }}>
                                                    <div>{formatDateBasedOnValue(formatDateView(item.to_date))}</div>
                                                </th>

                                                {/* Consumption */}
                                                {showComputationDetails && (
                                                    <th style={{ textAlign: 'end' }}>
                                                        <input
                                                            type="number"
                                                            value={item.consumption}
                                                            onChange={(e) => handleInvoiceItemChange(item.id, 'consumption', parseFloat(e.target.value) || 0)}
                                                            style={{
                                                                backgroundColor: '#e6f7ff',
                                                                border: 'none',
                                                                outline: 'none',
                                                                padding: '4px 8px',
                                                                textAlign: 'right',
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </th>
                                                )}

                                                {/* Rate Per Unit */}
                                                {showComputationDetails && (
                                                    <th style={{ textAlign: 'end' }}>
                                                        <input
                                                            type="number"
                                                            value={item.rate_per_unit}
                                                            onChange={(e) => handleInvoiceItemChange(item.id, 'rate_per_unit', parseFloat(e.target.value) || 0)}
                                                            style={{
                                                                backgroundColor: '#e6f7ff',
                                                                border: 'none',
                                                                outline: 'none',
                                                                padding: '4px 8px',
                                                                textAlign: 'right',
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </th>
                                                )}

                                                {/* Net Amount */}
                                                <th style={{ textAlign: 'end' }}>
                                                    <input
                                                        type="number"
                                                        value={item.net_amount}
                                                        onChange={(e) => handleInvoiceItemChange(item.id, 'net_amount', parseFloat(e.target.value) || 0)}
                                                        style={{
                                                            backgroundColor: '#e6f7ff',
                                                            border: 'none',
                                                            outline: 'none',
                                                            padding: '4px 8px',
                                                            textAlign: 'right',
                                                            width: '100%',
                                                        }}
                                                    />
                                                </th>

                                                {/* CGST Rate */}
                                                {!igstToggle && (
                                                    <th style={{ textAlign: 'end' }}>
                                                        <input
                                                            type="number"
                                                            value={item.cgst_rate}
                                                            onChange={(e) => handleInvoiceItemChange(item.id, 'cgst_rate', parseFloat(e.target.value) || 0)}
                                                            style={{
                                                                backgroundColor: '#e6f7ff',
                                                                border: 'none',
                                                                outline: 'none',
                                                                padding: '4px 8px',
                                                                textAlign: 'right',
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </th>
                                                )}

                                                {/* CGST Amount */}
                                                {!igstToggle && (
                                                    <th style={{ textAlign: 'end' }}>
                                                        <input
                                                            type="number"
                                                            value={item.cgst}
                                                            onChange={(e) => handleInvoiceItemChange(item.id, 'cgst', parseFloat(e.target.value) || 0)}
                                                            style={{
                                                                backgroundColor: '#e6f7ff',
                                                                border: 'none',
                                                                outline: 'none',
                                                                padding: '4px 8px',
                                                                textAlign: 'right',
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </th>
                                                )}

                                                {/* SGST Rate */}
                                                {!igstToggle && (
                                                    <th style={{ textAlign: 'end' }}>
                                                        <input
                                                            type="number"
                                                            value={item.sgst_rate}
                                                            onChange={(e) => handleInvoiceItemChange(item.id, 'sgst_rate', parseFloat(e.target.value) || 0)}
                                                            style={{
                                                                backgroundColor: '#e6f7ff',
                                                                border: 'none',
                                                                outline: 'none',
                                                                padding: '4px 8px',
                                                                textAlign: 'right',
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </th>
                                                )}

                                                {/* SGST Amount */}
                                                {!igstToggle && (
                                                    <th style={{ textAlign: 'end' }}>
                                                        <input
                                                            type="number"
                                                            value={item.sgst}
                                                            onChange={(e) => handleInvoiceItemChange(item.id, 'sgst', parseFloat(e.target.value) || 0)}
                                                            style={{
                                                                backgroundColor: '#e6f7ff',
                                                                border: 'none',
                                                                outline: 'none',
                                                                padding: '4px 8px',
                                                                textAlign: 'right',
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </th>
                                                )}

                                                {/* IGST Rate */}
                                                {igstToggle && (
                                                    <th style={{ textAlign: 'end' }}>
                                                        <input
                                                            type="number"
                                                            value={item.igst_rate}
                                                            onChange={(e) => handleInvoiceItemChange(item.id, 'igst_rate', parseFloat(e.target.value) || 0)}
                                                            style={{
                                                                backgroundColor: '#e6f7ff',
                                                                border: 'none',
                                                                outline: 'none',
                                                                padding: '4px 8px',
                                                                textAlign: 'right',
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </th>
                                                )}

                                                {/* IGST Amount */}
                                                {igstToggle && (
                                                    <th style={{ textAlign: 'end' }}>
                                                        <input
                                                            type="number"
                                                            value={item.igst}
                                                            onChange={(e) => handleInvoiceItemChange(item.id, 'igst', parseFloat(e.target.value) || 0)}
                                                            style={{
                                                                backgroundColor: '#e6f7ff',
                                                                border: 'none',
                                                                outline: 'none',
                                                                padding: '4px 8px',
                                                                textAlign: 'right',
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </th>
                                                )}

                                                {/* Gross Amount */}
                                                <th style={{ textAlign: 'end' }}>
                                                    <input
                                                        type="number"
                                                        value={item.gross_amount}
                                                        onChange={(e) => handleInvoiceItemChange(item.id, 'gross_amount', parseFloat(e.target.value) || 0)}
                                                        style={{
                                                            backgroundColor: '#e6f7ff',
                                                            border: 'none',
                                                            outline: 'none',
                                                            padding: '4px 8px',
                                                            textAlign: 'right',
                                                            width: '100%',
                                                        }}
                                                    />
                                                </th>
                                            </tr>
                                        );
                                    })}


                                    {/* Grand Total */}
                                    <tr >
                                        {/* service description */}
                                        <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
                                            Total
                                        </th>
                                        {/* sac/hsn */}
                                        <th className="text-start">
                                        </th>
                                        <th className="text-start">
                                        </th>
                                        {showBillingPeriod && <th className="text-start">
                                        </th>}
                                        {showComputationDetails && <th className="text-start">
                                        </th>}
                                        <th className="text-start">
                                        </th>
                                        {/* basic amount */}
                                        <th className="text-end">
                                            <input
                                                type="number"
                                                value={basicAmount}
                                                onChange={(e) => setBasicAmount(parseFloat(e.target.value) || 0)}
                                                style={{
                                                    backgroundColor: '#e6f7ff',
                                                    border: 'none',
                                                    outline: 'none',
                                                    padding: '4px 8px',
                                                    textAlign: 'right',
                                                    width: '100%',
                                                }}
                                            />
                                        </th>

                                        {/* sgst rate */}
                                        {!igstToggle && <th>
                                            <input
                                                type="number"
                                                value={0} // Assuming you handle sgstRate calculation elsewhere
                                                readOnly
                                                style={{
                                                    backgroundColor: '#e6f7ff',
                                                    border: 'none',
                                                    outline: 'none',
                                                    padding: '4px 8px',
                                                    textAlign: 'right',
                                                    width: '100%',
                                                }}
                                            />
                                        </th>}

                                        {/* sgst amount */}
                                        {!igstToggle && <th className="text-end">
                                            <input
                                                type="number"
                                                value={totalSgst}
                                                onChange={(e) => setTotalSgst(parseFloat(e.target.value) || 0)}
                                                style={{
                                                    backgroundColor: '#e6f7ff',
                                                    border: 'none',
                                                    outline: 'none',
                                                    padding: '4px 8px',
                                                    textAlign: 'right',
                                                    width: '100%',
                                                }}
                                            />
                                        </th>}

                                        {/* cgst rate */}
                                        {!igstToggle && <th>
                                            <input
                                                type="number"
                                                value={0} // Assuming you handle cgstRate calculation elsewhere
                                                readOnly
                                                style={{
                                                    backgroundColor: '#e6f7ff',
                                                    border: 'none',
                                                    outline: 'none',
                                                    padding: '4px 8px',
                                                    textAlign: 'right',
                                                    width: '100%',
                                                }}
                                            />
                                        </th>}

                                        {/* cgst amount */}
                                        {!igstToggle && <th className="text-end">
                                            <input
                                                type="number"
                                                value={totalCgst}
                                                onChange={(e) => setTotalCgst(parseFloat(e.target.value) || 0)}
                                                style={{
                                                    backgroundColor: '#e6f7ff',
                                                    border: 'none',
                                                    outline: 'none',
                                                    padding: '4px 8px',
                                                    textAlign: 'right',
                                                    width: '100%',
                                                }}
                                            />
                                        </th>}

                                        {/* igst rate */}
                                        {igstToggle && <th>
                                            <input
                                                type="number"
                                                value={0} // Assuming you handle igstRate calculation elsewhere
                                                readOnly
                                                style={{
                                                    backgroundColor: '#e6f7ff',
                                                    border: 'none',
                                                    outline: 'none',
                                                    padding: '4px 8px',
                                                    textAlign: 'right',
                                                    width: '100%',
                                                }}
                                            />
                                        </th>}

                                        {/* igst amount */}
                                        {igstToggle && <th className="text-end">
                                            <input
                                                type="number"
                                                value={totalIgst}
                                                onChange={(e) => setTotalIgst(parseFloat(e.target.value) || 0)}
                                                style={{
                                                    backgroundColor: '#e6f7ff',
                                                    border: 'none',
                                                    outline: 'none',
                                                    padding: '4px 8px',
                                                    textAlign: 'right',
                                                    width: '100%',
                                                }}
                                            />
                                        </th>}

                                        {/* gross amount */}
                                        <th className="text-end">
                                            <input
                                                type="number"
                                                value={TotalAmount}
                                                onChange={(e) => setTotalAmount(parseFloat(e.target.value) || 0)}
                                                style={{
                                                    backgroundColor: '#e6f7ff',
                                                    border: 'none',
                                                    outline: 'none',
                                                    padding: '4px 8px',
                                                    textAlign: 'right',
                                                    width: '100%',
                                                }}
                                            />
                                        </th>

                                    </tr>
                                </tbody>
                            </Table>
                            <div className="invoice-preview-total-con">
                                <div className="invoice-preview-total-con-left">
                                    <span>
                                        <b>Total Invoice Amount In Words ({formatCurrencyBasedOnRegion()}) : </b>
                                    </span>
                                    <p >{totalAmountInWords}
                                    </p>
                                </div>
                                <div className="invoice-preview-total d-flex">
                                    <p className="invoice-preview-total-key" >Total : </p>
                                    {/* <span className="diagonal-line"></span> */}
                                    {/* <span></span> */}
                                    <p className="invoice-preview-total-value" >&nbsp;
                                        &nbsp;{formatToIndianRupee(TotalAmount)} {formatCurrencyBasedOnRegion()}</p>
                                </div>
                            </div>

                        </div>
                        <div className="signature">
                            <p></p>
                            <p>sign here</p>
                        </div>

                    </div>
                </div>
            </>
        )
    }

    const [fileData, setFileData] = useState([]);
    const [termsAndConditions, setTermsAndConditions] = useState(null);

    const handleSelectTermsAndCondition = (files) => {
        setTermsAndConditions(null)
        let processedFiles1 = [];
        files.forEach((file) => {
            const reader1 = new FileReader();
            reader1.onloadend = function () {
                const base64FileContent = reader1.result.split(",")[1];
                const processedFile1 = {
                    file_content: base64FileContent,
                    file_name: file?.file?.name,
                    file_type: "pdf",
                    object_type: "terms_documents",
                    flag: null,
                    document_type: "tandc",
                    user_id: localStorage.getItem("username"),
                    contract_name: miscContractName?.label,
                    service_code: "miscellaneous"
                };
                processedFiles1 = [...processedFiles1, processedFile1];
                if (processedFiles1.length === files.length) {
                    setFileData(processedFiles1);
                }
            };
            reader1.readAsDataURL(file.file);
        });
    }
    const handleTermsAndConditionsUpload = (index) => {
        const data = { "files": [fileData[index]] }
        dispatch(handleDocumentLoaderTrue())
        axios.post(base_url + "documents", data)
            .then((response) => {
                if (response.status === 200) {
                    setTermsAndConditions(response.data.data[0].key)
                    dispatch(handleDocumentLoaderFalse())
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }


    return (
        <>
            <>
                <NavBarTop />
                <LeftNavBar />
            </>
            <div>
                {invoicesListError && <Modal keyboard={false} backdrop="static" show={invoicesListError} onHide={() => {
                    dispatch({
                        type: GET_ALL_INVOICES_ERROR,
                        payload: null
                    })
                }} centered>
                    <Modal.Header><div style={{ width: '100%' }} className='d-flex justify-content-center align-items-center gap-2'><MdErrorOutline color='red' style={{ height: "25px", width: "25px" }} /><span className='fs-3'>Error</span></div></Modal.Header>
                    <Modal.Body className="text-center"><h5>{invoicesListError}</h5></Modal.Body>
                    <Modal.Footer className="footer d-flex justify-content-center">
                        <Button variant="secondary" onClick={() => {
                            dispatch({
                                type: GET_ALL_INVOICES_ERROR,
                                payload: null
                            })
                            
                        }}
                        >Close</Button>
                    </Modal.Footer>
                </Modal>}
                <Drawer
                    open={isOpen}
                    onClose={() => setIsOpen(false)}
                    direction='right'
                    className='px-3'
                    style={{ width: '330px' }}
                >
                    <div className="" style={{
                        marginTop: "11vh"
                        // marginTop: "-10px",
                    }}>
                        <div className='d-flex justify-content-between align-items-center'>
                            <h5 className='mt-1 '>Filters</h5>
                            <img src="./images/icons/crossWithCircle.svg" alt="close" onClick={() => setIsOpen(false)} style={{ cursor: 'pointer' }} />
                        </div>
                        <hr style={{ border: 'none', borderTop: '1px solid gray', margin: '1px 0' }} />
                        <div className="d-flex flex-column" style={{
                            gap: '2rem',
                            marginTop: '17px',
                            height: '80vh',
                            overflowY: 'auto',
                            paddingRight: '5px',
                            paddingBottom: '10px'
                        }}>
                            <div style={{ width: '280px' }} className="fin_man_billing_period">
                                <p style={{ marginBottom: '-18px' }}>Facility:&nbsp;</p>
                                <SearchableDropdown
                                    style={{ zIndex: 100, width: "180px !important" }}
                                    // className = "searchable-dropdown2"
                                    options={facilityList ? facilityList : []} //facilityList is the array of facilities
                                    selectedOption={selectedFacility}
                                    noOptionsAvailable="Facility unavailable"
                                    onChange={(e) => {
                                        setSelectedFacility(e.value)
                                        const selectedFacility = facilitiesListForNav?.find((facility) => `${facility.city}, ${facility.name}` === e.value);
                                        setSelectedFacilityName(selectedFacility?.name);
                                        setSelectedCityName(selectedFacility?.city);
                                        setSelectedFacility(`${selectedFacility?.city}, ${selectedFacility?.name}`);
                                        setSelectedFacilityId(selectedFacility?.facility_id);
                                    }}

                                    placeholder="Select Facility"
                                    isDisabled={false}
                                />
                            </div>
                            <div style={{ width: '280px' }} className="fin_man_billing_period">
                                <p style={{ marginBottom: '5px' }}>Select Customer:&nbsp;</p>
                                <select
                                    value={selectedCustomer}
                                    onChange={(e) => {
                                        setSelectedCustomer(e.target.value);
                                    }}
                                    className="invoice-select-date"
                                    style={{ width: "100%", height: "2.5rem" }}
                                >
                                    <option value={""}>All Customers</option>
                                    {companyList?.map((customer, index) => (
                                        <option key={index} value={customer.customer_id}>{customer.company_name}</option>
                                    ))}
                                    {/* <option value="miscellaneous">Miscellaneous</option>
                                    {servicesForDropdown?.map((service, index) => (
                                        <option key={index} value={service.service_code}>{service.service_name}</option>
                                    ))} */}
                                </select>
                            </div>
                            <div style={{ width: '280px' }} className="fin_man_billing_period">
                                <p style={{ marginBottom: '5px' }}>Invoice Type:&nbsp;</p>
                                <select
                                    value={invoiceSelected}
                                    onChange={(e) => {
                                        setinvoiceSelected(e.target.value);
                                    }}
                                    className="invoice-select-date"
                                    style={{ width: "100%", height: "2.5rem" }}
                                >
                                    <option value={""}>All Invoices</option>
                                    <option value="miscellaneous">Miscellaneous</option>
                                    {servicesForDropdown?.map((service, index) => (
                                        <option key={index} value={service.service_code}>{service.service_name}</option>
                                    ))}
                                </select>
                            </div>
                            <div style={{ width: '280px' }} className="fin_man_billing_period">
                                <p style={{ marginBottom: '5px' }}>Invoice Status:&nbsp;</p>
                                <select
                                    value={selectedStatus}
                                    onChange={(e) => {
                                        setSelectedStatus(e.target.value);
                                    }}
                                    className="invoice-select-date"
                                    style={{ width: "100%", height: "2.5rem" }}
                                >
                                    {typesOfInvoices?.map((status, index) => (
                                        <option key={index} value={status.id}>{status.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="fin_man_billing_period">
                                <p style={{ marginBottom: '0px' }}>Billing Period:&nbsp;</p>
                                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label=""
                                        value={dayjs(`${billingYearFilter}-${billingMonthFilter}`)}
                                        views={['month', 'year']}
                                        // minDate={dayjs('2022-01-01')} // Set minimum selectable date
                                        // maxDate={dayjs('2025-01-08')} // Set minimum selectable date
                                        onChange={(newValue) => {
                                            setBillingMonthFilter(dayjs(newValue).month() + 1);
                                            setBillingYearFilter(dayjs(newValue).year());
                                            setBillingPeriodFilter(newValue)
                                        }
                                        }
                                        sx={{
                                            '.MuiInputBase-root': {
                                                height: '40px', // Adjust height
                                                width: "280px",
                                                backgroundColor: 'white', // Set background to white
                                                borderRadius: '6px', // Optional: Rounded corners
                                                fontSize: '14px', // Optional: Adjust text size
                                            },
                                        }}
                                    // slotProps={{
                                    //     textField: {
                                    //         InputProps: {
                                    //             readOnly: true, // Prevent typing in the input field
                                    //         },
                                    //         onKeyDown: (e) => e.preventDefault(), // Block keyboard inputs
                                    //     },
                                    // }}
                                    />
                                </LocalizationProvider> */}
                                <MultiMonthSelect
                                    value={periods}
                                    onChange={(newPeriods) => setPeriods(newPeriods)}
                                />


                            </div>
                            <div style={{ width: '280px' }} className="fin_man_billing_period">
                                <p style={{ marginBottom: '5px' }}>Payment Status:&nbsp;</p>
                                <select
                                    value={selectedPaymentStatus}
                                    onChange={(e) => {
                                        setSelectedPaymentStatus(e.target.value);
                                    }}
                                    className="invoice-select-date"
                                    style={{ width: "100%", height: "2.5rem" }}
                                >
                                    <option value={""}>All</option>
                                    {paymentTypes?.map((type, index) => (
                                        <option key={index} value={type.value}>{type.label}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="fm-invoice-con-filters d-flex justify-content-between" style={{ width: '280px' }}>
                                <button className="add_fac_clear_btn secondary-button"
                                    style={{ color: 'white', height: '20px !important', width: "45%" }}
                                    onClick={() => {
                                        handleReset()
                                        setIsOpen(false)
                                        // setSearchText('')
                                        // setinvoiceSelected('')
                                        // setBillingPeriodFilter(new Date())
                                        // setBillingMonthFilter(dayjs().month() + 1)
                                        // setBillingYearFilter(dayjs().year())
                                        // const search = ''
                                        // const selectedInvoice = ''
                                        // const month = format(new Date(), 'MMMM yyyy');
                                        // // const fullYear = format(new Date(), 'yyyy');
                                        // // const monthNumber = new Date(month + ' 1, ' + fullYear).getMonth() + 1;
                                        // const monthNumber = dayjs().month() + 1
                                        // const fullYear = dayjs().year()
                                        // setInvoiceListErrorFlag(false)
                                        // dispatch(getAllInvoices({ page: 1 && 1, facility_id: localStorage.getItem("selected_facility_id"), limit: RECORDS_PER_PAGE, invoiceType, monthNumber, fullYear, search, selectedInvoice }))
                                    }}>Reset</button>
                                <button className="add_fac_apply_btn primary-button"
                                    style={{ color: 'white', height: '20px !important', width: "45%" }}
                                    onClick={() => {
                                        applyFilter()
                                    }}>Apply</button>


                            </div>
                        </div>
                    </div>
                </Drawer>
                <AlertPopUp alertShow={alertShow} alertType={alertType} alertMsg={alertMessage} alertValue={alertValue} alertButtons={alertButtons} />
                {currentPage === 1 && <div className='invoice_container'>
                    <div className='fm-invoice-con'>
                        <div className='fm-invoice-heading-con  mb-1'>
                            <h3 className="invoice-heading">Invoices</h3>
                            
                        </div>
                        <div className="invoice-buttons">
                            {(invoiceType == "pdfgenerated" || invoiceType == "emailed") && showDownloadProgress && <div style={{ width: '40px' }}>
                                <CircularProgressbar
                                    styles={buildStyles({
                                        pathColor: 'gray',
                                        textColor: 'gray',
                                    })}
                                    value={downloadProgress} text={`${downloadProgress}%`} /></div>}
                            {(invoiceType == "pdfgenerated" || invoiceType == "emailed") && <button className="invoice_btn" style={{ color: 'white' }}
                                onClick={async () => {
                                    const pdfgen = await getAllInvoicesPdf("pdfgenerated");
                                    const emailed = await getAllInvoicesPdf("emailed");
                                    const allKeys = [...pdfgen, ...emailed]; // Combine both lists

                                    if (allKeys.length > 0) {
                                        await handleDownloadZip(allKeys); // Download combined ZIP
                                    }
                                }}>Download all PDFs</button>}
                            {isManage && <button className="invoice_btn" style={{ color: 'white' }} onClick={() => {
                                navigate("/financeManagerGenerateInvoices")
                            }}>Run Invoices</button>}
                            {isManage && <button className="invoice_btn" style={{ color: 'white' }}
                                onClick={() => {
                                    setCurrentPage(3)
                                    generateInvoiceButtonClicked()
                                }}>Generate Misc. Invoice</button>}
                        </div>
                        {/* genearate a misc invoice */}
                    </div>

                    <div className='fm-invoice-con-filters d-flex justify-content-between' style={{ zIndex: 100 }}>
                        <div className='fm-invoice-filter'
                            style={{
                                padding: "10px 20px",
                                paddingLeft: "0px",
                                borderRadius: "10px",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                width: "65%",
                            }}
                        >
                            <div className="fm-invoice-filter-chips"
                                style={{
                                    padding: "10px 20px",
                                    overflowX: "auto",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                }}
                            >
                                {filterItems.map((item) => (
                                    <Chip
                                        key={item.id}
                                        label={item.value}
                                        onClick={() => { setIsOpen(true) }}
                                        onDelete={item.clearable ? (() => handleDelete(item.id)) : undefined}
                                        variant="outlined"
                                        sx={{
                                            borderRadius: "20px",
                                            fontSize: "0.9rem",
                                            color: "#333",
                                            borderColor: "#ccc",
                                            "& .MuiChip-deleteIcon": {
                                                color: "#999",
                                                fontSize: "18px",
                                                "&:hover": { color: "#333" },
                                            },
                                        }}
                                    />
                                ))}
                            </div>

                            {filterItems.some((item) => item.clearable) && (
                                // <button onClick={clearAll}
                                //     className="invoice_btn" style={{ color: 'white' }}
                                // >Clear All</button>
                                <Chip
                                    label="Reset"
                                    // onDelete={clearAll}
                                    variant="outlined"
                                    className="invoice_btn"
                                    onClick={handleReset}
                                    sx={{
                                        color: 'white',
                                        borderColor: 'white',
                                    }}
                                />
                            )}
                        </div>
                        {/* <div style={{ width: '280px' }} className="fin_man_billing_period">
                            <p style={{ marginBottom: '-18px' }}>Facility:&nbsp;</p>
                            <SearchableDropdown
                                style={{ zIndex: 100 }}
                                // className = "searchable-dropdown2"
                                options={facilityList ? facilityList : []} //facilityList is the array of facilities
                                selectedOption={selectedFacility}
                                noOptionsAvailable="Facility unavailable"
                                onChange={(e) => {
                                    setSelectedFacility(e.value)
                                    const selectedFacility = facilitiesListForNav?.find((facility) => `${facility.city}, ${facility.name}` === e.value);
                                    setSelectedFacilityName(selectedFacility?.name);
                                    setSelectedCityName(selectedFacility?.city);
                                    setSelectedFacility(`${selectedFacility?.city}, ${selectedFacility?.name}`);
                                    setSelectedFacilityId(selectedFacility?.facility_id);
                                }}

                                placeholder="Select Facility"
                                isDisabled={false}
                            />
                        </div>
                        <div style={{ width: '180px' }} className="fin_man_billing_period">
                            <p style={{ marginBottom: '5px' }}>Invoice Type:&nbsp;</p>
                            <select
                                value={invoiceSelected}
                                onChange={(e) => {
                                    setinvoiceSelected(e.target.value);
                                }}
                                className="invoice-select-date"
                                style={{ width: "100%", height: "2.5rem" }}
                            >
                                <option value={""}>All Invoices</option>
                                <option value="miscellaneous">Miscellaneous</option>
                                {servicesForDropdown?.map((service, index) => (
                                    <option key={index} value={service.service_code}>{service.service_name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="fin_man_billing_period">
                            <p style={{ marginBottom: '0px' }}>Billing Period:&nbsp;</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label=""
                                    value={dayjs(`${billingYearFilter}-${billingMonthFilter}`)}
                                    views={['month', 'year']}
                                    // minDate={dayjs('2022-01-01')} // Set minimum selectable date
                                    // maxDate={dayjs('2025-01-08')} // Set minimum selectable date
                                    onChange={(newValue) => {
                                        setBillingMonthFilter(dayjs(newValue).month() + 1);
                                        setBillingYearFilter(dayjs(newValue).year());
                                        setBillingPeriodFilter(newValue)
                                    }
                                    }
                                    sx={{
                                        '.MuiInputBase-root': {
                                            height: '40px', // Adjust height
                                            width: "180px",
                                            backgroundColor: 'white', // Set background to white
                                            borderRadius: '6px', // Optional: Rounded corners
                                            fontSize: '14px', // Optional: Adjust text size
                                        },
                                    }}
                                // slotProps={{
                                //     textField: {
                                //         InputProps: {
                                //             readOnly: true, // Prevent typing in the input field
                                //         },
                                //         onKeyDown: (e) => e.preventDefault(), // Block keyboard inputs
                                //     },
                                // }}
                                />
                            </LocalizationProvider>


                            </div> */}
                        <div className='d-flex align-items-center flex-wrap gap-3 mb-3'>
                            <div className='d-flex align-items-center gap-3 mb-3'>
                                <div className='fin_man_meter_search_bar_container'>
                                    <input style={{ marginTop: '20px', height: '2.5rem' }} type='search' placeholder='Search' value={searchText}
                                        onChange={(e) => handleSearchSubmit(e.target.value)}
                                        className='fin_man_meter_search_bar' />
                                    <GoSearch
                                        // onClick={() => searchTextFilter()} 
                                        style={{ marginTop: '17px' }} className='fin_man_meter_search_bar_icon C-pointer' />
                                </div>

                            </div>
                            <div className="fm-invoice-con-filters mb-2 mt-2">
                                {/* <button className="add_fac_apply_btn primary-button" style={{ color: 'white', height: '20px !important' }} onClick={() => {
                                applyFilter()
                            }}>Apply</button>
                            <button className="add_fac_clear_btn secondary-button" style={{ color: 'white', height: '20px !important' }} onClick={() => {
                                setSearchText('')
                                setinvoiceSelected('')
                                setBillingPeriodFilter(new Date())
                                setBillingMonthFilter(dayjs().month() + 1)
                                setBillingYearFilter(dayjs().year())
                                const search = ''
                                const selectedInvoice = ''
                                const month = format(new Date(), 'MMMM yyyy');
                                // const fullYear = format(new Date(), 'yyyy');
                                // const monthNumber = new Date(month + ' 1, ' + fullYear).getMonth() + 1;
                                const monthNumber = dayjs().month() + 1
                                const fullYear = dayjs().year()
                                setInvoiceListErrorFlag(false)
                                dispatch(getAllInvoices({ page: 1 && 1, facility_id: localStorage.getItem("selected_facility_id"), limit: RECORDS_PER_PAGE, invoiceType, monthNumber, fullYear, search, selectedInvoice }))
                            }}>Clear</button>
                            <button className="add_fac_export_btn primary-button"
                                style={{ color: 'white', height: '20px !important' }}
                                onClick={() => { handleExportInvoiceMasterClicked() }}
                            >
                                Export
                            </button> */}
                                <button className="add_fac_export_btn primary-button"
                                    style={{ color: 'white', height: '20px !important' }}
                                    onClick={() => {
                                        handleExportInvoiceMasterClicked()
                                    }}
                                >
                                    <PiExportBold style={{ height: "20px", width: "20px" }} />
                                </button>
                                <button className="add_fac_export_btn primary-button"
                                    style={{ color: 'white', height: '20px !important' }}
                                    onClick={() => {

                                        // setFilterDrawerOpen(true)
                                        setIsOpen(true)
                                    }}
                                >
                                    <FaFilter />
                                </button>
                            </div>
                        </div>
                    </div>
                    {isManage && <Stack direction="horizontal" className=" invoice-type-div" gap={3}>
                        {typesOfInvoices.map((i, index) => {
                            return (
                                <div key={index} className="invoice-type-card" onClick={() => {
                                    setInvoiceType(i.id)
                                    // const month = format(biilingPeriodFilter, 'MMMM yyyy');
                                    // const fullYear = format(biilingPeriodFilter, 'yyyy');
                                    // const monthNumber = new Date(month + ' 1, ' + fullYear).getMonth() + 1;
                                    setSelectedStatusFilter(i.id)
                                    setSelectedStatus(i.id)

                                    const monthNumber = billingMonthFilter
                                    const fullYear = billingYearFilter
                                    dispatch({
                                        type: SET_PAGINATION_COUNT_TO,
                                        payload: 1
                                    })
                                    const invoiceType = i.id
                                    setInvoiceListErrorFlag(false)
                                    dispatch(getAllInvoices({
                                        page: 1 && 1, limit: RECORDS_PER_PAGE, facility_id: localStorage.getItem("selected_facility_id"), invoiceType, searchText, invoiceSelected, periods

                                        , selectedCustomer, paymentStatus: selectedPaymentStatus
                                    }))

                                }}>
                                    <p className={i.id === invoiceType ? "selected-invoice-type C-pointer" : "C-pointer"}>{i.name}</p>
                                </div>
                            )
                        })
                        }
                    </Stack>}
                    {/* <div className="fm-invoice-search-con">
                        <div className='fm-invoice-search-bar'>
                            <input type='search' placeholder='Search' value={searchText} onChange={e => {
                                setSearchText(e.target.value)
                            }} className='fin_man_meter_search_bar' />
                            <GoSearch />
                        </div>
                        <div>
                            <select className="fm-invoice-select-type" onChange={(e) => {
                                // onchangeInvoiceType(e.target.value)
                                setInvoiceType(e.target.value)
                            }}>
                                {typesOfInvoices?.map((i, index) => {
                                    return (
                                        <option key={index}
                                            className="invoice-type-card-small"
                                            value={i.id}
                                        >
                                            {i.name}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>
                    </div> */}
                    <div className='table_container_finance_manager'>
                        <table>
                            <thead>
                                <tr className='fin_man_table_head text-center'>
                                    <th className="C-pointer" onClick={() => sortInvoiceNo()}>Invoice No <img src="./images/icons/sort.svg" alt="edit-icon" /></th>
                                    <th className="C-pointer" onClick={() => sortInvoiceType()}>Invoice Type <img src="./images/icons/sort.svg" alt="edit-icon" /></th>
                                    <th className="C-pointer" onClick={() => sortCompanyName()}>Company Name <img src="./images/icons/sort.svg" alt="edit-icon" /></th>
                                    <th className="C-pointer" onClick={() => sortBillingPeriod()}>Billing period <img src="./images/icons/sort.svg" alt="edit-icon" /></th>
                                    <th className="C-pointer" onClick={() => sortPreviousInvoiceAmount()} style={{ width: '110px' }}>Previous invoice amount ({formatCurrencyBasedOnRegion()}) <img src="./images/icons/sort.svg" alt="edit-icon" /></th>
                                    <th className="C-pointer" onClick={() => sortCurrentInvoiceAmount()} style={{ width: '110px' }}>Current Invoice amount ({formatCurrencyBasedOnRegion()}) <img src="./images/icons/sort.svg" alt="edit-icon" /></th>
                                    {invoiceType === "On-Hold" && <th className="C-pointer" onClick={() => sortHeldBy()}>Held by <img src="./images/icons/sort.svg" alt="edit-icon" /></th>}
                                    {invoiceType === "rejected" && <th className="C-pointer" onClick={() => sortRejectedBy()}>Rejected by <img src="./images/icons/sort.svg" alt="edit-icon" /></th>}
                                    {(invoiceType === "On-Hold" || invoiceType === "rejected") && <th style={{ width: '230px' }}>Reason</th>}
                                    <th className="C-pointer" onClick={() => sortUpdatedOn()}>Payment Status<FaSort className="icon-sort" alt="edit-icon" /></th>
                                    <th className="C-pointer" onClick={() => sortUpdatedOn()}>Invoice Status<FaSort className="icon-sort" alt="edit-icon" /></th>
                                    <th className="C-pointer" onClick={() => sortUpdatedBy()}>Last Updated<FaSort className="icon-sort" alt="edit-icon" /></th>
                                    <th>Action</th>

                                </tr>
                            </thead>
                            {filteredData === null ?
                                <tbody className='fin_man_table_body'>
                                    <tr className='text-center'>
                                        <td colSpan='11'>No invoices</td>
                                    </tr>
                                </tbody>
                                :
                                <>
                                    {filteredData.length > 0 ? (

                                        <tbody className='fin_man_table_body'>
                                            {filteredData && filteredData?.map((each, index) => {
                                                return (
                                                    <tr key={index} className={`table_row ${index % 2 === 0 ? 'even-row' : 'odd-row'}`}>
                                                        <td className='table_text_left'>{each.invoice_number}</td>
                                                        <td>{each.invoice_type?.toUpperCase()}</td>
                                                        <td>{each.company_name}</td>
                                                        <td >{getMonthName(each.invoice_month) + " " + each.invoice_year}</td>
                                                        <td className='table_text_right'>{each.previous_amount ? <> {each.previous_amount} </> : "-"}</td>
                                                        <td className='table_text_right'>{each.gross_amount ? <> {numberComponent(each.gross_amount)} </> : "-"}</td>
                                                        {invoiceType === "On-Hold" && <td>{each.held_by}</td>}
                                                        {invoiceType === "rejected" && <td>{each.rejected_by}</td>}
                                                        {(invoiceType === "rejected") &&
                                                            <td style={{
                                                                whiteSpace: 'nowrap',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                maxWidth: '200px' // adjust this value as per your requirement
                                                            }}
                                                                title={each.rejected_reason}>
                                                                {/* Invoice is rejected due to improper data */}
                                                                {each.rejected_reason}
                                                            </td>
                                                        }
                                                        {(invoiceType === "On-Hold") &&
                                                            <td style={{
                                                                // whiteSpace: 'nowrap',
                                                                overflow: 'hidden',
                                                                // textOverflow: 'ellipsis',
                                                                maxWidth: '200px' // adjust this value as per your requirement
                                                            }}
                                                                title="Invoice is kept On-Hold by Admin">
                                                                Invoice is kept On-Hold by Admin
                                                            </td>
                                                        }
                                                        {<td title={each?.payment_details} className='table_text_right C-pointer'>{each?.payment_details ? each?.payment_details?.status : '-'}</td>}
                                                        {<td title={each?.status} className='table_text_right'>{each.status}</td>}
                                                        <td >{each?.updated_by?.toUpperCase()}</td>
                                                        <td className='text-decoration-underline text-center' role='button' >
                                                            <img src="./images/icons/ViewEYE.svg" title="view" onClick={() => handleViewButton(each.invoice_number, each.status, each.invoice_type)} alt="view imag" />
                                                            {(invoiceType === "emailed" || invoiceType === "pdfgenerated") && <img src="./images/icons/Download.svg" title="download" onClick={() => handleDownloadpdf(each.pdf_path_on_s3)} alt="download imag" />}
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                            )}
                                        </tbody>
                                    )
                                        :
                                        (

                                            <tbody className='fin_man_table_body'>
                                                <tr className='text-center'>
                                                    <td colSpan='11'>{invoiceListErrorFlag ? 'Error in fetching invoices' : 'No invoices'}</td>
                                                    {/* <td colSpan='11'>{(error!==null) && 'Error while'}</td> */}
                                                </tr>
                                            </tbody>

                                        )
                                    }
                                </>
                            }
                        </table>
                    </div>
                    <Pagination
                        handledPaginationNextClicked={handledPaginationNextClicked}
                        handledPaginationPrevClicked={handledPaginationPrevClicked}
                        isApplyClicked
                        totalRecords={totalRecordsAc}
                        recordsPerPage={RECORDS_PER_PAGE}
                        currentPaginationPage={currentPaginationPageAc}
                    />

                </div>
                }
                {/* invoice preview page */}
                {invoicePage && currentPage !== 3 && <div className="invoice_preview_container">
                    <div style={{ position: "relative" }}>
                        {reusableInvoicePreviewCon()}
                        {reusableInvoicePreviewButtons()}
                    </div>
                </div>
                }
                {/* generate misc invoice */}
                {currentPage === 3 && <div className="invoice_preview_container">

                    <div className="invoice-preview-con">
                        {!preview && <div className="fm-invoice-setting-con">

                            <h1 className="invoice-setting-header">Invoice Details</h1>
                            <p style={{ marginBottom: '3px', marginTop: '15px' }}>Contract Name</p>
                            <Select
                                onChange={(e) => {
                                    setMiscContractName(e)
                                    if (editMiscInvoiceClicked) {
                                        getContractDetailsForEdit(e.value)
                                    } else {
                                        getContractDetails(e.value)
                                    }
                                }}
                                options={contractsDropdown}
                                placeholder="Select Contract"
                                value={miscContractName}
                                noOptionsMessage={() => "No Contracts Available"}
                            />

                            <div style={{ position: "relative", display: "inline-block" }}>
                                <p style={{ marginBottom: '3px', marginTop: '15px', cursor: 'pointer' }}>
                                    Billing Entity
                                    <span
                                        className="info-icon"
                                        onMouseEnter={() => setShowSummary(true)}
                                        onMouseLeave={() => setShowSummary(false)}
                                    >
                                        <IoMdInformationCircleOutline style={{
                                            width: "16px",
                                            height: "16px"
                                        }} />
                                    </span>
                                </p>

                                {/* Hover Card */}
                                {showSummary && billingEntityDropdown && (() => {
                                    const selectedEntity = billingEntities?.find(
                                        entity => entity.partner_company_id === billingEntityDropdown.value
                                    );

                                    if (!selectedEntity) return null;

                                    return (
                                        <div className="hover-summary-card"
                                            onMouseEnter={() => setShowSummary(true)}
                                            onMouseLeave={() => setShowSummary(false)}
                                        >
                                            <div style={{
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                marginBottom: '10px',
                                                color: '#495057',
                                            }}>
                                                Company Summary
                                            </div>

                                            <div style={{ fontSize: '13px', color: '#6c757d' }}>
                                                <div style={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: '10px 20px'
                                                }}>
                                                    <div><strong>GST:</strong> {selectedEntity.gst_number || 'N/A'}</div>
                                                    <div><strong>PAN:</strong> {selectedEntity.pan_number || 'N/A'}</div>
                                                    <div><strong>CIN:</strong> {selectedEntity.cin || 'N/A'}</div>
                                                </div>

                                                {selectedEntity.registered_address && (
                                                    <div style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #dee2e6' }}>
                                                        <strong>Registered Address:</strong>
                                                        <div style={{ lineHeight: '1.6' }}>
                                                            {selectedEntity.registered_address.door_number && `${selectedEntity.registered_address.door_number}, `}
                                                            {selectedEntity.registered_address.street_address_1 && `${selectedEntity.registered_address.street_address_1}, `}
                                                            {selectedEntity.registered_address.street_address_2 && `${selectedEntity.registered_address.street_address_2}, `}
                                                            {selectedEntity.registered_address.city && `${selectedEntity.registered_address.city}, `}
                                                            {selectedEntity.registered_address.state && `${selectedEntity.registered_address.state} - `}
                                                            {selectedEntity.registered_address.postal_code && `${selectedEntity.registered_address.postal_code}, `}
                                                            {selectedEntity.registered_address.country}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })()}
                            </div>

                            {/* 
                            <p style={{ marginBottom: '3px', marginTop: '15px' }}>Billing Entity  <IoMdInformationCircleOutline /></p> */}
                            <Select
                                onChange={(e) => {
                                    setBillingEntityDropdown(e)
                                    const billingEntity = billingEntities.find(each => each.partner_company_id === e.value)
                                    if (billingEntity) {
                                        setBillingEntityDropdown({
                                            label: billingEntity.company_name,
                                            value: billingEntity.partner_company_id
                                        })
                                        if (billingEntity.logo) {
                                            getImage(billingEntity.logo)
                                        } else {
                                            setCompanyLogo(null)
                                        }
                                        setCompanyName(billingEntity.company_name)
                                        const address = billingEntity?.registered_address
                                        setCompanyAddress(`${address?.street_address_1}, ${address?.street_address_2}, ${address?.city}, ${address?.state}, ${address?.postal_code}`)
                                        setPartnerState(address?.state)
                                        setPartnerStateCode(billingEntity?.gst_number?.slice(0, 2))
                                        setCompanyGST(billingEntity?.gst_number)
                                        setPartnerPAN(billingEntity?.pan_number)
                                        setCompanyCIN(billingEntity?.cin)
                                    }
                                    // getContractDetails(e.value)
                                }}
                                options={billingEntityOptions}
                                placeholder="Select Billing Entity"
                                value={billingEntityDropdown}
                                isDisabled={miscContractName === null || miscContractName === "" || editMiscInvoiceClicked}
                            />

                            <p style={{ marginBottom: '3px', marginTop: '15px' }}>Place Of Supply</p>
                            <Select
                                options={stateOptions}
                                value={miscPlaceOfSupply}
                                placeholder="Select Place Of Supply"
                                onChange={e => {
                                    setMiscPlaceOfSupply(e)
                                    setcustomerPlaceOfSupply(e.value)
                                }}
                                noOptionsMessage={() => "No States Available"}
                                isDisabled={miscContractName === null || miscContractName === ""}
                            />
                            <p style={{ marginBottom: '3px', marginTop: '15px' }}>Terms and Conditions</p>
                            <UploadComponent
                                onFilesSelected={handleSelectTermsAndCondition}
                                idType={"termsandconditions"}
                                uploadActionClicked={handleTermsAndConditionsUpload}
                                uploadMethod={"single"}
                                // viewMode={viewClicked}
                                maxNumberOfFiles={1}
                                uploadedFileData={termsAndConditions ? [{ file_name: termsAndConditions?.split("/")[3]?.split("-")[0], file_type: termsAndConditions?.split("/")[3]?.split(".")[1], s3_key: termsAndConditions }] : []}
                                acceptedFileTypes={".pdf"}
                            />




                            <div className="mt-2 d-flex flex-row justify-content-between">
                                <p>Billing Period</p>
                                <label className="switch">
                                    <input type="checkbox"
                                        checked={miscShowBilling} onClick={() => setMiscShowBilling(!miscShowBilling)}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                            <div className="mt-2 d-flex flex-row justify-content-between">
                                <p>Computation Details</p>
                                <label className="switch">
                                    <input type="checkbox"
                                        checked={miscShowComputations} onClick={() => setMiscShowComputations(!miscShowComputations)}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </div>


                            <p style={{ marginBottom: '3px', marginTop: '15px', marginBottom: '15px' }}>List Of Contacts</p>
                            <div className="d-flex flex-column gap-1 ">
                                {miscListOfContacts.length > 0 ?
                                    <>
                                        {miscListOfContacts?.map((contact, index) => {
                                            return (
                                                <div className="">
                                                    <div className="d-flex align-items-start gap-2"
                                                        style={{ marginTop: '-10px' }}
                                                    >
                                                        <input type="checkbox" checked={contact?.sendEmail} onChange={() => {
                                                            let temp = [...miscListOfContacts]
                                                            temp[index].sendEmail = !temp[index].sendEmail
                                                            setMiscListOfContacts([...temp])
                                                            const atleastOneSelected = temp.some((contact) => contact.sendEmail === true)
                                                            setMiscSelectedContacts(atleastOneSelected)
                                                        }} />
                                                        <p style={{ marginTop: '-7px', color: '#000' }} key={index} value={contact}>{contact?.name}{contact?.designation ? `, ${contact?.designation}` : ''}</p>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        {!miscSelectedContacts && <p style={{ fontSize: 'small', marginTop: '-10px', color: 'red' }}>Please select atleast one contact</p>}
                                    </>
                                    :
                                    <p style={{ fontSize: 'small', marginTop: '-10px' }}>{miscContractName?.length > 0 ? 'No Contacts Available' : 'select a contract'}</p>}

                            </div>
                            {/* manditory fields missing message */}
                            {!addMiscInvoiceValidation() && <p style={{ marginBottom: '3px', marginTop: '15px' }}>Manditory Fields Missing</p>}
                            {<p style={{ color: 'red', fontSize: '12px' }}>
                                {miscContractName === null || miscContractName === "" ? 'Contract Name,' : ''}
                                {billingEntityDropdown === null || billingEntityDropdown === "" ? 'Billing Entity,' : ''}
                                {miscPlaceOfSupply === null || miscPlaceOfSupply === "" ? 'Place Of Supply,' : ''}
                                {miscInvoiceTable.length === 0 ? 'Invoice Table,' : ''}
                                {/* if any of the table data is missing */}
                                {/* {miscInvoiceTable.length > 0 && miscInvoiceTable.some((each) => each.service === "" || (each.hsn?.length !== 6 && each.hsn?.length !== 8 ) || !each.basicAmount
                                    ) ? 'Invoice Table fields' : ''} */}
                                {!addMiscInvoiceValidation() && 'Invoice Table fields, '}
                                {termsAndConditions === null ? 'Terms and Conditions' : ''}

                            </p>}
                            {/* <button>Generate Invioce</button> */}
                        </div>}
                        <div className="invoice-preview-scrollable" style={{ width: preview ? '100vw' : '' }}>
                            <div className="invoice-preview-card">
                                <div className="invoice-preview-card-details">
                                    {companyLogo ? <div className="invoice-logo-placeholder">
                                        <div>
                                            <img style={{ width: '15rem', height: '5rem' }} src={companyLogo} alt="company logo" />
                                        </div>
                                    </div> :
                                        <p style={{ marginTop: '10px' }}></p>}
                                    <div className="d-flex justify-content-between w-100">
                                        <div className="invoice-header-address text-center" style={{ marginTop: "-50px" }}>
                                            <h5>{companyName?.toUpperCase()}</h5>
                                            <p style={{ textAlign: 'center' }}><span ><b>Reg.Office:</b> {companyAddress}</span></p>
                                        </div>
                                        {
                                            QrCode?.length > 0 ?
                                                <QRCode style={{ marginTop: '-70px' }} value={QrCode} size={170} />
                                                :
                                                <div className="invoice-bar-code" style={{ marginTop: '-70px' }}>
                                                    {invoiceStatus === "rejected" ? (
                                                        <p className="rejected-text">Rejected</p>
                                                    ) : (
                                                        <p className="qr-code-text">QR Code</p>
                                                    )}
                                                </div>
                                        }

                                    </div>
                                    <h5 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>Tax Invoice</h5>
                                    {/* <h6 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>{miscInvoiceTable[0]?.service ?<> ({miscInvoiceTable[0]?.service}) </>: ''}</h6> */}

                                    <div className="invoice-preview-inner-card-div">
                                        <div className="invoice-preview-inner-card">
                                            <div style={{ width: '100%' }}>
                                                <p>
                                                    <b style={{ fontSize: "18px" }}>Buyer </b>
                                                    <br /> <b>{customerName}</b><br />
                                                    <div className="invoice-left-data">
                                                        <span className="key"><b>Billed To</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value"> {customerAddress}</span>
                                                    </div>
                                                    {toggleShippingAddress && <div className="invoice-left-data">
                                                        <span className="key"><b>Shipped To</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value">
                                                            {streetAddress ?
                                                                <>
                                                                    {streetAddress}{streetAddress ? ", " : ""} {city}{city ? ", " : ""} {state}{state ? ", " : ""} {pincode}
                                                                </>
                                                                :
                                                                <>
                                                                    {shippingAddress}
                                                                </>
                                                            }
                                                        </span>
                                                    </div>}
                                                    <div className="invoice-left-data">
                                                        <span className="key"><b>State Code</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value"> {customerStateCode}</span>
                                                    </div>
                                                    <div className="invoice-left-data">
                                                        <span className="key"><b>GSTIN</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value"> {customerGSTIN}</span>
                                                    </div>
                                                    <div className="invoice-left-data">
                                                        <span className="key"><b>PAN</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value"> {customerPAN}</span>
                                                    </div>
                                                    <div className="invoice-left-data">
                                                        <span className="key"><b>CIN</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value"> {customerCIN}</span>
                                                    </div>
                                                    <div className="invoice-left-data">
                                                        <span className="key"><b>Place Of Supply</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value"> {customerPlaceOfSupply}</span>
                                                    </div>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="invoice-address-right">
                                            <div >
                                                <br />
                                                <p> <b>Contract No   </b> </p>
                                                <p><b>Invoice No</b> </p>
                                                <p><b>State</b></p>
                                                <p><b>State Code</b> </p>
                                                <p><b>GSTIN</b></p>
                                                <p><b>PAN</b></p>
                                                <p><b>CIN</b></p>
                                                <br />
                                                <p><b>Invoice Date</b></p>
                                                <p><b>Due Date</b></p>

                                            </div>
                                            <div style={{ marginLeft: "20px" }}>
                                                <br />
                                                <p>: {contractNo}</p>
                                                <p>: {editMiscInvoiceClicked ? invoiceNo : 'Generated at creation'}</p>
                                                <p>: {parnterState}</p>
                                                <p>: {partnerStateCode}</p>
                                                <p>: {companyGST}</p>
                                                <p>: {partnerPAN}</p>
                                                <p>: {companyCIN}</p>

                                                <br />
                                                <p>: {ackDate}</p>
                                                <p>: {partnerDueDate}</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="invoice-preview-card-details-bottom">
                                    <div className="invoice-preview-inner-card-2">
                                        <p><span><b>IRN :</b> </span>{IRN}<br /></p>
                                    </div>
                                </div>
                                <div className="invoice-preview-table-container">
                                    <Table className="invoice-preview-table">
                                        <thead>
                                            <tr>
                                                <th colSpan={5} rowSpan={2} style={{ width: "220px" }}>Service Description</th>
                                                <th colSpan={1} rowSpan={2} >SAC/HSN</th>
                                                {miscShowBilling && <th colSpan={2} >Bill Period</th>}
                                                {miscShowComputations && <th colSpan={1} rowSpan={2}>Total Units</th>}
                                                {miscShowComputations && <th colSpan={1} rowSpan={2}>Rate</th>}
                                                <th colSpan={1}>Basic Amount</th>
                                                {!igstToggle && <th colSpan={2}>SGST</th>}
                                                {!igstToggle && <th colSpan={2}>CGST</th>}
                                                {igstToggle && <th colSpan={2}>IGST</th>}
                                                <th colSpan={1}>GROSS</th>
                                            </tr>
                                            <tr>
                                                {miscShowBilling && <><th>From</th>
                                                    <th>To</th>
                                                </>}

                                                <th colSpan={1}>Amount ({formatCurrencyBasedOnRegion()})</th>
                                                {!igstToggle && <th>Rate %</th>}
                                                {!igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                                {!igstToggle && <th>Rate %</th>}
                                                {!igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                                {igstToggle && <th>Rate %</th>}
                                                {igstToggle && <th>Amount</th>}
                                                <th>Amount ({formatCurrencyBasedOnRegion()})</th>
                                            </tr>
                                        </thead>
                                        <tbody className="misc-invoice-tbody">
                                            {miscInvoiceTable?.map((each, index) => (
                                                <tr >
                                                    {/* service description */}
                                                    <th colSpan={5} style={{ color: 'gray', fontWeight: 'bold' }} className="text-start">
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Service Name"
                                                            value={each.service}
                                                            onChange={(e) => {
                                                                let input = e.target.value;

                                                                // Allow space only if there is a preceding character
                                                                if (/^\s/.test(input)) {
                                                                    input = input.trimStart(); // Prevent starting with space
                                                                }

                                                                if (/\s{2,}/.test(input)) {
                                                                    input = input.replace(/\s{2,}/g, ' '); // Prevent consecutive spaces
                                                                }

                                                                // Update the state
                                                                let temp = [...miscInvoiceTable];
                                                                temp[index].service = input;
                                                                setMiscInvoiceTable(temp);
                                                            }}
                                                            onBlur={(e) => {
                                                                // Trim spaces when the user leaves the field
                                                                const trimmedValue = e.target.value.trim();
                                                                let temp = [...miscInvoiceTable];
                                                                temp[index].service = trimmedValue;
                                                                setMiscInvoiceTable(temp);
                                                            }}
                                                            style={{
                                                                paddingLeft: '0px',
                                                                fontWeight: 'normal',
                                                                backgroundColor: each.service.length === 0 ? '#deeff5' : 'transparent',
                                                            }}
                                                        />

                                                        {miscInvoiceServiceIntifier}
                                                    </th>
                                                    {/* sac/hsn */}
                                                    <th className="text-start">
                                                        <div style={{
                                                            // width: '8rem',
                                                            margin: 0,
                                                        }}>
                                                            <input type="text" value={each.hsn} onChange={(e) => {
                                                                let temp = [...miscInvoiceTable]
                                                                const input = e.target.value
                                                                const formattedInput = input.replace(/[^0-9]/g, '')
                                                                const trimmedInput = formattedInput.trim();
                                                                if (trimmedInput.length <= 8) {
                                                                    temp[index].hsn = trimmedInput
                                                                }
                                                                if ((trimmedInput.length < 6 && trimmedInput.length > 0) || (trimmedInput.length === 7 && trimmedInput.length > 0)) {
                                                                    temp[index].hsnError = true
                                                                    temp[index].hsnLoader = false
                                                                    temp[index].hsnMsg = ''
                                                                } else {
                                                                    temp[index].hsnError = false
                                                                    if (trimmedInput.length !== 0) {
                                                                        temp[index].hsnLoader = true
                                                                        // lol bellow one not working
                                                                        setTimeout(() => {
                                                                            temp[index].hsnLoader = false
                                                                            temp[index].hsnMsg = 'HSN Description'
                                                                        }, 2000)
                                                                    }
                                                                }
                                                                setMiscInvoiceTable(temp)
                                                            }}
                                                                placeholder="Enter HSN"
                                                                style={{
                                                                    width: '100%',
                                                                    paddingLeft: '0px',
                                                                    fontWeight: 'normal',
                                                                    backgroundColor: each.hsn.length === 0 ? '#deeff5' : 'transparent',
                                                                }}
                                                            />
                                                            {/* add this if hsn code is there */}
                                                            {/* {each.hsnLoader && <Spinner style={{ height: "15px", width: "15px" }} animation="border" />} */}
                                                        </div>
                                                        {/* <br /> */}
                                                        {each.hsnError && <span style={{ color: 'red', width: '40% !important' }} >Invalid HSN code</span>}
                                                        {/* {!each.hsnError && <span style={{ color: 'red', width: '40% !important' }} >{each?.hsnMsg}</span>} */}
                                                    </th>
                                                    {/* Area */}
                                                    {miscShowBilling && <th>
                                                        <input type="date" style={{ textAlign: 'end' }} value={each.from_date} onChange={(e) => {
                                                            let temp = [...miscInvoiceTable];
                                                            const input = e.target.value;
                                                            if (input > each.to_date) {
                                                                // clear to date
                                                                temp[index].to_date = ''
                                                            }
                                                            temp[index].from_date = input;
                                                            setMiscInvoiceTable(temp);

                                                        }}
                                                        // placeholder="dd-mm-yyyy"
                                                        />
                                                    </th>}
                                                    {miscShowBilling && <th>
                                                        <input type="date" style={{ textAlign: 'end' }}
                                                            value={each.to_date}
                                                            min={each.from_date}
                                                            onChange={(e) => {
                                                                let temp = [...miscInvoiceTable];
                                                                temp[index].to_date = e.target.value;
                                                                setMiscInvoiceTable(temp);

                                                            }}
                                                        // placeholder="dd-mm-yyyy"
                                                        />
                                                    </th>}
                                                    {/* rate */}
                                                    {miscShowComputations && <th>
                                                        <input type="text" style={{ textAlign: 'end' }} value={each.consumption} onChange={(e) => {
                                                            let temp = [...miscInvoiceTable];
                                                            const input = e.target.value;
                                                            const formattedInput = input.replace(/[^0-9.]/g, '');
                                                            const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                            const trimmedInput = validInput.trim();


                                                            // Check if the input has more than 2 decimal places
                                                            const decimalIndex = trimmedInput.indexOf('.');
                                                            if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                                return; // Ignore the input if it has more than 2 decimal places
                                                            }

                                                            // Check if the input is a positive number
                                                            if (parseFloat(trimmedInput) < 0) {
                                                                return; // Ignore the input if it is negative
                                                            }

                                                            temp[index].consumption = trimmedInput;
                                                            if (trimmedInput.length === 0) {
                                                                temp[index].consumption = 0.0
                                                            }
                                                            if (temp[index].rate_per_unit.length > 0) {
                                                                temp[index].basicAmount = (parseFloat(trimmedInput) * parseFloat(temp[index].rate_per_unit)).toFixed(2)
                                                            }
                                                            temp[index].consumption = trimmedInput;
                                                            setMiscInvoiceTable(temp);
                                                            calculateTotalBasicAmount();
                                                            calculateTotalTaxAmount();

                                                        }}


                                                        />
                                                    </th>}
                                                    {miscShowComputations && <th>
                                                        <input type="text" style={{ textAlign: 'end' }} value={each.rate_per_unit} onChange={(e) => {
                                                            let temp = [...miscInvoiceTable];
                                                            const input = e.target.value;
                                                            const formattedInput = input.replace(/[^0-9.]/g, '');
                                                            const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                            const trimmedInput = validInput.trim();


                                                            // Check if the input has more than 2 decimal places
                                                            const decimalIndex = trimmedInput.indexOf('.');
                                                            if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                                return; // Ignore the input if it has more than 2 decimal places
                                                            }

                                                            // Check if the input is a positive number
                                                            if (parseFloat(trimmedInput) < 0) {
                                                                return; // Ignore the input if it is negative
                                                            }

                                                            temp[index].rate_per_unit = trimmedInput;
                                                            if (trimmedInput.length === 0) {
                                                                temp[index].rate_per_unit = 0.0
                                                            }
                                                            if (temp[index].consumption.length > 0) {
                                                                temp[index].basicAmount = (parseFloat(temp[index].consumption) * parseFloat(trimmedInput)).toFixed(2)
                                                            }
                                                            temp[index].rate_per_unit = trimmedInput;
                                                            setMiscInvoiceTable(temp);
                                                            calculateTotalBasicAmount();
                                                            calculateTotalTaxAmount();
                                                        }}
                                                        />
                                                    </th>}
                                                    {/* basic amount */}
                                                    <th>
                                                        <input type="text" style={{ textAlign: 'end' }} value={each.basicAmount}
                                                            // maxLength={12}
                                                            onChange={(e) => {
                                                                let temp = [...miscInvoiceTable];
                                                                const input = e.target.value;
                                                                const formattedInput = input.replace(/[^0-9.]/g, '');
                                                                const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                                const trimmedInput = validInput.trim();


                                                                // Check if the input has more than 2 decimal places
                                                                const decimalIndex = trimmedInput.indexOf('.');
                                                                if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                                    return; // Ignore the input if it has more than 2 decimal places
                                                                }

                                                                // Check if the input is a positive number
                                                                if (parseFloat(trimmedInput) < 0) {
                                                                    return; // Ignore the input if it is negative
                                                                }

                                                                temp[index].basicAmount = trimmedInput;
                                                                if (trimmedInput.length === 0) {
                                                                    temp[index].basicAmount = 0.0
                                                                }
                                                                setMiscInvoiceTable(temp);
                                                                calculateTotalBasicAmount();
                                                                calculateTotalTaxAmount();
                                                            }} />
                                                    </th>

                                                    {/* sgst rate*/}
                                                    {!igstToggle && <th>
                                                        <select value={each.sgst} onChange={(e) => {
                                                            let temp = [...miscInvoiceTable]
                                                            temp[index].sgst = e.target.value
                                                            temp[index].cgst = e.target.value
                                                            setMiscInvoiceTable(temp)
                                                            calculateTotalTaxAmount()
                                                        }}>
                                                            {miscCgstSgstOptions.map((option, index) => {
                                                                return (
                                                                    <option key={index} value={option}>{option}</option>
                                                                )
                                                            })}
                                                        </select>
                                                    </th>}
                                                    {/* sgst amount*/}
                                                    {!igstToggle && (
                                                        <th className="text-end">
                                                            {formatToIndianRupee(((each.basicAmount / 100) * each.sgst).toFixed(2))}
                                                        </th>
                                                    )}
                                                    {/* cgst rate*/}
                                                    {!igstToggle && <th>
                                                        <select value={each.cgst} onChange={(e) => {
                                                            let temp = [...miscInvoiceTable]
                                                            temp[index].sgst = e.target.value
                                                            temp[index].cgst = e.target.value
                                                            setMiscInvoiceTable(temp)
                                                            calculateTotalTaxAmount()
                                                        }}>
                                                            {miscCgstSgstOptions.map((option, index) => {
                                                                return (
                                                                    <option key={index} value={option}>{option}</option>
                                                                )
                                                            })}
                                                        </select>
                                                    </th>}
                                                    {/* cgst amount*/}
                                                    {!igstToggle && (
                                                        <th className="text-end">
                                                            {formatToIndianRupee(((each.basicAmount / 100) * each.cgst).toFixed(2))}
                                                        </th>
                                                    )}
                                                    {/* igst rate*/}
                                                    {igstToggle && <th>
                                                        <select value={each.igst} onChange={(e) => {
                                                            let temp = [...miscInvoiceTable]
                                                            temp[index].igst = e.target.value
                                                            setMiscInvoiceTable(temp)
                                                            calculateTotalTaxAmount()
                                                        }}>
                                                            {miscIgstOptions.map((option, index) => {
                                                                return (
                                                                    <option key={index} value={option}>{option}</option>
                                                                )
                                                            })}
                                                        </select>
                                                    </th>}
                                                    {/* igst amount*/}
                                                    {igstToggle && (
                                                        <th className="text-end">
                                                            {formatToIndianRupee(((each.basicAmount / 100) * each.igst).toFixed(2))}
                                                        </th>
                                                    )}
                                                    {/* gross amount */}
                                                    <th className="text-end">
                                                        {igstToggle
                                                            ? formatToIndianRupee(
                                                                (parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.igst)).toFixed(2)
                                                            )
                                                            : formatToIndianRupee(
                                                                (parseFloat(each.basicAmount) +
                                                                    parseFloat((each.basicAmount / 100) * each.cgst) +
                                                                    parseFloat((each.basicAmount / 100) * each.sgst)).toFixed(2)
                                                            )}
                                                    </th>
                                                </tr>)
                                            )}
                                            {/* Grand Total */}
                                            <tr >
                                                {/* service description */}
                                                <th colSpan={5} style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
                                                    Total
                                                </th>
                                                {/* sac/hsn */}

                                                <th className="text-start">
                                                </th>
                                                {miscShowBilling && <th className="text-start">
                                                </th>}
                                                {miscShowBilling && <th className="text-start">
                                                </th>}
                                                {miscShowComputations && <th className="text-start">
                                                </th>}
                                                {miscShowComputations && <th className="text-start">
                                                </th>}
                                                {/* basic amount */}
                                                <th className="text-end">
                                                    {formatToIndianRupee(miscTotalBasicAmount)}
                                                </th>
                                                {/* sgst rate*/}
                                                {!igstToggle && <th>

                                                </th>}
                                                {/* sgst amount*/}
                                                {!igstToggle && <th className="text-end">
                                                    {formatToIndianRupee((miscTotalTaxAmount / 2).toFixed(2))}
                                                </th>}
                                                {/* cgst rate*/}
                                                {!igstToggle && <th>

                                                </th>}
                                                {/* cgst amount*/}
                                                {!igstToggle && <th className="text-end">
                                                    {formatToIndianRupee((miscTotalTaxAmount / 2).toFixed(2))}
                                                </th>}
                                                {/* igst rate*/}
                                                {igstToggle && <th>

                                                </th>}
                                                {/* igst amount*/}
                                                {igstToggle && <th className="text-end">{formatToIndianRupee(miscTotalTaxAmount.toFixed(2))}</th>}
                                                {/* gross amount */}
                                                <th className="text-end">
                                                    {formatToIndianRupee((parseFloat(miscTotalBasicAmount) + parseFloat(miscTotalTaxAmount)).toFixed(2))}
                                                    {/* parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.igst)) : formatToIndianRupee(parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.cgst) + parseFloat((each.basicAmount / 100) * each.sgst))} */}
                                                </th>
                                            </tr>
                                        </tbody>
                                    </Table>
                                    <div style={{ display: "flex", justifyContent: "end", marginTop: "-13px", marginBottom: '30px' }}>
                                        <p style={{ marginRight: '10px', textDecoration: 'underline', fontSize: '12px', marginTop: '1px' }}>Add a row : </p>
                                        {
                                            <FiPlusCircle
                                                style={{ height: '20px', width: '20px', marginRight: '10px', color: 'blue' }}
                                                onClick={() => {
                                                    let temp = [...miscInvoiceTable]
                                                    temp.push({
                                                        service: "", hsn: "", hsnError: false, hsnLoader: false, hsnMsg: '', basicAmount: 0.0, cgst: 9.0, sgst: 9.0, igst: 18.0, gross: 0.0
                                                        , consumption: 0.0, rate_per_unit: 0.0, from_date: '', to_date: ''
                                                    })
                                                    setMiscInvoiceTable(temp)
                                                }}
                                                alt="add"
                                                className="C-pointer"
                                                title="Add row below"
                                            />

                                        }
                                        {
                                            miscInvoiceTable.length >= 2 ?
                                                <FiMinusCircle
                                                    style={{ height: '20px', width: '20px', color: 'blue' }}
                                                    onClick={() => {
                                                        let temp = [...miscInvoiceTable]
                                                        temp.pop()
                                                        setMiscInvoiceTable(temp)
                                                        calculateTotalBasicAmount(temp)
                                                        calculateTotalTaxAmount(temp)
                                                    }}
                                                    className="C-pointer"
                                                    alt="remove"
                                                    title="Delete last row"
                                                />
                                                : null
                                        }

                                    </div>
                                    <div className="invoice-preview-total-con">
                                        <div className="invoice-preview-total-con-left">
                                            <span>
                                                <b>Total Invoice Amount In Words ({formatCurrencyBasedOnRegion()}) : </b>
                                            </span>
                                            <p >{convertCurrencyToWords((parseFloat(miscTotalBasicAmount) + parseFloat(miscTotalTaxAmount)).toFixed(2))} {convertCurrencyToWords(parseFloat(miscTotalBasicAmount) + parseFloat(miscTotalTaxAmount).toFixed(2)) ? '' : ''}
                                            </p>
                                        </div>
                                        <div className="invoice-preview-total d-flex">
                                            <p className="invoice-preview-total-key" >Total : </p>
                                            <p className="invoice-preview-total-value" >&nbsp;
                                                &nbsp;{formatToIndianRupee((parseFloat(miscTotalBasicAmount) + parseFloat(miscTotalTaxAmount)).toFixed(2))} <span>{formatCurrencyBasedOnRegion()}</span></p>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    {!preview && <div className="invoice-preview-buttons">
                        {(invoiceStatus === "pdfgenerated" || invoiceStatus === "gstsubmitted" || invoiceStatus === "emailed")
                            &&
                            <Dropdown as={ButtonGroup}>
                                <Dropdown.Toggle id="dropdown-basic" className="custom-toggle">
                                    Credit/Debit
                                </Dropdown.Toggle>

                                <Dropdown.Menu style={{ width: 'max-content' }}>
                                    <Dropdown.Item onClick={() => {
                                        navigate('/CreditAndDebit', {
                                            state: {
                                                invoice_number: invoiceNo,
                                                facilityId: localStorage.getItem('selected_facility_id'),
                                                noteType: 'Credit'
                                            }
                                        });
                                    }}>Credit Note</Dropdown.Item>
                                    <Dropdown.Item onClick={() => {
                                        navigate('/CreditAndDebit', {
                                            state: {
                                                noteType: 'Debit',
                                                invoice_number: invoiceNo,
                                                facilityId: localStorage.getItem('selected_facility_id'),
                                            }
                                        });
                                    }}>Debit Note</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>

                        }
                        <button className="secondary-button" onClick={() => { setCurrentPage(1); backFunction(); backPagination() }}> Back</button>
                        {editMiscInvoiceClicked ?
                            <button style={{ opacity: addMiscInvoiceValidation() ? '100%' : '50%' }}
                                disabled={addMiscInvoiceValidation() ? false : true}
                                onClick={() => { editMiscInvoice() }}>Regenerate</button>
                            :
                            <button className="primary-button" style={{ opacity: addMiscInvoiceValidation() ? '100%' : '50%' }}
                                disabled={addMiscInvoiceValidation() ? false : true}
                                onClick={() => { addMiscInvoice() }}>Generate</button>}
                    </div>}
                    {preview && <div className="invoice-preview-buttons">
                        <button onClick={() => setPreview(false)}> Back</button>
                    </div>}
                </div>
                }


                <Modal
                    show={slfShow}
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}
                    centered
                    className="slf-preview-modal"
                    size="lg"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Fee Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="slf-preview-table-con">
                            <Table className="slf-preivew-table">
                                <thead>
                                    <tr>
                                        <th>Year</th>
                                        <th>Space</th>
                                        <th>License Fee</th>
                                        <th>Escalation Rate</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th>Locking Period</th>
                                        <th>Payment Term</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {slfDetails?.map((each, index) => {
                                        return (
                                            <tr className="d-flex" key={index}>
                                                <th>{each.year}</th>
                                                <th>{each.space}</th>
                                                <th>{each.license_fee}</th>
                                                <th>{each.escation}</th>
                                                <th>{each.start_date}</th>
                                                <th>{each.end_date}</th>
                                                <th>{each.locking_period}</th>
                                                <th>{each.Payement}</th>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    </Modal.Body>
                </Modal>
                {/* for rejection pop up */}
                <Modal keyboard={false} backdrop="static" show={rejectModal} centered className="popper-modal">
                    <Modal.Body className="text-center mt-4">
                        <>
                            <h5>Do you reject this invoice?</h5>
                            <p style={{ textAlign: 'start', marginBottom: '-1px' }}>Please mention reason for rejection</p>
                            <textarea
                                name=""
                                id=""
                                value={rejectReason}
                                onChange={e => {
                                    const value = e.target.value.trimStart(); // Remove leading spaces
                                    const regex = /^[a-zA-Z0-9 .,!?@#%^&*()_+=-]*$/; // Allow only standard keyboard characters
                                    if (regex.test(value)) {
                                        if (value.length <= 250) {
                                            setRejectReason(value);
                                            setRejectReasonError("");
                                        } else {
                                            setRejectReasonError("Cannot exceed 250 characters");
                                        }
                                    } else {
                                        setRejectReasonError("Invalid characters entered");
                                    }
                                }}
                                style={{ width: '100%', borderRadius: '8px', borderColor: 'grey', outline: "none", padding: '10px' }}
                                rows="5"
                            ></textarea>
                        </>
                    </Modal.Body>
                    <Modal.Footer className="footer d-flex justify-content-center">
                        <Button style={{ width: `45%` }} variant="secondary" className="secondary" onClick={() => {
                            setRejectReason('');
                            setRejectReasonError('');
                            setRejectModal(false);
                        }}>
                            Close
                        </Button>
                        <Button style={{ width: `45%`, opacity: rejectReason.length > 0 ? '100%' : '50%' }} variant="secondary" className="secondary"
                            disabled={rejectReason.length <= 0}
                            onClick={() => {
                                const trimmedReason = rejectReason.trim(); // Trim leading and trailing spaces on submit
                                if (!trimmedReason) {
                                    setRejectReasonError("Reason cannot be empty");
                                } else {
                                    setRejectReasonError("");
                                    setRejectModal(false);
                                    rejectAnInvoice(trimmedReason); // Proceed with the valid reason
                                }
                            }}
                        >
                            Reject
                        </Button>
                    </Modal.Footer>
                </Modal>
                {(loading || isLoading) && <FormLoader />}
                {contractApiLoader && <FormLoader />}
            </div>
            <Footer />
        </>
    )
}

export default FinanceManagerInvoice

{/* SLF invoice */ }
// {currentPage === 5 && <div className="invoice_preview_container">

//     <div className="invoice-preview-con">
//         {/* <div className="invoice-preview-scrollable" style={{ margin: preview || (invoiceStatus !== "rejected" && invoiceStatus!=='onhold' && invoiceStatus!== "draft") ? 'auto' : '' }}> */}
//         <div className="invoice-preview-scrollable" style={{ margin: 'auto' }}>
//             <div className="invoice-preview-card">
//                 <div className="invoice-preview-card-details">
//                     {companyLogo && <div className="invoice-logo-placeholder">
//                         <div>
//                             <img style={{ width: '15rem', height: '5rem' }} src={companyLogo} alt="company logo" />
//                         </div>
//                     </div>}
//                     <div className="d-flex justify-content-between w-100">
//                         <div className="invoice-header-address">
//                             <h5
//                                 className="invoice-header-title"
//                                 style={{
//                                     fontSize: `${Math.max(40 - (companyName?.length ? companyName?.length * 0.3 : 1), 20)}px`
//                                 }}
//                             >
//                                 {companyName?.toUpperCase()}

//                             </h5>
//                             <p style={{
//                                 textAlign: 'center'
//                             }}><span ><b>Reg.Office:</b> {companyAddress}</span></p>
//                         </div>
//                         {
//                             QrCode?.length > 0 ?
//                                 <QRCode style={{ marginTop: '-70px' }} value={QrCode} size={170} />
//                                 :
//                                 <div className="invoice-bar-code">
//                                     {invoiceStatus === "rejected" ? (
//                                         <p className="rejected-text">Rejected</p>
//                                     ) : (
//                                         <p className="qr-code-text">QR Code</p>
//                                     )}
//                                 </div>
//                         }

//                     </div>
//                     <h5 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>Tax Invoice</h5>
//                     <h6 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>({serviceNameInInvoice})</h6>
//                     <div className="invoice-preview-inner-card-div">
//                         <div className="invoice-preview-inner-card">
//                             <div style={{ width: '100%' }}>
//                                 <p>
//                                     <b style={{ fontSize: "18px" }}>Buyer </b>
//                                     <br /> <b>{customerName}</b><br />
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>Billed To</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerAddress}</span>
//                                     </div>
//                                     {toggleShippingAddress && <div className="invoice-left-data">
//                                         <span className="key"><b>Shipped To</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value">  {shippingAddress}</span>
//                                     </div>}
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>State Code</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerStateCode}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>GSTIN</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerGSTIN}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>PAN</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerPAN}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>CIN</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerCIN}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>Place Of Supply</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerPlaceOfSupply}</span>
//                                     </div>
//                                 </p>
//                             </div>
//                         </div>
//                         <div className="invoice-address-right">
//                             <div >
//                                 <br />
//                                 <p> <b>Contract No   </b> </p>
//                                 <p><b>Invoice No</b> </p>
//                                 <p><b>State</b></p>
//                                 <p><b>State Code</b> </p>
//                                 <p><b>GSTIN</b></p>
//                                 <p><b>PAN</b></p>
//                                 <p><b>CIN</b></p>
//                                 <br />
//                                 <p><b>Invoice Date</b></p>
//                                 <p><b>Due Date</b></p>

//                             </div>
//                             <div style={{ marginLeft: "20px" }}>
//                                 <br />
//                                 <p>: {contractNo}</p>
//                                 <p>: {invoiceNo}</p>
//                                 <p>: {parnterState}</p>
//                                 <p>: {partnerStateCode}</p>
//                                 <p>: {companyGST}</p>
//                                 <p>: {partnerPAN}</p>
//                                 <p>: {companyCIN}</p>

//                                 <br />
//                                 <p>: {ackDate}</p>
//                                 <p>: {partnerDueDate}</p>
//                             </div>
//                         </div>
//                     </div>

//                 </div>
//                 <div className="invoice-preview-card-details-bottom">
//                     <div className="invoice-preview-inner-card-2">
//                         <p><span><b>IRN :</b> </span>{IRN}<br />
//                         </p>
//                     </div>
//                 </div>

//                 <div className="invoice-preview-table-container">
//                     <Table className="invoice-preview-table">
//                         <thead>
//                             <tr>
//                                 <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
//                                 <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
//                                 <th colSpan={2}><b>Bill Period </b></th>
//                                 {showComputationDetails && <th colSpan={1}><b>Total Area</b></th>}
//                                 {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
//                                 <th colSpan={1}><b>Basic Amount</b></th>
//                                 {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
//                                 {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
//                                 {igstToggle && <th colSpan={2}><b>IGST</b></th>}
//                                 <th colSpan={1}><b>GROSS</b></th>
//                             </tr>
//                             <tr>

//                                 <th>From</th>
//                                 <th>To</th>
//                                 {showComputationDetails && <th>Sq. ft</th>}
//                                 {showComputationDetails && <th> ({formatCurrencyBasedOnRegion()} / Sq. ft)</th>}
//                                 <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
//                                 {!igstToggle && <th>Rate <br /> (%)</th>}
//                                 {!igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
//                                 {!igstToggle && <th>Rate <br />(%)</th>}
//                                 {!igstToggle && <th>Amount<br /> ({formatCurrencyBasedOnRegion()})</th>}
//                                 {igstToggle && <th>Rate <br />(%)</th>}
//                                 {igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
//                                 <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
//                             </tr>
//                         </thead>
//                         <tbody >
//                             {invoiceDetails?.map((item, index) => {
//                                 return (
//                                     <tr key={index}>
//                                         <th className="text-start">{item?.service_name_in_invoice?.toUpperCase()},<br />
//                                             {item?.service_identifier}
//                                         </th>
//                                         <th className="text-start">{item?.hsn}</th>
//                                         <th style={{ textAlign: 'end' }}>{(formatDateBasedOnValue(formatDateView(item.from_date)))}</th>
//                                         <th style={{ textAlign: 'end' }}>
//                                             <div>
//                                                 {formatDateBasedOnValue(formatDateView(item.to_date))}
//                                             </div>
//                                         </th>
//                                         {showComputationDetails && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.consumption)}</th>}
//                                         {showComputationDetails && <th style={{ textAlign: 'end' }}><div>
//                                             {formatToIndianRupee(item.rate_per_unit)}
//                                         </div></th>}
//                                         <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.net_amount)}</th>

//                                         {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst_rate)}</th>}
//                                         {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst)}</th>}
//                                         {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst_rate)}</th>}
//                                         {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst)}</th>}
//                                         {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst_rate)}</th>}
//                                         {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst)}</th>}
//                                         <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.gross_amount)}</th>
//                                     </tr>
//                                 )
//                             })
//                             }
//                             {/* Grand Total */}
//                             <tr >
//                                 {/* service description */}
//                                 <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
//                                     Total
//                                 </th>
//                                 {/* sac/hsn */}
//                                 <th className="text-start">
//                                 </th>
//                                 <th className="text-start">
//                                 </th>
//                                 <th className="text-start">
//                                 </th>
//                                 <th className="text-start">
//                                 </th>
//                                 <th className="text-start">
//                                 </th>
//                                 {/* basic amount */}
//                                 <th className="text-end">
//                                     {formatToIndianRupee(basicAmount)}
//                                 </th>
//                                 {/* sgst rate*/}
//                                 {!igstToggle && <th>

//                                 </th>}
//                                 {/* sgst amount*/}
//                                 {!igstToggle && <th className="text-end">
//                                     {formatToIndianRupee(totalSgst)}
//                                 </th>}
//                                 {/* cgst rate*/}
//                                 {!igstToggle && <th>

//                                 </th>}
//                                 {/* cgst amount*/}
//                                 {!igstToggle && <th className="text-end">
//                                     {formatToIndianRupee(totalCgst)}
//                                 </th>}
//                                 {/* igst rate*/}
//                                 {igstToggle && <th>

//                                 </th>}
//                                 {/* igst amount*/}
//                                 {igstToggle && <th className="text-end">{formatToIndianRupee(totalIgst)}</th>}
//                                 {/* gross amount */}
//                                 <th className="text-end">
//                                     {formatToIndianRupee(TotalAmount)}
//                                     {/* parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.igst)) : formatToIndianRupee(parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.cgst) + parseFloat((each.basicAmount / 100) * each.sgst))} */}
//                                 </th>
//                             </tr>
//                         </tbody>
//                     </Table>
//                     <div className="invoice-preview-total-con">
//                         <div className="invoice-preview-total-con-left">
//                             <span>
//                                 <b>Total Invoice Amount In Words ({formatCurrencyBasedOnRegion()}) : </b>
//                             </span>
//                             <p >{totalAmountInWords}
//                             </p>
//                         </div>
//                         <div className="invoice-preview-total d-flex">
//                             <p className="invoice-preview-total-key" >Total : </p>
//                             {/* <span className="diagonal-line"></span> */}
//                             {/* <span></span> */}
//                             <p className="invoice-preview-total-value" >&nbsp;
//                                 &nbsp;{formatToIndianRupee(TotalAmount)} {formatCurrencyBasedOnRegion()}</p>
//                         </div>
//                     </div>
//                     {userNotesToggle && <div className="invoice-user-notes-div">
//                         <p className="invoice-user-notes">User Notes</p>
//                         <p>{userNotes}</p>
//                     </div>}
//                 </div>
//                 <div className="signature">
//                     <p></p>
//                     <p>sign here</p>
//                 </div>

//             </div>
//             {/* {!preview && !(invoiceStatus !== "rejected" && invoiceStatus!=='onhold' && invoiceStatus!== "draft") && (<div className="chat-feature">
//                 <div className="chatbox">
//                     <div className="chat-user">
//                         <p className="name">User-name</p>
//                         <p>13-02-24 15:25</p>
//                     </div>
//                     <p>
//                         Lorem ipsum dolor <span>@fin-man</span>, consectetur adipiscing elit. Maecenas vulputate,
//                         leo eu bibendum sollicitudin, risus velit posuere libero, vitae aliquet turpis
//                         sem eu massa. Proin vitae consequat ligula. Duis erat massa, imperdiet at turpis ac,
//                         luctus aliquet sapien. Nullam
//                     </p>
//                 </div>
//                 <div className="chatbox">
//                     <div className="chat-user">
//                         <p className="name">CEO</p>
//                         <p>13-02-24 15:25</p>
//                     </div>
//                     <p>
//                         Lorem ipsum dolor <span>@fin-man</span>, consectetur adipiscing elit. Maecenas vulputate,
//                         leo eu bibendum sollicitudin, risus velit posuere libero, vitae aliquet turpis
//                         sem eu massa. Proin vitae consequat ligula. Duis erat massa, imperdiet at turpis ac,
//                         luctus aliquet sapien. Nullam
//                     </p>
//                 </div>
//             </div>
//             )} */}
//             {/* to show payments and terms */}
//             {(paymentToggle && pdfDataForPayments && showPaymentDetails) && <PdfViewer base64Pdf={pdfDataForPayments} />}
//             {(termsToggle && pdfDataForTerms && showTermsDetails) && <PdfViewer base64Pdf={pdfDataForTerms} />}
//         </div>
//     </div>
//     {!preview && <div className="invoice-preview-buttons">
//         {(invoiceStatus === "pdfgenerated" || invoiceStatus === "gstsubmitted" || invoiceStatus === "emailed")
//             &&
//             <Dropdown as={ButtonGroup}>
//                 <Dropdown.Toggle id="dropdown-basic" className="custom-toggle">
//                     Credit/Debit
//                 </Dropdown.Toggle>

//                 <Dropdown.Menu style={{ width: 'max-content' }}>
//                     <Dropdown.Item onClick={() => {
//                         navigate('/CreditAndDebit', {
//                             state: {
//                                 invoice_number: invoiceNo,
//                                 facilityId: localStorage.getItem('selected_facility_id'),
//                                 noteType: 'Credit'
//                             }
//                         });
//                     }}>Credit Note</Dropdown.Item>
//                     <Dropdown.Item onClick={() => {
//                         navigate('/CreditAndDebit', {
//                             state: {
//                                 noteType: 'Debit',
//                                 invoice_number: invoiceNo,
//                                 facilityId: localStorage.getItem('selected_facility_id'),
//                             }
//                         });
//                     }}>Debit Note</Dropdown.Item>
//                 </Dropdown.Menu>
//             </Dropdown>

//         }
//         {downloadPath && <button onClick={() => {
//             handleDownload()
//         }} disabled={downloadPath === '' || downloadPath === null} style={{ opacity: downloadPath ? '100%' : '50%' }}>Download</button>}
//         {(invoiceStatus === "draft" || invoiceStatus === "onhold" || invoiceStatus === "rejected") && <button onClick={() => {
//             handleRegenerate()
//             setApprovalType('slf')
//         }} >Regenerate</button>}
//         <button onClick={() => { setCurrentPage(1); setPreview(false); backFunction(); backPagination() }}> Back</button>
//         {(invoiceStatus === "draft" || invoiceStatus === "onhold" || invoiceStatus === "approved") && <button onClick={() => {
//             handleReject()
//             setApprovalType('slf')
//         }} >Reject</button>}
//         {(invoiceStatus === "draft" || invoiceStatus === "rejected" || invoiceStatus === "approved") && <button onClick={() => {
//             handleHold()
//             setApprovalType('slf')
//         }} >Hold</button>}
//         {!(invoiceStatus !== "rejected" && invoiceStatus !== 'onhold' && invoiceStatus !== "draft") && <button
//             onClick={() => {
//                 editInvoice()
//                 setApprovalType('slf')
//             }
//             }
//             style={{ opacity: checkSendForApprovalValidation() ? '100%' : '50%' }} disabled={!checkSendForApprovalValidation()}>Approve</button>}

//     </div>}
//     {preview && <div className="invoice-preview-buttons">
//         <button onClick={() => setPreview(false)}> Back</button>
//     </div>}

// </div>
// }
{/* electricity invoice */ }
// {currentPage === 2 && <div className="invoice_preview_container">

//     <div className="invoice-preview-con">

//         {/* <div className="invoice-preview-scrollable" style={{ margin: preview || (invoiceStatus !== "rejected" && invoiceStatus!=='onhold' && invoiceStatus!== "draft") ? 'auto' : '' }}> */}
//         <div className="invoice-preview-scrollable" style={{ margin: 'auto' }}>
//             <div className="invoice-preview-card">
//                 <div className="invoice-preview-card-details">
//                     {companyLogo && <div className="invoice-logo-placeholder">
//                         <div>
//                             <img style={{ width: '15rem', height: '5rem' }} src={companyLogo} alt="company logo" />
//                         </div>
//                     </div>
//                     }
//                     <div className="d-flex justify-content-between w-100">
//                         <div className="invoice-header-address">
//                             <h5>{companyName?.toUpperCase()}</h5>
//                             <p style={{ textAlign: 'center' }}> <span
//                             ><b>Reg.Office:</b> {companyAddress}</span></p>
//                         </div>
//                         {
//                             QrCode?.length > 0 ?
//                                 <QRCode style={{ marginTop: '-50px' }} value={QrCode} size={170} />
//                                 :
//                                 <div className="invoice-bar-code">
//                                     {invoiceStatus === "rejected" ? (
//                                         <p className="rejected-text">Rejected</p>
//                                     ) : (
//                                         <p className="qr-code-text">QR Code</p>
//                                     )}
//                                 </div>
//                         }

//                     </div>
//                     <h5 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>Tax Invoice</h5>
//                     <h6 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>({serviceNameInInvoice})</h6>

//                     <div className="invoice-preview-inner-card-div">
//                         <div className="invoice-preview-inner-card">
//                             <div style={{ width: '100%' }}>
//                                 <p>
//                                     <b style={{ fontSize: "18px" }}>Buyer </b>
//                                     <br /> <b>{customerName}</b><br />
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>Billed To</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerAddress}</span>
//                                     </div>
//                                     {toggleShippingAddress && <div className="invoice-left-data">
//                                         <span className="key"><b>Shipped To</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value">  {shippingAddress}</span>
//                                     </div>}
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>State Code</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerStateCode}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>GSTIN</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerGSTIN}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>PAN</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerPAN}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>CIN</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerCIN}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>Place Of Supply</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerPlaceOfSupply}</span>
//                                     </div>
//                                 </p>
//                             </div>
//                         </div>
//                         <div className="invoice-address-right">
//                             <div >
//                                 <br />
//                                 <p> <b>Contract No   </b> </p>
//                                 <p><b>Invoice No</b> </p>
//                                 <p><b>State</b></p>
//                                 <p><b>State Code</b> </p>
//                                 <p><b>GSTIN</b></p>
//                                 <p><b>PAN</b></p>
//                                 <p><b>CIN</b></p>
//                                 <br />
//                                 <p><b>Invoice Date</b></p>
//                                 <p><b>Due Date</b></p>

//                             </div>
//                             <div style={{ marginLeft: "20px" }}>
//                                 <br />
//                                 <p>: {contractNo}</p>
//                                 <p>: {invoiceNo}</p>
//                                 <p>: {parnterState}</p>
//                                 <p>: {partnerStateCode}</p>
//                                 <p>: {companyGST}</p>
//                                 <p>: {partnerPAN}</p>
//                                 <p>: {companyCIN}</p>

//                                 <br />
//                                 <p>: {ackDate}</p>
//                                 <p>: {partnerDueDate}</p>
//                             </div>
//                         </div>
//                     </div>

//                 </div>
//                 <div className="invoice-preview-card-details-bottom">
//                     <div className="invoice-preview-inner-card-2">
//                         <p><span><b>IRN :</b> </span>{IRN}<br />
//                         </p>
//                     </div>
//                 </div>

//                 <div className="invoice-preview-table-container">
//                     <Table className="invoice-preview-table">
//                         <thead >
//                             <tr >
//                                 <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
//                                 <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
//                                 <th colSpan={2}><b>Bill Period / Reading</b></th>
//                                 {showComputationDetails && <th colSpan={1}><b>Total Units</b></th>}
//                                 {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
//                                 {/* <th colSpan={1}><b>Meter Rent</b></th> */}
//                                 <th colSpan={1}><b>Basic Amount</b></th>
//                                 {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
//                                 {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
//                                 {igstToggle && <th colSpan={2}><b>IGST</b></th>}
//                                 <th colSpan={1}><b>Gross</b></th>
//                             </tr>
//                             <tr>
//                                 <th>From / Op. Reading</th>
//                                 <th>To / Cl. Reading</th>

//                                 {showComputationDetails && <th>kWh</th>}
//                                 {showComputationDetails && <th>
//                                     ({formatCurrencyBasedOnRegion()} / kWh)</th>}
//                                 {/* <th>Amount (INR)</th> */}
//                                 <th>Amount ({formatCurrencyBasedOnRegion()})</th>
//                                 {!igstToggle && <th>Rate (%)</th>}
//                                 {!igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
//                                 {!igstToggle && <th>Rate (%)</th>}
//                                 {!igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
//                                 {igstToggle && <th>Rate (%)</th>}
//                                 {igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
//                                 <th>Amount ({formatCurrencyBasedOnRegion()})</th>
//                             </tr>
//                         </thead>
//                         <tbody >
//                             {invoiceDetails?.map((item, index) => (
//                                 <tr key={index}>
//                                     <th className="text-start">{item?.service_name_in_invoice?.toUpperCase()},<br />
//                                         {item?.service_identifier}
//                                     </th>
//                                     <th className="text-start">{item?.hsn}</th>
//                                     <th style={{ textAlign: 'end' }}>
//                                         <div>
//                                             <p style={{ marginBottom: '-5px' }}>{formatDateBasedOnValue(formatDateView(item.from_date))}
//                                                 <hr />
//                                                 {formatToIndianRupee(item.initial_reading)}
//                                             </p>
//                                         </div>
//                                     </th>
//                                     <th style={{ textAlign: 'end' }}><div>
//                                         <p style={{ marginBottom: '-5px' }}>{formatDateBasedOnValue(formatDateView(item.to_date))}
//                                             <hr />
//                                             {formatToIndianRupee(item.final_reading)}
//                                         </p>
//                                     </div></th>
//                                     {showComputationDetails && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.consumption)}</th>}
//                                     {showComputationDetails && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.rate_per_unit)}</th>}
//                                     {/* <th>-</th> */}
//                                     <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.net_amount)}</th>
//                                     {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst_rate)}</th>}
//                                     {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst)}</th>}
//                                     {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst_rate)}</th>}
//                                     {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst)}</th>}
//                                     {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst_rate)}</th>}
//                                     {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst)}</th>}
//                                     <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.gross_amount)}</th>
//                                 </tr>
//                             ))}
//                             {/* Grand Total */}
//                             <tr >
//                                 {/* service description */}
//                                 <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
//                                     Total
//                                 </th>
//                                 {/* sac/hsn */}
//                                 <th className="text-start">
//                                 </th>
//                                 <th className="text-start">
//                                 </th>
//                                 <th className="text-start">
//                                 </th>
//                                 <th className="text-start">
//                                 </th>
//                                 <th className="text-start">
//                                 </th>
//                                 {/* basic amount */}
//                                 <th className="text-end">
//                                     {formatToIndianRupee(basicAmount)}
//                                 </th>
//                                 {/* sgst rate*/}
//                                 {!igstToggle && <th>

//                                 </th>}
//                                 {/* sgst amount*/}
//                                 {!igstToggle && <th className="text-end">
//                                     {formatToIndianRupee(totalSgst)}
//                                 </th>}
//                                 {/* cgst rate*/}
//                                 {!igstToggle && <th>

//                                 </th>}
//                                 {/* cgst amount*/}
//                                 {!igstToggle && <th className="text-end">
//                                     {formatToIndianRupee(totalCgst)}
//                                 </th>}
//                                 {/* igst rate*/}
//                                 {igstToggle && <th>

//                                 </th>}
//                                 {/* igst amount*/}
//                                 {igstToggle && <th className="text-end">{formatToIndianRupee(totalIgst)}</th>}
//                                 {/* gross amount */}
//                                 <th className="text-end">
//                                     {formatToIndianRupee(TotalAmount)}
//                                     {/* parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.igst)) : formatToIndianRupee(parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.cgst) + parseFloat((each.basicAmount / 100) * each.sgst))} */}
//                                 </th>
//                             </tr>
//                         </tbody>
//                     </Table>
//                     <div className="invoice-preview-total-con">
//                         <div className="invoice-preview-total-con-left">
//                             <span>
//                                 <b>Total Invoice Amount In Words ({formatCurrencyBasedOnRegion()}) : </b>
//                             </span>
//                             <p >{totalAmountInWords}
//                             </p>
//                         </div>
//                         <div className="invoice-preview-total d-flex">
//                             <p className="invoice-preview-total-key" >Total : </p>
//                             {/* <span className="diagonal-line"></span> */}
//                             {/* <span></span> */}
//                             <p className="invoice-preview-total-value" >&nbsp;
//                                 &nbsp;{formatToIndianRupee(TotalAmount)} {formatCurrencyBasedOnRegion()}</p>
//                         </div>
//                     </div>
//                     {userNotesToggle && <div className="invoice-user-notes-div">
//                         <p className="invoice-user-notes">User Notes</p>
//                         <p>{userNotes}</p>
//                     </div>}
//                 </div>
//                 <div className="signature">
//                     <p></p>
//                     <p>sign here</p>
//                 </div>

//             </div>
//             {/* {!preview && !(invoiceStatus !== "rejected" && invoiceStatus!=='onhold' && invoiceStatus!== "draft") && (<div className="chat-feature">
//                 <div className="chatbox">
//                     <div className="chat-user">
//                         <p className="name">User-name</p>
//                         <p>13-02-24 15:25</p>
//                     </div>
//                     <p>
//                         Lorem ipsum dolor <span>@fin-man</span>, consectetur adipiscing elit. Maecenas vulputate,
//                         leo eu bibendum sollicitudin, risus velit posuere libero, vitae aliquet turpis
//                         sem eu massa. Proin vitae consequat ligula. Duis erat massa, imperdiet at turpis ac,
//                         luctus aliquet sapien. Nullam
//                     </p>
//                 </div>
//                 <div className="chatbox">
//                     <div className="chat-user">
//                         <p className="name">CEO</p>
//                         <p>13-02-24 15:25</p>
//                     </div>
//                     <p>
//                         Lorem ipsum dolor <span>@fin-man</span>, consectetur adipiscing elit. Maecenas vulputate,
//                         leo eu bibendum sollicitudin, risus velit posuere libero, vitae aliquet turpis
//                         sem eu massa. Proin vitae consequat ligula. Duis erat massa, imperdiet at turpis ac,
//                         luctus aliquet sapien. Nullam
//                     </p>
//                 </div>
//             </div>
//             )} */}
//             {/* to show payments and terms */}
//             {(paymentToggle && pdfDataForPayments && showPaymentDetails) && <PdfViewer base64Pdf={pdfDataForPayments} />}
//             {(termsToggle && pdfDataForTerms && showTermsDetails) && <PdfViewer base64Pdf={pdfDataForTerms} />}
//         </div>
//     </div>
//     {/* <button onClick={() => {
//             navigate('/CreditAndDebit', {
//                 state: {
//                     invoice_number: invoiceNo,
//                     facilityId: localStorage.getItem('selected_facility_id'),
//                 }
//             });
//         }} >Credit/Debit</button> */}
//     {!preview && <div className="invoice-preview-buttons">
//         {(invoiceStatus === "pdfgenerated" || invoiceStatus === "gstsubmitted" || invoiceStatus === "emailed")
//             &&
//             <Dropdown as={ButtonGroup}>
//                 <Dropdown.Toggle id="dropdown-basic" className="custom-toggle">
//                     Credit/Debit
//                 </Dropdown.Toggle>

//                 <Dropdown.Menu style={{ width: 'max-content' }}>
//                     <Dropdown.Item onClick={() => {
//                         navigate('/CreditAndDebit', {
//                             state: {
//                                 invoice_number: invoiceNo,
//                                 facilityId: localStorage.getItem('selected_facility_id'),
//                                 noteType: 'Credit'
//                             }
//                         });
//                     }}>Credit Note</Dropdown.Item>
//                     <Dropdown.Item onClick={() => {
//                         navigate('/CreditAndDebit', {
//                             state: {
//                                 noteType: 'Debit',
//                                 invoice_number: invoiceNo,
//                                 facilityId: localStorage.getItem('selected_facility_id'),
//                             }
//                         });
//                     }}>Debit Note</Dropdown.Item>
//                 </Dropdown.Menu>
//             </Dropdown>

//         }
//         {downloadPath && <button onClick={() => {
//             handleDownload()
//         }}
//             disabled={downloadPath === '' || downloadPath === null} style={{ opacity: downloadPath ? '100%' : '50%' }}>Download</button>}
//         {(invoiceStatus === "draft" || invoiceStatus === "onhold" || invoiceStatus === "rejected") && <button onClick={() => {
//             handleRegenerate()
//             setApprovalType('Electricity')
//         }} >Regenerate</button>}
//         <button onClick={() => { setCurrentPage(1); setPreview(false); backFunction(); backPagination() }}> Back</button>
//         {(invoiceStatus === "draft" || invoiceStatus === "onhold" || invoiceStatus === "approved") && <button onClick={() => {
//             handleReject()
//             setApprovalType('Electricity')
//         }} >Reject</button>}
//         {(invoiceStatus === "draft" || invoiceStatus === "rejected" || invoiceStatus === "approved") && <button onClick={() => {
//             handleHold()
//             setApprovalType('Electricity')
//         }} >Hold</button>}
//         {!(invoiceStatus !== "rejected" && invoiceStatus !== 'onhold' && invoiceStatus !== "draft") && <button
//             onClick={() => {
//                 editInvoice()
//                 setApprovalType('Electricity')
//             }
//             }
//             style={{ opacity: checkSendForApprovalValidation() ? '100%' : '50%' }} disabled={!checkSendForApprovalValidation()}>Approve</button>}

//     </div>}
//     {preview && <div className="invoice-preview-buttons">
//         <button onClick={() => setPreview(false)}> Back</button>
//     </div>}

// </div>
// }
// {/* FMS invoice */}
//                 {currentPage === 6 && <div className="invoice_preview_container">

//                     <div className="invoice-preview-con">

//                         <div className="invoice-preview-scrollable" style={{ margin: 'auto' }}>
//                             <div className="invoice-preview-card">
//                                 <div className="invoice-preview-card-details">
//                                     {companyLogo && <div className="invoice-logo-placeholder">
//                                         <div>
//                                             <img style={{ width: '15rem', height: '5rem' }} src={companyLogo} alt="company logo" />
//                                         </div>
//                                     </div>
//                                     }
//                                     <div className="d-flex justify-content-between w-100">
//                                         <div className="invoice-header-address">
//                                             <h5>{companyName?.toUpperCase()}</h5>
//                                             <p style={{
//                                                 textAlign: 'center'
//                                             }}><span ><b>Reg.Office:</b> {companyAddress}</span></p>
//                                         </div>
//                                         {
//                                             QrCode?.length > 0 ?
//                                                 <QRCode style={{ marginTop: '-70px' }} value={QrCode} size={170} />
//                                                 :
//                                                 <div className="invoice-bar-code">
//                                                     {invoiceStatus === "rejected" ? (
//                                                         <p className="rejected-text">Rejected</p>
//                                                     ) : (
//                                                         <p className="qr-code-text">QR Code</p>
//                                                     )}
//                                                 </div>
//                                         }

//                                     </div>
//                                     <h5 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>Tax Invoice</h5>
//                                     <h6 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>({serviceNameInInvoice})</h6>
//                                     <div className="invoice-preview-inner-card-div">
//                                         <div className="invoice-preview-inner-card">
//                                             <div style={{ width: '100%' }}>
//                                                 <p>
//                                                     <b style={{ fontSize: "18px" }}>Buyer </b>
//                                                     <br /> <b>{customerName}</b><br />
//                                                     <div className="invoice-left-data">
//                                                         <span className="key"><b>Billed To</b></span>
//                                                         <span style={{ marginRight: '3px' }}>:</span>
//                                                         <span className="value"> {customerAddress}</span>
//                                                     </div>
//                                                     {toggleShippingAddress && <div className="invoice-left-data">
//                                                         <span className="key"><b>Shipped To</b></span>
//                                                         <span style={{ marginRight: '3px' }}>:</span>
//                                                         <span className="value">  {shippingAddress}</span>
//                                                     </div>}
//                                                     <div className="invoice-left-data">
//                                                         <span className="key"><b>State Code</b></span>
//                                                         <span style={{ marginRight: '3px' }}>:</span>
//                                                         <span className="value"> {customerStateCode}</span>
//                                                     </div>
//                                                     <div className="invoice-left-data">
//                                                         <span className="key"><b>GSTIN</b></span>
//                                                         <span style={{ marginRight: '3px' }}>:</span>
//                                                         <span className="value"> {customerGSTIN}</span>
//                                                     </div>
//                                                     <div className="invoice-left-data">
//                                                         <span className="key"><b>PAN</b></span>
//                                                         <span style={{ marginRight: '3px' }}>:</span>
//                                                         <span className="value"> {customerPAN}</span>
//                                                     </div>
//                                                     <div className="invoice-left-data">
//                                                         <span className="key"><b>CIN</b></span>
//                                                         <span style={{ marginRight: '3px' }}>:</span>
//                                                         <span className="value"> {customerCIN}</span>
//                                                     </div>
//                                                     <div className="invoice-left-data">
//                                                         <span className="key"><b>Place Of Supply</b></span>
//                                                         <span style={{ marginRight: '3px' }}>:</span>
//                                                         <span className="value"> {customerPlaceOfSupply}</span>
//                                                     </div>
//                                                 </p>
//                                             </div>
//                                         </div>
//                                         <div className="invoice-address-right">
//                                             <div >
//                                                 <br />
//                                                 <p> <b>Contract No   </b> </p>
//                                                 <p><b>Invoice No</b> </p>
//                                                 <p><b>State</b></p>
//                                                 <p><b>State Code</b> </p>
//                                                 <p><b>GSTIN</b></p>
//                                                 <p><b>PAN</b></p>
//                                                 <p><b>CIN</b></p>
//                                                 <br />
//                                                 <p><b>Invoice Date</b></p>
//                                                 <p><b>Due Date</b></p>

//                                             </div>
//                                             <div style={{ marginLeft: "20px" }}>
//                                                 <br />
//                                                 <p>: {contractNo}</p>
//                                                 <p>: {invoiceNo}</p>
//                                                 <p>: {parnterState}</p>
//                                                 <p>: {partnerStateCode}</p>
//                                                 <p>: {companyGST}</p>
//                                                 <p>: {partnerPAN}</p>
//                                                 <p>: {companyCIN}</p>

//                                                 <br />
//                                                 <p>: {ackDate}</p>
//                                                 <p>: {partnerDueDate}</p>
//                                             </div>
//                                         </div>
//                                     </div>

//                                 </div>
//                                 <div className="invoice-preview-card-details-bottom">
//                                     <div className="invoice-preview-inner-card-2">
//                                         <p><span><b>IRN :</b> </span>{IRN}<br />
//                                         </p>
//                                     </div>
//                                 </div>

//                                 <div className="invoice-preview-table-container">
//                                     <Table className="invoice-preview-table">
//                                         <thead>
//                                             <tr>
//                                                 <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
//                                                 <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
//                                                 <th colSpan={2}><b>Bill Period </b></th>
//                                                 {showComputationDetails && <th colSpan={1}><b>Total Area</b></th>}
//                                                 {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
//                                                 <th colSpan={1}><b>Basic Amount</b></th>
//                                                 {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
//                                                 {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
//                                                 {igstToggle && <th colSpan={2}><b>IGST</b></th>}
//                                                 <th colSpan={1}><b>GROSS</b></th>
//                                             </tr>
//                                             <tr>

//                                                 <th>From</th>
//                                                 <th>To</th>
//                                                 {showComputationDetails && <th>Sq. ft</th>}
//                                                 {showComputationDetails && <th> ({formatCurrencyBasedOnRegion()} / Sq. ft)</th>}
//                                                 <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
//                                                 {!igstToggle && <th>Rate <br /> (%)</th>}
//                                                 {!igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
//                                                 {!igstToggle && <th>Rate <br />(%)</th>}
//                                                 {!igstToggle && <th>Amount<br /> ({formatCurrencyBasedOnRegion()})</th>}
//                                                 {igstToggle && <th>Rate <br />(%)</th>}
//                                                 {igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
//                                                 <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody >
//                                             {invoiceDetails?.map((item, index) => {
//                                                 return (
//                                                     <tr key={index}>
//                                                         <th className="text-start">{item?.service_name_in_invoice?.toUpperCase()},<br />
//                                                             {item?.service_identifier}
//                                                         </th>
//                                                         <th className="text-start">{item?.hsn}</th>
//                                                         <th style={{ textAlign: 'end', textWrap: 'nowrap' }}>{formatDateBasedOnValue(formatDateView(item.from_date))}</th>
//                                                         <th style={{ textAlign: 'end', textWrap: 'nowrap' }}>
//                                                             <div>
//                                                                 {formatDateBasedOnValue(formatDateView(item.to_date))}
//                                                             </div>
//                                                         </th>
//                                                         {showComputationDetails && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.consumption)}</th>}
//                                                         {showComputationDetails && <th style={{ textAlign: 'end' }}><div>
//                                                             {formatToIndianRupee(item.rate_per_unit)}
//                                                         </div></th>}
//                                                         <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.net_amount)}</th>

//                                                         {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst_rate)}</th>}
//                                                         {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst)}</th>}
//                                                         {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst_rate)}</th>}
//                                                         {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst)}</th>}
//                                                         {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst_rate)}</th>}
//                                                         {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst)}</th>}
//                                                         <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.gross_amount)}</th>
//                                                     </tr>
//                                                 )
//                                             })
//                                             }
//                                             {/* Grand Total */}
//                                             <tr >
//                                                 {/* service description */}
//                                                 <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
//                                                     Total
//                                                 </th>
//                                                 {/* sac/hsn */}
//                                                 <th className="text-start">
//                                                 </th>
//                                                 <th className="text-start">
//                                                 </th>
//                                                 <th className="text-start">
//                                                 </th>
//                                                 {showComputationDetails &&
//                                                     <>
//                                                         <th className="text-start">
//                                                         </th>
//                                                         <th className="text-start">
//                                                         </th>
//                                                     </>}

//                                                 {/* basic amount */}
//                                                 <th className="text-end">
//                                                     {formatToIndianRupee(basicAmount)}
//                                                 </th>
//                                                 {/* sgst rate*/}
//                                                 {!igstToggle && <th>

//                                                 </th>}
//                                                 {/* sgst amount*/}
//                                                 {!igstToggle && <th className="text-end">
//                                                     {formatToIndianRupee(totalSgst)}
//                                                 </th>}
//                                                 {/* cgst rate*/}
//                                                 {!igstToggle && <th>

//                                                 </th>}
//                                                 {/* cgst amount*/}
//                                                 {!igstToggle && <th className="text-end">
//                                                     {formatToIndianRupee(totalCgst)}
//                                                 </th>}
//                                                 {/* igst rate*/}
//                                                 {igstToggle && <th>

//                                                 </th>}
//                                                 {/* igst amount*/}
//                                                 {igstToggle && <th className="text-end">{formatToIndianRupee(totalIgst)}</th>}
//                                                 {/* gross amount */}
//                                                 <th className="text-end">
//                                                     {formatToIndianRupee(TotalAmount)}
//                                                     {/* parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.igst)) : formatToIndianRupee(parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.cgst) + parseFloat((each.basicAmount / 100) * each.sgst))} */}
//                                                 </th>
//                                             </tr>
//                                         </tbody>
//                                     </Table>
//                                     <div className="invoice-preview-total-con">
//                                         <div className="invoice-preview-total-con-left">
//                                             <span>
//                                                 <b>Total Invoice Amount In Words ({formatCurrencyBasedOnRegion()}) : </b>
//                                             </span>
//                                             <p >{totalAmountInWords}
//                                             </p>
//                                         </div>
//                                         <div className="invoice-preview-total d-flex">
//                                             <p className="invoice-preview-total-key" >Total : </p>
//                                             {/* <span className="diagonal-line"></span> */}
//                                             {/* <span></span> */}
//                                             <p className="invoice-preview-total-value" >&nbsp;
//                                                 &nbsp;{formatToIndianRupee(TotalAmount)} {formatCurrencyBasedOnRegion()}</p>
//                                         </div>
//                                     </div>
//                                     {userNotesToggle && <div className="invoice-user-notes-div">
//                                         <p className="invoice-user-notes">User Notes</p>
//                                         <p>{userNotes}</p>
//                                     </div>}
//                                 </div>
//                                 <div className="signature">
//                                     <p></p>
//                                     <p>sign here</p>
//                                 </div>

//                             </div>
//                             {/* {!preview && !(invoiceStatus !== "rejected" && invoiceStatus!=='onhold' && invoiceStatus!== "draft") && (<div className="chat-feature">
//                                 <div className="chatbox">
//                                     <div className="chat-user">
//                                         <p className="name">User-name</p>
//                                         <p>13-02-24 15:25</p>
//                                     </div>
//                                     <p>
//                                         Lorem ipsum dolor <span>@fin-man</span>, consectetur adipiscing elit. Maecenas vulputate,
//                                         leo eu bibendum sollicitudin, risus velit posuere libero, vitae aliquet turpis
//                                         sem eu massa. Proin vitae consequat ligula. Duis erat massa, imperdiet at turpis ac,
//                                         luctus aliquet sapien. Nullam
//                                     </p>
//                                 </div>
//                                 <div className="chatbox">
//                                     <div className="chat-user">
//                                         <p className="name">CEO</p>
//                                         <p>13-02-24 15:25</p>
//                                     </div>
//                                     <p>
//                                         Lorem ipsum dolor <span>@fin-man</span>, consectetur adipiscing elit. Maecenas vulputate,
//                                         leo eu bibendum sollicitudin, risus velit posuere libero, vitae aliquet turpis
//                                         sem eu massa. Proin vitae consequat ligula. Duis erat massa, imperdiet at turpis ac,
//                                         luctus aliquet sapien. Nullam
//                                     </p>
//                                 </div>
//                             </div>
//                             )} */}
//                             {/* to show payments and terms */}
//                             {(paymentToggle && pdfDataForPayments && showPaymentDetails) && <PdfViewer base64Pdf={pdfDataForPayments} />}
//                             {(termsToggle && pdfDataForTerms && showTermsDetails) && <PdfViewer base64Pdf={pdfDataForTerms} />}
//                         </div>
//                     </div>
//                     {!preview && <div className="invoice-preview-buttons">
//                         {(invoiceStatus === "pdfgenerated" || invoiceStatus === "gstsubmitted" || invoiceStatus === "emailed")
//                             &&
//                             <Dropdown as={ButtonGroup}>
//                                 <Dropdown.Toggle id="dropdown-basic" className="custom-toggle">
//                                     Credit/Debit
//                                 </Dropdown.Toggle>

//                                 <Dropdown.Menu style={{ width: 'max-content' }}>
//                                     <Dropdown.Item onClick={() => {
//                                         navigate('/CreditAndDebit', {
//                                             state: {
//                                                 invoice_number: invoiceNo,
//                                                 facilityId: localStorage.getItem('selected_facility_id'),
//                                                 noteType: 'Credit'
//                                             }
//                                         });
//                                     }}>Credit Note</Dropdown.Item>
//                                     <Dropdown.Item onClick={() => {
//                                         navigate('/CreditAndDebit', {
//                                             state: {
//                                                 noteType: 'Debit',
//                                                 invoice_number: invoiceNo,
//                                                 facilityId: localStorage.getItem('selected_facility_id'),
//                                             }
//                                         });
//                                     }}>Debit Note</Dropdown.Item>
//                                 </Dropdown.Menu>
//                             </Dropdown>

//                         }
//                         {downloadPath && <button onClick={() => {
//                             handleDownload()
//                         }} disabled={downloadPath === '' || downloadPath === null} style={{ opacity: downloadPath ? '100%' : '50%' }}>Download</button>}
//                         {(invoiceStatus === "draft" || invoiceStatus === "onhold" || invoiceStatus === "rejected") && <button onClick={() => {
//                             handleRegenerate()
//                             setApprovalType('fms')
//                         }} >Regenerate</button>}
//                         <button onClick={() => { setCurrentPage(1); setPreview(false); backFunction(); backPagination() }}> Back</button>
//                         {(invoiceStatus === "draft" || invoiceStatus === "onhold" || invoiceStatus === "approved") && <button onClick={() => {
//                             handleReject()
//                             setApprovalType('fms')
//                         }} >Reject</button>}
//                         {(invoiceStatus === "draft" || invoiceStatus === "rejected" || invoiceStatus === "approved") && <button onClick={() => {
//                             handleHold()
//                             setApprovalType('fms')
//                         }} >Hold</button>}
//                         {!(invoiceStatus !== "rejected" && invoiceStatus !== 'onhold' && invoiceStatus !== "draft") && <button
//                             onClick={() => {
//                                 editInvoice()
//                                 setApprovalType('fms')
//                             }
//                             }
//                             style={{ opacity: checkSendForApprovalValidation() ? '100%' : '50%' }} disabled={!checkSendForApprovalValidation()}>Approve</button>}

//                     </div>}
//                     {preview && <div className="invoice-preview-buttons">
//                         <button onClick={() => setPreview(false)}> Back</button>
//                     </div>}

//                 </div>
//                 }
{/* water invoice */ }
// {currentPage === 4 && <div className="invoice_preview_container">

//     <div className="invoice-preview-con">
//         {/* <div className="invoice-preview-scrollable" style={{ margin: preview || (invoiceStatus !== "rejected" && invoiceStatus!=='onhold' && invoiceStatus!== "draft") ? 'auto' : '' }}> */}
//         <div className="invoice-preview-scrollable" style={{ margin: 'auto' }}>
//             <div className="invoice-preview-card">
//                 <div className="invoice-preview-card-details">
//                     {companyLogo && <div className="invoice-logo-placeholder">
//                         <div>
//                             <img style={{ width: '15rem', height: '5rem' }} src={companyLogo} alt="company logo" />
//                         </div>
//                     </div>}
//                     <div className="d-flex justify-content-between w-100">
//                         <div className="invoice-header-address">
//                             <h5>{companyName?.toUpperCase()}</h5>
//                             <p style={{ textAlign: 'center' }}><span ><b>Reg.Office:</b> {companyAddress}</span></p>
//                         </div>

//                         {
//                             QrCode?.length > 0 ?
//                                 <QRCode style={{ marginTop: '-70px' }} value={QrCode} size={170} />
//                                 :
//                                 <div className="invoice-bar-code">
//                                     {invoiceStatus === "rejected" ? (
//                                         <p className="rejected-text">Rejected</p>
//                                     ) : (
//                                         <p className="qr-code-text">QR Code</p>
//                                     )}
//                                 </div>
//                         }

//                     </div>
//                     <h5 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>Tax Invoice</h5>
//                     <h6 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>({serviceNameInInvoice})</h6>

//                     <div className="invoice-preview-inner-card-div">
//                         <div className="invoice-preview-inner-card">
//                             <div style={{ width: '100%' }}>
//                                 <p>
//                                     <b style={{ fontSize: "18px" }}>Buyer </b>
//                                     <br /> <b>{customerName}</b><br />
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>Billed To</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerAddress}</span>
//                                     </div>
//                                     {toggleShippingAddress && <div className="invoice-left-data">
//                                         <span className="key"><b>Shipped To</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value">  {shippingAddress}</span>
//                                     </div>}
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>State Code</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerStateCode}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>GSTIN</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerGSTIN}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>PAN</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerPAN}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>CIN</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerCIN}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>Place Of Supply</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerPlaceOfSupply}</span>
//                                     </div>
//                                 </p>
//                             </div>
//                         </div>
//                         <div className="invoice-address-right">
//                             <div >
//                                 <br />
//                                 <p> <b>Contract No.   </b> </p>
//                                 <p><b>Invoice No.</b> </p>
//                                 <p><b>State</b></p>
//                                 <p><b>State Code</b> </p>
//                                 <p><b>GSTIN</b></p>
//                                 <p><b>PAN</b></p>
//                                 <p><b>CIN</b></p>
//                                 <br />
//                                 <p><b>Invoice Date</b></p>
//                                 <p><b>Due Date</b></p>

//                             </div>
//                             <div style={{ marginLeft: "20px" }}>
//                                 <br />
//                                 <p>: {contractNo}</p>
//                                 <p>: {invoiceNo}</p>
//                                 <p>: {parnterState}</p>
//                                 <p>: {partnerStateCode}</p>
//                                 <p>: {companyGST}</p>
//                                 <p>: {partnerPAN}</p>
//                                 <p>: {companyCIN}</p>

//                                 <br />
//                                 <p>: {ackDate}</p>
//                                 <p>: {partnerDueDate}</p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="invoice-preview-card-details-bottom">
//                     <div className="invoice-preview-inner-card-2">
//                         <p><span><b>IRN :</b> </span>{IRN}<br /></p>
//                     </div>
//                 </div>

//                 <div className="invoice-preview-table-container">
//                     <Table className="invoice-preview-table">
//                         <thead>
//                             <tr>
//                                 <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
//                                 <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
//                                 <th colSpan={2}><b>Bill Period / Reading</b></th>
//                                 {showComputationDetails && <th colSpan={1}><b>Total Units</b></th>}
//                                 {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
//                                 {/* <th colSpan={1}><b>Meter Rent</b></th> */}
//                                 <th colSpan={1}><b>Basic Amount</b></th>
//                                 {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
//                                 {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
//                                 {igstToggle && <th colSpan={2}><b>IGST</b></th>}
//                                 <th colSpan={1}><b>GROSS</b></th>
//                             </tr>
//                             <tr>
//                                 <th>From / Op. Reading</th>
//                                 <th>To / Cl. Reading</th>
//                                 {showComputationDetails && <th>kL</th>}
//                                 {showComputationDetails && <th>({formatCurrencyBasedOnRegion()} / kL)</th>}
//                                 <th>Amount ({formatCurrencyBasedOnRegion()})</th>
//                                 {/* <th>Amount (INR)</th> */}
//                                 {!igstToggle && <th>Rate (%)</th>}
//                                 {!igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
//                                 {!igstToggle && <th>Rate (%)</th>}
//                                 {!igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
//                                 {igstToggle && <th>Rate (%)</th>}
//                                 {igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
//                                 <th>Amount ({formatCurrencyBasedOnRegion()})</th>
//                             </tr>
//                         </thead>
//                         <tbody >
//                             {invoiceDetails?.map((item, index) => (
//                                 <tr key={index}>
//                                     <th className="text-start">{item?.service_name_in_invoice?.toUpperCase()},<br />
//                                         {item?.service_identifier}</th>
//                                     <th className="text-start">{item?.hsn}</th>
//                                     <th style={{ textAlign: 'end' }}>
//                                         <div>
//                                             <p style={{ marginBottom: '-5px', textWrap: 'nowrap' }}>{formatDateBasedOnValue(formatDateView(item.from_date))}
//                                                 <hr />
//                                                 {formatToIndianRupee(item.initial_reading)}
//                                             </p>
//                                         </div>
//                                     </th>
//                                     <th style={{ textAlign: 'end' }}><div>
//                                         <p style={{ marginBottom: '-5px' }}>{formatDateBasedOnValue(formatDateView(item.to_date))}
//                                             <hr />
//                                             {formatToIndianRupee(item.final_reading)}
//                                         </p>
//                                     </div></th>
//                                     {showComputationDetails && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.consumption)}</th>}
//                                     {showComputationDetails && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.rate_per_unit)}</th>}
//                                     {/* <th>-</th> */}
//                                     <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.net_amount)}</th>
//                                     {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst_rate)}</th>}
//                                     {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst)}</th>}
//                                     {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst_rate)}</th>}
//                                     {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst)}</th>}
//                                     {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst_rate)}</th>}
//                                     {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst)}</th>}
//                                     <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.gross_amount)}</th>
//                                 </tr>
//                             ))}
//                             {/* Grand Total */}
//                             <tr >
//                                 {/* service description */}
//                                 <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
//                                     Total
//                                 </th>
//                                 {/* sac/hsn */}
//                                 <th className="text-start">
//                                 </th>
//                                 <th className="text-start">
//                                 </th>
//                                 <th className="text-start">
//                                 </th>
//                                 <th className="text-start">
//                                 </th>
//                                 <th className="text-start">
//                                 </th>
//                                 {/* basic amount */}
//                                 <th className="text-end">
//                                     {formatToIndianRupee(basicAmount)}
//                                 </th>
//                                 {/* sgst rate*/}
//                                 {!igstToggle && <th>

//                                 </th>}
//                                 {/* sgst amount*/}
//                                 {!igstToggle && <th className="text-end">
//                                     {formatToIndianRupee(totalSgst)}
//                                 </th>}
//                                 {/* cgst rate*/}
//                                 {!igstToggle && <th>

//                                 </th>}
//                                 {/* cgst amount*/}
//                                 {!igstToggle && <th className="text-end">
//                                     {formatToIndianRupee(totalCgst)}
//                                 </th>}
//                                 {/* igst rate*/}
//                                 {igstToggle && <th>

//                                 </th>}
//                                 {/* igst amount*/}
//                                 {igstToggle && <th className="text-end">{formatToIndianRupee(totalIgst)}</th>}
//                                 {/* gross amount */}
//                                 <th className="text-end">
//                                     {formatToIndianRupee(TotalAmount)}
//                                     {/* parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.igst)) : formatToIndianRupee(parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.cgst) + parseFloat((each.basicAmount / 100) * each.sgst))} */}
//                                 </th>
//                             </tr>
//                         </tbody>
//                     </Table>

//                     <div className="invoice-preview-total-con">
//                         <div className="invoice-preview-total-con-left">
//                             <span>
//                                 <b>Total Invoice Amount In Words ({formatCurrencyBasedOnRegion()}) : </b>
//                             </span>
//                             <p >{totalAmountInWords}
//                             </p>
//                         </div>
//                         <div className="invoice-preview-total d-flex ">
//                             <p className="invoice-preview-total-key">Total : </p>
//                             {/* <span className="diagonal-line"></span> */}
//                             {/* <span></span> */}
//                             <p className="invoice-preview-total-value">&nbsp;
//                                 &nbsp;{formatToIndianRupee(TotalAmount)} <span>{formatCurrencyBasedOnRegion()}</span></p>
//                         </div>
//                     </div>
//                     {userNotesToggle && <div className="invoice-user-notes-div">
//                         <p className="invoice-user-notes">User Notes</p>
//                         <p>{userNotes}</p>
//                     </div>}
//                 </div>
//                 <div className="signature">
//                     <p></p>
//                     <p>sign here</p>
//                 </div>
//             </div>
//             {/* {!preview && !(invoiceStatus !== "rejected" && invoiceStatus!=='onhold' && invoiceStatus!== "draft") && <div className="chat-feature">
//                 <div className="chatbox">
//                     <div className="chat-user">
//                         <p className="name">User-name</p>
//                         <p>13-02-24 15:25</p>
//                     </div>
//                     <p>
//                         Lorem ipsum dolor <span>@fin-man</span>, consectetur adipiscing elit. Maecenas vulputate,
//                         leo eu bibendum sollicitudin, risus velit posuere libero, vitae aliquet turpis
//                         sem eu massa. Proin vitae consequat ligula. Duis erat massa, imperdiet at turpis ac,
//                         luctus aliquet sapien. Nullam
//                     </p>
//                 </div>
//                 <div className="chatbox">
//                     <div className="chat-user">
//                         <p className="name">CEO</p>
//                         <p>13-02-24 15:25</p>
//                     </div>
//                     <p>
//                         Lorem ipsum dolor <span>@fin-man</span>, consectetur adipiscing elit. Maecenas vulputate,
//                         leo eu bibendum sollicitudin, risus velit posuere libero, vitae aliquet turpis
//                         sem eu massa. Proin vitae consequat ligula. Duis erat massa, imperdiet at turpis ac,
//                         luctus aliquet sapien. Nullam
//                     </p>
//                 </div>
//             </div>} */}
//             {/* to show payments and terms */}
//             {(paymentToggle && pdfDataForPayments && showPaymentDetails) && <PdfViewer base64Pdf={pdfDataForPayments} />}
//             {(termsToggle && pdfDataForTerms && showTermsDetails) && <PdfViewer base64Pdf={pdfDataForTerms} />}
//         </div>
//     </div>
//     {!preview && <div className="invoice-preview-buttons">
//         {(invoiceStatus === "pdfgenerated" || invoiceStatus === "gstsubmitted" || invoiceStatus === "emailed")
//             &&
//             <Dropdown as={ButtonGroup}>
//                 <Dropdown.Toggle id="dropdown-basic" className="custom-toggle">
//                     Credit/Debit
//                 </Dropdown.Toggle>

//                 <Dropdown.Menu style={{ width: 'max-content' }}>
//                     <Dropdown.Item onClick={() => {
//                         navigate('/CreditAndDebit', {
//                             state: {
//                                 invoice_number: invoiceNo,
//                                 facilityId: localStorage.getItem('selected_facility_id'),
//                                 noteType: 'Credit'
//                             }
//                         });
//                     }}>Credit Note</Dropdown.Item>
//                     <Dropdown.Item onClick={() => {
//                         navigate('/CreditAndDebit', {
//                             state: {
//                                 noteType: 'Debit',
//                                 invoice_number: invoiceNo,
//                                 facilityId: localStorage.getItem('selected_facility_id'),
//                             }
//                         });
//                     }}>Debit Note</Dropdown.Item>
//                 </Dropdown.Menu>
//             </Dropdown>

//         }
//         {downloadPath && <button onClick={() => {
//             handleDownload()
//         }} disabled={downloadPath === '' || downloadPath === null} style={{ opacity: downloadPath ? '100%' : '50%' }}>Download</button>}
//         {(invoiceStatus === "draft" || invoiceStatus === "onhold" || invoiceStatus === "rejected") && <button onClick={() => {
//             handleRegenerate()
//             setApprovalType('Water')
//         }} >Regenerate</button>}
//         <button onClick={() => { setCurrentPage(1); setPreview(false); backFunction(); backPagination() }}> Back</button>
//         {(invoiceStatus === "draft" || invoiceStatus === "onhold" || invoiceStatus === "approved") && <button onClick={() => {
//             handleReject()
//             setApprovalType('Water')
//         }} >Reject</button>}
//         {(invoiceStatus === "draft" || invoiceStatus === "rejected" || invoiceStatus === "approved") && <button onClick={() => {
//             handleHold()
//             setApprovalType('Water')
//         }} >Hold</button>}
//         {!(invoiceStatus !== "rejected" && invoiceStatus !== 'onhold' && invoiceStatus !== "draft") && <button
//             onClick={() => {
//                 editInvoice()
//                 setApprovalType('Water')
//             }
//             }
//             style={{ opacity: checkSendForApprovalValidation() ? '100%' : '50%' }} disabled={!checkSendForApprovalValidation()}>Approve</button>}
//     </div>}

//     {preview && <div className="invoice-preview-buttons">
//         <button onClick={() => setPreview(false)}> Back</button>
//     </div>}
// </div>
// }
{/*  misc invoice */ }
// {currentPage === 7 && <div className="invoice_preview_container">

//     <div className="invoice-preview-con">
//         <div className="invoice-preview-scrollable" style={{ margin: 'auto' }}>
//             <div className="invoice-preview-card">
//                 <div className="invoice-preview-card-details">
//                     {companyLogo && <div className="invoice-logo-placeholder">
//                         <div>
//                             <img style={{ width: '15rem', height: '5rem' }} src={companyLogo} alt="company logo" />
//                         </div>
//                     </div>
//                     }
//                     <div className="d-flex justify-content-between w-100">
//                         <div className="invoice-header-address">
//                             <h5>{companyName?.toUpperCase()}</h5>
//                             <p style={{ textAlign: 'center' }}><span ><b>Reg.Office:</b> {companyAddress}</span></p>
//                         </div>
//                         {
//                             QrCode?.length > 0 ?
//                                 <QRCode style={{ marginTop: '-70px' }} value={QrCode} size={170} />
//                                 :
//                                 <div className="invoice-bar-code" style={{ marginTop: companyLogo ? '-100px' : '0px', }}>
//                                     {invoiceStatus === "rejected" ? (
//                                         <p className="rejected-text">Rejected</p>
//                                     ) : (
//                                         <p className="qr-code-text">QR Code</p>
//                                     )}
//                                 </div>
//                         }

//                     </div>
//                     <h5 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>Tax Invoice</h5>
//                     {/* <h6 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>({serviceNameInInvoice})</h6> */}

//                     <div className="invoice-preview-inner-card-div">
//                         <div className="invoice-preview-inner-card">
//                             <div style={{ width: '100%' }}>
//                                 <p>
//                                     <b style={{ fontSize: "18px" }}>Buyer </b>
//                                     <br /> <b>{customerName}</b><br />
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>Billed To</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerAddress}</span>
//                                     </div>
//                                     {toggleShippingAddress && <div className="invoice-left-data">
//                                         <span className="key"><b>Shipped To</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value">{shippingAddress}                                                        </span>
//                                     </div>}
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>State Code</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerStateCode}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>GSTIN</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerGSTIN}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>PAN</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerPAN}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>CIN</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerCIN}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>Place Of Supply</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerPlaceOfSupply}</span>
//                                     </div>
//                                 </p>
//                             </div>
//                         </div>
//                         <div className="invoice-address-right">
//                             <div >
//                                 <br />
//                                 <p> <b>Contract No   </b> </p>
//                                 <p><b>Invoice No</b> </p>
//                                 <p><b>State</b></p>
//                                 <p><b>State Code</b> </p>
//                                 <p><b>GSTIN</b></p>
//                                 <p><b>PAN</b></p>
//                                 <p><b>CIN</b></p>
//                                 <br />
//                                 <p><b>Invoice Date</b></p>
//                                 <p><b>Due Date</b></p>

//                             </div>
//                             <div style={{ marginLeft: "20px" }}>
//                                 <br />
//                                 <p>: {contractNo}</p>
//                                 <p>: {invoiceNo}</p>
//                                 <p>: {parnterState}</p>
//                                 <p>: {partnerStateCode}</p>
//                                 <p>: {companyGST}</p>
//                                 <p>: {partnerPAN}</p>
//                                 <p>: {companyCIN}</p>

//                                 <br />
//                                 <p>: {ackDate}</p>
//                                 <p>: {partnerDueDate}</p>
//                             </div>
//                         </div>
//                     </div>

//                 </div>
//                 <div className="invoice-preview-card-details-bottom">
//                     <div className="invoice-preview-inner-card-2">
//                         <p><span><b>IRN :</b> </span>{IRN}<br />
//                         </p>
//                     </div>
//                 </div>

//                 <div className="invoice-preview-table-container">
//                     <Table className="invoice-preview-table">
//                         <thead>
//                             <tr>
//                                 <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
//                                 <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
//                                 {miscShowBilling && <th colSpan={2}><b>Bill Period</b></th>}
//                                 {miscShowComputations && <th colSpan={1} rowSpan={2}><b>Total Units</b></th>}
//                                 {miscShowComputations && <th colSpan={1} rowSpan={2}><b>Rate</b></th>}
//                                 <th colSpan={1}><b>Basic Amount</b></th>
//                                 {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
//                                 {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
//                                 {igstToggle && <th colSpan={2}><b>IGST</b></th>}
//                                 <th colSpan={1}><b>GROSS</b></th>
//                             </tr>
//                             <tr>
//                                 {miscShowBilling && <><th>From</th>
//                                     <th>To</th>
//                                 </>}
//                                 <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
//                                 {!igstToggle && <th>Rate <br /> (%)</th>}
//                                 {!igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
//                                 {!igstToggle && <th>Rate <br />(%)</th>}
//                                 {!igstToggle && <th>Amount<br /> ({formatCurrencyBasedOnRegion()})</th>}
//                                 {igstToggle && <th>Rate <br />(%)</th>}
//                                 {igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
//                                 <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
//                             </tr>
//                         </thead>
//                         <tbody >
//                             {invoiceDetails?.map((item, index) => {
//                                 return (
//                                     <tr key={index}>
//                                         <th className="text-start">{item?.service_name_in_invoice?.toUpperCase()},<br />
//                                             {item?.service_identifier}
//                                         </th>
//                                         <th className="text-start">{item?.hsn}</th>
//                                         {miscShowBilling && <th>{item?.from_date}</th>}
//                                         {miscShowBilling && <th>{item?.to_date}</th>}
//                                         {miscShowComputations && <th>{item?.consumption}</th>}
//                                         {miscShowComputations && <th>{item?.rate_per_unit}</th>}
//                                         <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.net_amount)}</th>

//                                         {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst_rate)}</th>}
//                                         {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst)}</th>}
//                                         {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst_rate)}</th>}
//                                         {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst)}</th>}
//                                         {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst_rate)}</th>}
//                                         {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst)}</th>}
//                                         <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.gross_amount)}</th>
//                                     </tr>
//                                 )
//                             })
//                             }
//                             {/* Grand Total */}
//                             <tr >
//                                 {/* service description */}
//                                 <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
//                                     Total
//                                 </th>
//                                 {/* sac/hsn */}
//                                 <th className="text-start">
//                                 </th>
//                                 {miscShowBilling && <th className="text-start">
//                                 </th>}
//                                 {miscShowBilling && <th className="text-start">
//                                 </th>}
//                                 {miscShowComputations && <th className="text-start">
//                                 </th>}
//                                 {miscShowComputations && <th className="text-start">
//                                 </th>}
//                                 {/* basic amount */}
//                                 <th className="text-end">
//                                     {formatToIndianRupee(basicAmount)}
//                                 </th>
//                                 {/* sgst rate*/}
//                                 {!igstToggle && <th>

//                                 </th>}
//                                 {/* sgst amount*/}
//                                 {!igstToggle && <th className="text-end">
//                                     {formatToIndianRupee(totalSgst)}
//                                 </th>}
//                                 {/* cgst rate*/}
//                                 {!igstToggle && <th>

//                                 </th>}
//                                 {/* cgst amount*/}
//                                 {!igstToggle && <th className="text-end">
//                                     {formatToIndianRupee(totalCgst)}
//                                 </th>}
//                                 {/* igst rate*/}
//                                 {igstToggle && <th>

//                                 </th>}
//                                 {/* igst amount*/}
//                                 {igstToggle && <th className="text-end">{formatToIndianRupee(totalIgst)}</th>}
//                                 {/* gross amount */}
//                                 <th className="text-end">
//                                     {formatToIndianRupee(TotalAmount)}
//                                     {/* parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.igst)) : formatToIndianRupee(parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.cgst) + parseFloat((each.basicAmount / 100) * each.sgst))} */}
//                                 </th>
//                             </tr>
//                         </tbody>
//                     </Table>

//                     <div className="invoice-preview-total-con">
//                         <div className="invoice-preview-total-con-left">
//                             <span>
//                                 <b>Total Invoice Amount In Words ({formatCurrencyBasedOnRegion()}) : </b>
//                             </span>
//                             <p >{totalAmountInWords}
//                             </p>
//                         </div>
//                         <div className="invoice-preview-total d-flex">
//                             <p className="invoice-preview-total-key" >Total : </p>
//                             {/* <span className="diagonal-line"></span> */}
//                             {/* <span></span> */}

//                         </div><p className="invoice-preview-total-value" >&nbsp;
//                             &nbsp;{formatToIndianRupee(TotalAmount)} {formatCurrencyBasedOnRegion()}</p>
//                     </div>
//                     {userNotesToggle && <div className="invoice-user-notes-div">
//                         <p className="invoice-user-notes">User Notes</p>
//                         <p>{userNotes}</p>
//                     </div>}
//                 </div>
//                 <div className="signature">
//                     <p></p>
//                     <p>sign here</p>
//                 </div>

//             </div>
//             {/* {!preview && !(invoiceStatus !== "rejected" && invoiceStatus!=='onhold' && invoiceStatus!== "draft") && (<div className="chat-feature">
//                 <div className="chatbox">
//                     <div className="chat-user">
//                         <p className="name">User-name</p>
//                         <p>13-02-24 15:25</p>
//                     </div>
//                     <p>
//                         Lorem ipsum dolor <span>@fin-man</span>, consectetur adipiscing elit. Maecenas vulputate,
//                         leo eu bibendum sollicitudin, risus velit posuere libero, vitae aliquet turpis
//                         sem eu massa. Proin vitae consequat ligula. Duis erat massa, imperdiet at turpis ac,
//                         luctus aliquet sapien. Nullam
//                     </p>
//                 </div>
//                 <div className="chatbox">
//                     <div className="chat-user">
//                         <p className="name">CEO</p>
//                         <p>13-02-24 15:25</p>
//                     </div>
//                     <p>
//                         Lorem ipsum dolor <span>@fin-man</span>, consectetur adipiscing elit. Maecenas vulputate,
//                         leo eu bibendum sollicitudin, risus velit posuere libero, vitae aliquet turpis
//                         sem eu massa. Proin vitae consequat ligula. Duis erat massa, imperdiet at turpis ac,
//                         luctus aliquet sapien. Nullam
//                     </p>
//                 </div>
//             </div>
//             )} */}
//             {/* to show payments and terms */}
//             {(paymentToggle && pdfDataForPayments && showPaymentDetails) && <PdfViewer base64Pdf={pdfDataForPayments} />}
//             {(termsToggle && pdfDataForTerms && showTermsDetails) && <PdfViewer base64Pdf={pdfDataForTerms} />}
//         </div>
//     </div>
//     {!preview && <div className="invoice-preview-buttons">
// {(invoiceStatus === "pdfgenerated" || invoiceStatus === "gstsubmitted" || invoiceStatus === "emailed")
//     &&
//     <Dropdown as={ButtonGroup}>
//         <Dropdown.Toggle id="dropdown-basic" className="custom-toggle">
//             Credit/Debit
//         </Dropdown.Toggle>

//         <Dropdown.Menu style={{ width: 'max-content' }}>
//             <Dropdown.Item onClick={() => {
//                 navigate('/CreditAndDebit', {
//                     state: {
//                         invoice_number: invoiceNo,
//                         facilityId: localStorage.getItem('selected_facility_id'),
//                         noteType: 'Credit'
//                     }
//                 });
//             }}>Credit Note</Dropdown.Item>
//             <Dropdown.Item onClick={() => {
//                 navigate('/CreditAndDebit', {
//                     state: {
//                         noteType: 'Debit',
//                         invoice_number: invoiceNo,
//                         facilityId: localStorage.getItem('selected_facility_id'),
//                     }
//                 });
//             }}>Debit Note</Dropdown.Item>
//         </Dropdown.Menu>
//     </Dropdown>

// }
// {downloadPath && <button onClick={() => {
//     handleDownload()
// }} disabled={downloadPath === '' || downloadPath === null} style={{ opacity: downloadPath ? '100%' : '50%' }}>Download</button>}
// {(invoiceStatus === "approved") && <button onClick={() => {
//     submitToGSTPortal(invoiceNo)
// }} >Submit to GST</button>}
// {(invoiceStatus === "pdfgenerated" && downloadPath) && (
//     <button
//         onClick={() => {
//             setAlertShow(true);
//             setAlertType('question');
//             setAlertMessage('Confirmation');
//             setAlertValue('Do you want to send the invoice to the customer?');
//             setAlertButtons([
//                 {
//                     name: 'Cancel',
//                     action: () => setAlertShow(false),
//                     variant: 'secondary'
//                 },
//                 {
//                     name: 'Proceed',
//                     action: () => {
//                         setAlertShow(false);
//                         sendToCustomer(invoiceNo);
//                     },
//                     variant: 'primary'
//                 }
//             ]);
//         }}
//     >
//         Send to Customer
//     </button>
// )}
// {(invoiceStatus === "gstsubmitted") && <button onClick={() => {
//     handleGeneratePdf()
// }}  >Generate PDF</button>}
// {(invoiceStatus === "draft" || invoiceStatus === "onhold" || invoiceStatus === "rejected") && <button onClick={() => {
//     handleEditMiscInvoice()
//     setApprovalType('miscellaneous')
// }}
// // disabled
// // style={{ opacity: '50%' }}
// >Edit Misc Invoice</button>}
// <button onClick={() => { setCurrentPage(1); setPreview(false); backFunction(); backPagination() }}> Back</button>
// {(invoiceStatus === "draft" || invoiceStatus === "onhold" || invoiceStatus === "approved") && <button onClick={() => {
//     handleReject()
//     setApprovalType('miscellaneous')
// }} >Reject</button>}
// {(invoiceStatus === "draft" || invoiceStatus === "rejected" || invoiceStatus === "approved") && <button onClick={() => {
//     handleHold()
//     setApprovalType('miscellaneous')
// }} >Hold</button>}
// {!(invoiceStatus !== "rejected" && invoiceStatus !== 'onhold' && invoiceStatus !== "draft") && <button
//     onClick={() => {
//         editInvoice()
//         setApprovalType('miscellaneous')
//     }
//     }
//     style={{ opacity: checkSendForApprovalValidation() ? '100%' : '50%' }} disabled={!checkSendForApprovalValidation()}>Approve</button>}

//     </div>}
//     {preview && <div className="invoice-preview-buttons">
//         <button onClick={() => setPreview(false)}> Back</button>
//     </div>}
// </div>
// }
{/* other service invoices */ }
// {currentPage === 8 && <div className="invoice_preview_container">

//     <div className="invoice-preview-con">
//         {/* <div className="invoice-preview-scrollable" style={{ margin: preview || (invoiceStatus !== "rejected" && invoiceStatus!=='onhold' && invoiceStatus!== "draft") ? 'auto' : '' }}> */}
//         <div className="invoice-preview-scrollable" style={{ margin: 'auto' }}>
//             <div className="invoice-preview-card">
//                 <div className="invoice-preview-card-details">
//                     {companyLogo && <div className="invoice-logo-placeholder">
//                         <div>
//                             <img style={{ width: '15rem', height: '5rem' }} src={companyLogo} alt="company logo" />
//                         </div>
//                     </div>}
//                     <div className="d-flex justify-content-between w-100">
//                         <div className="invoice-header-address">
//                             <h5
//                                 className="invoice-header-title"
//                                 style={{
//                                     fontSize: `${Math.max(40 - (companyName?.length ? companyName?.length * 0.3 : 1), 20)}px`
//                                 }}
//                             >
//                                 {companyName?.toUpperCase()}

//                             </h5>
//                             <p style={{
//                                 textAlign: 'center'
//                             }}><span ><b>Reg.Office:</b> {companyAddress}</span></p>
//                         </div>
//                         {
//                             QrCode?.length > 0 ?
//                                 <QRCode style={{ marginTop: '-70px' }} value={QrCode} size={170} />
//                                 :
//                                 <div className="invoice-bar-code">
//                                     {invoiceStatus === "rejected" ? (
//                                         <p className="rejected-text">Rejected</p>
//                                     ) : (
//                                         <p className="qr-code-text">QR Code</p>
//                                     )}
//                                 </div>
//                         }

//                     </div>
//                     <h5 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>Tax Invoice</h5>
//                     <h6 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>({serviceNameInInvoice})</h6>
//                     <div className="invoice-preview-inner-card-div">
//                         <div className="invoice-preview-inner-card">
//                             <div style={{ width: '100%' }}>
//                                 <p>
//                                     <b style={{ fontSize: "18px" }}>Buyer </b>
//                                     <br /> <b>{customerName}</b><br />
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>Billed To</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerAddress}</span>
//                                     </div>
//                                     {toggleShippingAddress && <div className="invoice-left-data">
//                                         <span className="key"><b>Shipped To</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value">  {shippingAddress}</span>
//                                     </div>}
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>State Code</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerStateCode}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>GSTIN</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerGSTIN}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>PAN</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerPAN}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>CIN</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerCIN}</span>
//                                     </div>
//                                     <div className="invoice-left-data">
//                                         <span className="key"><b>Place Of Supply</b></span>
//                                         <span style={{ marginRight: '3px' }}>:</span>
//                                         <span className="value"> {customerPlaceOfSupply}</span>
//                                     </div>
//                                 </p>
//                             </div>
//                         </div>
//                         <div className="invoice-address-right">
//                             <div >
//                                 <br />
//                                 <p> <b>Contract No   </b> </p>
//                                 <p><b>Invoice No</b> </p>
//                                 <p><b>State</b></p>
//                                 <p><b>State Code</b> </p>
//                                 <p><b>GSTIN</b></p>
//                                 <p><b>PAN</b></p>
//                                 <p><b>CIN</b></p>
//                                 <br />
//                                 <p><b>Invoice Date</b></p>
//                                 <p><b>Due Date</b></p>

//                             </div>
//                             <div style={{ marginLeft: "20px" }}>
//                                 <br />
//                                 <p>: {contractNo}</p>
//                                 <p>: {invoiceNo}</p>
//                                 <p>: {parnterState}</p>
//                                 <p>: {partnerStateCode}</p>
//                                 <p>: {companyGST}</p>
//                                 <p>: {partnerPAN}</p>
//                                 <p>: {companyCIN}</p>

//                                 <br />
//                                 <p>: {ackDate}</p>
//                                 <p>: {partnerDueDate}</p>
//                             </div>
//                         </div>
//                     </div>

//                 </div>
//                 <div className="invoice-preview-card-details-bottom">
//                     <div className="invoice-preview-inner-card-2">
//                         <p><span><b>IRN :</b> </span>{IRN}<br />
//                         </p>
//                     </div>
//                 </div>

//                 <div className="invoice-preview-table-container">
//                     <Table className="invoice-preview-table">
//                         <thead>
//                             <tr>
//                                 <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
//                                 <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
//                                 <th colSpan={2}><b>Bill Period </b></th>
//                                 {showComputationDetails && <th colSpan={1}><b>Total Area</b></th>}
//                                 {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
//                                 <th colSpan={1}><b>Basic Amount</b></th>
//                                 {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
//                                 {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
//                                 {igstToggle && <th colSpan={2}><b>IGST</b></th>}
//                                 <th colSpan={1}><b>GROSS</b></th>
//                             </tr>
//                             <tr>

//                                 <th>From</th>
//                                 <th>To</th>
//                                 {showComputationDetails && <th>Sq. ft</th>}
//                                 {showComputationDetails && <th> ({formatCurrencyBasedOnRegion()} / Sq. ft)</th>}
//                                 <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
//                                 {!igstToggle && <th>Rate <br /> (%)</th>}
//                                 {!igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
//                                 {!igstToggle && <th>Rate <br />(%)</th>}
//                                 {!igstToggle && <th>Amount<br /> ({formatCurrencyBasedOnRegion()})</th>}
//                                 {igstToggle && <th>Rate <br />(%)</th>}
//                                 {igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
//                                 <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
//                             </tr>
//                         </thead>
//                         <tbody >
//                             {invoiceDetails?.map((item, index) => {
//                                 return (
//                                     <tr key={index}>
//                                         <th className="text-start">{item?.service_name_in_invoice?.toUpperCase()},<br />
//                                             {item?.service_identifier}
//                                         </th>
//                                         <th className="text-start">{item?.hsn}</th>
//                                         <th style={{ textAlign: 'end' }}>{(formatDateBasedOnValue(formatDateView(item.from_date)))}</th>
//                                         <th style={{ textAlign: 'end' }}>
//                                             <div>
//                                                 {formatDateBasedOnValue(formatDateView(item.to_date))}
//                                             </div>
//                                         </th>
//                                         {showComputationDetails && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.consumption)}</th>}
//                                         {showComputationDetails && <th style={{ textAlign: 'end' }}><div>
//                                             {formatToIndianRupee(item.rate_per_unit)}
//                                         </div></th>}
//                                         <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.net_amount)}</th>

//                                         {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst_rate)}</th>}
//                                         {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst)}</th>}
//                                         {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst_rate)}</th>}
//                                         {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst)}</th>}
//                                         {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst_rate)}</th>}
//                                         {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst)}</th>}
//                                         <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.gross_amount)}</th>
//                                     </tr>
//                                 )
//                             })
//                             }
//                             {/* Grand Total */}
//                             <tr >
//                                 {/* service description */}
//                                 <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
//                                     Total
//                                 </th>
//                                 {/* sac/hsn */}
//                                 <th className="text-start">
//                                 </th>
//                                 <th className="text-start">
//                                 </th>
//                                 <th className="text-start">
//                                 </th>
//                                 <th className="text-start">
//                                 </th>
//                                 <th className="text-start">
//                                 </th>
//                                 {/* basic amount */}
//                                 <th className="text-end">
//                                     {formatToIndianRupee(basicAmount)}
//                                 </th>
//                                 {/* sgst rate*/}
//                                 {!igstToggle && <th>

//                                 </th>}
//                                 {/* sgst amount*/}
//                                 {!igstToggle && <th className="text-end">
//                                     {formatToIndianRupee(totalSgst)}
//                                 </th>}
//                                 {/* cgst rate*/}
//                                 {!igstToggle && <th>

//                                 </th>}
//                                 {/* cgst amount*/}
//                                 {!igstToggle && <th className="text-end">
//                                     {formatToIndianRupee(totalCgst)}
//                                 </th>}
//                                 {/* igst rate*/}
//                                 {igstToggle && <th>

//                                 </th>}
//                                 {/* igst amount*/}
//                                 {igstToggle && <th className="text-end">{formatToIndianRupee(totalIgst)}</th>}
//                                 {/* gross amount */}
//                                 <th className="text-end">
//                                     {formatToIndianRupee(TotalAmount)}
//                                     {/* parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.igst)) : formatToIndianRupee(parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.cgst) + parseFloat((each.basicAmount / 100) * each.sgst))} */}
//                                 </th>
//                             </tr>
//                         </tbody>
//                     </Table>
//                     <div className="invoice-preview-total-con">
//                         <div className="invoice-preview-total-con-left">
//                             <span>
//                                 <b>Total Invoice Amount In Words ({formatCurrencyBasedOnRegion()}) : </b>
//                             </span>
//                             <p >{totalAmountInWords}
//                             </p>
//                         </div>
//                         <div className="invoice-preview-total d-flex">
//                             <p className="invoice-preview-total-key" >Total : </p>
//                             {/* <span className="diagonal-line"></span> */}
//                             {/* <span></span> */}
//                             <p className="invoice-preview-total-value" >&nbsp;
//                                 &nbsp;{formatToIndianRupee(TotalAmount)} {formatCurrencyBasedOnRegion()}</p>
//                         </div>
//                     </div>
//                     {userNotesToggle && <div className="invoice-user-notes-div">
//                         <p className="invoice-user-notes">User Notes</p>
//                         <p>{userNotes}</p>
//                     </div>}
//                 </div>
//                 <div className="signature">
//                     <p></p>
//                     <p>sign here</p>
//                 </div>

//             </div>
//             {/* {!preview && !(invoiceStatus !== "rejected" && invoiceStatus!=='onhold' && invoiceStatus!== "draft") && (<div className="chat-feature">
//                 <div className="chatbox">
//                     <div className="chat-user">
//                         <p className="name">User-name</p>
//                         <p>13-02-24 15:25</p>
//                     </div>
//                     <p>
//                         Lorem ipsum dolor <span>@fin-man</span>, consectetur adipiscing elit. Maecenas vulputate,
//                         leo eu bibendum sollicitudin, risus velit posuere libero, vitae aliquet turpis
//                         sem eu massa. Proin vitae consequat ligula. Duis erat massa, imperdiet at turpis ac,
//                         luctus aliquet sapien. Nullam
//                     </p>
//                 </div>
//                 <div className="chatbox">
//                     <div className="chat-user">
//                         <p className="name">CEO</p>
//                         <p>13-02-24 15:25</p>
//                     </div>
//                     <p>
//                         Lorem ipsum dolor <span>@fin-man</span>, consectetur adipiscing elit. Maecenas vulputate,
//                         leo eu bibendum sollicitudin, risus velit posuere libero, vitae aliquet turpis
//                         sem eu massa. Proin vitae consequat ligula. Duis erat massa, imperdiet at turpis ac,
//                         luctus aliquet sapien. Nullam
//                     </p>
//                 </div>
//             </div>
//             )} */}
//             {/* to show payments and terms */}
//             {(paymentToggle && pdfDataForPayments && showPaymentDetails) && <PdfViewer base64Pdf={pdfDataForPayments} />}
//             {(termsToggle && pdfDataForTerms && showTermsDetails) && <PdfViewer base64Pdf={pdfDataForTerms} />}
//         </div>
//     </div>
//     {!preview && <div className="invoice-preview-buttons">
//         {(invoiceStatus === "pdfgenerated" || invoiceStatus === "gstsubmitted" || invoiceStatus === "emailed")
//             &&
//             <Dropdown as={ButtonGroup}>
//                 <Dropdown.Toggle id="dropdown-basic" className="custom-toggle">
//                     Credit/Debit
//                 </Dropdown.Toggle>

//                 <Dropdown.Menu style={{ width: 'max-content' }}>
//                     <Dropdown.Item onClick={() => {
//                         navigate('/CreditAndDebit', {
//                             state: {
//                                 invoice_number: invoiceNo,
//                                 facilityId: localStorage.getItem('selected_facility_id'),
//                                 noteType: 'Credit'
//                             }
//                         });
//                     }}>Credit Note</Dropdown.Item>
//                     <Dropdown.Item onClick={() => {
//                         navigate('/CreditAndDebit', {
//                             state: {
//                                 noteType: 'Debit',
//                                 invoice_number: invoiceNo,
//                                 facilityId: localStorage.getItem('selected_facility_id'),
//                             }
//                         });
//                     }}>Debit Note</Dropdown.Item>
//                 </Dropdown.Menu>
//             </Dropdown>

//         }
//         {downloadPath && <button onClick={() => {
//             handleDownload()
//         }} disabled={downloadPath === '' || downloadPath === null} style={{ opacity: downloadPath ? '100%' : '50%' }}>Download</button>}
//         {(invoiceStatus === "draft" || invoiceStatus === "onhold" || invoiceStatus === "rejected") && <button onClick={() => {
//             handleRegenerate()
//             setApprovalType('slf')
//         }} >Regenerate</button>}
//         <button onClick={() => { setCurrentPage(1); setPreview(false); backFunction(); backPagination() }}> Back</button>
//         {(invoiceStatus === "draft" || invoiceStatus === "onhold" || invoiceStatus === "approved") && <button onClick={() => {
//             handleReject()
//             setApprovalType('slf')
//         }} >Reject</button>}
//         {(invoiceStatus === "draft" || invoiceStatus === "rejected" || invoiceStatus === "approved") && <button onClick={() => {
//             handleHold()
//             setApprovalType('slf')
//         }} >Hold</button>}
//         {!(invoiceStatus !== "rejected" && invoiceStatus !== 'onhold' && invoiceStatus !== "draft") && <button
//             onClick={() => {
//                 editInvoice()
//                 setApprovalType('slf')
//             }
//             }
//             style={{ opacity: checkSendForApprovalValidation() ? '100%' : '50%' }} disabled={!checkSendForApprovalValidation()}>Approve</button>}

//     </div>}
//     {preview && <div className="invoice-preview-buttons">
//         <button onClick={() => setPreview(false)}> Back</button>
//     </div>}

// </div>}